import { setupRuntime, setupBridge } from '@alipay/smallfish-bridge-core';

function toObject(val) {
    if (val === null || val === undefined) {
        throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
var assign = Object.assign ||
    function (target, source) {
        var from;
        var to = toObject(target);
        for (var s = 1; s < arguments.length; s++) {
            from = Object(arguments[s]);
            for (var key in from) {
                if (hasOwnProperty.call(from, key)) {
                    to[key] = from[key];
                }
            }
        }
        return to;
    };

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var FunctionApply = /*#__PURE__*/ Function.prototype.apply.call.bind(Function.prototype.apply);
var FunctionBind =  Function.prototype.bind;
function functionBind(fn) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return FunctionApply(FunctionBind, fn, args);
}
function methodCall(fn, thisContext) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (typeof fn === 'function') {
        if (!FunctionApply) {
            FunctionApply = Function.prototype.apply.call.bind(Function.prototype.apply);
        }
        return FunctionApply(fn, thisContext, args);
    }
    else {
        // 说明是普通对象 .call 被错误替换，改回来
        return fn.call.apply(fn, __spreadArray([thisContext], args, false));
    }
}
function methodApply(fn, thisContext, args) {
    if (typeof fn === 'function') {
        if (!FunctionApply) {
            FunctionApply = Function.prototype.apply.call.bind(Function.prototype.apply);
        }
        return FunctionApply(fn, thisContext, args);
    }
    else {
        // 说明是普通对象 .apply 被错误替换，改回来
        return fn.apply(thisContext, args);
    }
}

var stringifyJSON =  JSON.stringify;
var parseJSON =  JSON.parse;

var encodeUriComponent =  encodeURIComponent;

function strictUriEncode (str) {
    return encodeUriComponent(str).replace(/[!'()*]/g, function (c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}

function encoderForArrayFormat(opts) {
    switch (opts.arrayFormat) {
        case 'index':
            return function (key, value, index) {
                return value === null
                    ? [encode$1(key, opts), '[', index, ']'].join('')
                    : [encode$1(key, opts), '[', encode$1(index, opts), ']=', encode$1(value, opts)].join('');
            };
        case 'bracket':
            return function (key, value) {
                return value === null ? encode$1(key, opts) : [encode$1(key, opts), '[]=', encode$1(value, opts)].join('');
            };
        default:
            return function (key, value) {
                return value === null ? encode$1(key, opts) : [encode$1(key, opts), '=', encode$1(value, opts)].join('');
            };
    }
}
function encode$1(value, opts) {
    if (opts.encode) {
        return opts.strict ? strictUriEncode(value) : encodeUriComponent(value);
    }
    return value;
}
function stringify(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none',
    };
    opts = assign(defaults, opts);
    var formatter = encoderForArrayFormat(opts);
    return obj
        ? Object.keys(obj)
            .sort()
            .map(function (key) {
            var val = obj[key];
            if (val === undefined) {
                return '';
            }
            if (val === null) {
                return encode$1(key, opts);
            }
            if (Array.isArray(val)) {
                var result_1 = [];
                val.slice().forEach(function (val2) {
                    if (val2 === undefined) {
                        return;
                    }
                    result_1.push(formatter(key, val2, result_1.length));
                });
                return result_1.join('&');
            }
            return encode$1(key, opts) + '=' + encode$1(val, opts);
        })
            .filter(function (x) {
            return x.length > 0;
        })
            .join('&')
        : '';
}

/**
 * @namespace @alipay/appx
 * @copyright @chengyu
 */
function objectKeys$1(obj) {
    if (obj && typeof obj === 'object') {
        return Object.keys(obj);
    }
    return [];
}

function toString(obj) {
    if (obj !== null && typeof obj === 'object') {
        if (typeof obj.toString === 'function') {
            return String(obj);
        }
        else {
            return '';
        }
    }
    return String(obj);
}
function escapeLogParams(params, skipUndefinedValue) {
    if (!params) {
        return '';
    }
    if (typeof params === 'string') {
        return params;
    }
    return objectKeys$1(params)
        .filter(function (key) {
        if (params[key] === undefined && skipUndefinedValue) {
            return false;
        }
        else {
            return true;
        }
    })
        .map(function (key) {
        var escaped = "".concat(key, "=");
        escaped += toString(params[key]).replace(/,/g, ';').replace(/\^/g, '@').replace(/\=/g, '~');
        return escaped;
    })
        .join('^');
}

function getWeakMapPolyfillConstructor() {
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var defineProperty = function (object, name, value) {
        if (Object.defineProperty) {
            Object.defineProperty(object, name, {
                configurable: true,
                value: value,
                writable: true,
            });
        }
        else {
            object[name] = value;
        }
    };
    function isObject(x) {
        return Object(x) === x;
    }
    // ECMA-262 23.3 WeakMap Objects
    function WeakMap() {
        if (this === void 0) {
            throw new TypeError("Constructor WeakMap requires 'new'");
        }
        defineProperty(this, '_id', genId('_WeakMap'));
        // ECMA-262 23.3.1.1 WeakMap([iterable])
        if (arguments.length > 0) {
            // Currently, WeakMap `iterable` argument is not supported
            throw new TypeError('WeakMap iterable is not supported');
        }
    }
    // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
    defineProperty(WeakMap.prototype, 'delete', function (key) {
        checkInstance(this, 'delete');
        if (!isObject(key)) {
            return false;
        }
        var entry = key[this._id];
        if (entry && entry[0] === key) {
            delete key[this._id];
            return true;
        }
        return false;
    });
    // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
    defineProperty(WeakMap.prototype, 'get', function (key) {
        checkInstance(this, 'get');
        if (!isObject(key)) {
            return void 0;
        }
        var entry = key[this._id];
        if (entry && entry[0] === key) {
            return entry[1];
        }
        return void 0;
    });
    // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
    defineProperty(WeakMap.prototype, 'has', function (key) {
        checkInstance(this, 'has');
        if (!isObject(key)) {
            return false;
        }
        var entry = key[this._id];
        if (entry && entry[0] === key) {
            return true;
        }
        return false;
    });
    // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
    defineProperty(WeakMap.prototype, 'set', function (key, value) {
        checkInstance(this, 'set');
        if (!isObject(key)) {
            throw new TypeError('Invalid value used as weak map key');
        }
        var entry = key[this._id];
        if (entry && entry[0] === key) {
            entry[1] = value;
            return this;
        }
        defineProperty(key, this._id, [key, value]);
        return this;
    });
    function checkInstance(x, methodName) {
        if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
            throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
        }
    }
    function genId(prefix) {
        return prefix + '_' + rand() + '.' + rand();
    }
    function rand() {
        return Math.random().toString().substring(2);
    }
    defineProperty(WeakMap, '_polyfill', true);
    return WeakMap;
}

var WeakMapKlass;
function getWeakMapConstructorMayBePolyfill() {
    var hasWeakMap = typeof WeakMap !== 'undefined';
    if (hasWeakMap) {
        WeakMapKlass = WeakMap;
    }
    else {
        WeakMapKlass = getWeakMapPolyfillConstructor();
    }
}
/**
 * weakMap 带 polyfill 的实现
 */
function createWeakMap() {
    if (!WeakMapKlass) {
        getWeakMapConstructorMayBePolyfill();
    }
    return new WeakMapKlass();
}

createWeakMap();

/* eslint-enable no-var */
/**
 * @description !!!! 编译扫描全局符号映射标识 DO NOT REMOVE LINES BEGIN
 */
if (typeof SECURITY_FUNCTION_CALL !== 'undefined') {
    SECURITY_FUNCTION_CALL = methodCall;
}
if (typeof SECURITY_FUNCTION_APPLY !== 'undefined') {
    SECURITY_FUNCTION_APPLY = methodApply;
}
/**
 * @description !!!! 编译扫描全局符号映射标识 DO NOT REMOVE LINES END
 */

var ELocalLogLevel;
(function (ELocalLogLevel) {
    ELocalLogLevel[ELocalLogLevel["Info"] = 0] = "Info";
    ELocalLogLevel[ELocalLogLevel["Warn"] = 1] = "Warn";
    ELocalLogLevel[ELocalLogLevel["Error"] = 2] = "Error";
})(ELocalLogLevel || (ELocalLogLevel = {}));
var ELocalLogType;
(function (ELocalLogType) {
    ELocalLogType["AppxLifecycle"] = "AppxLifecycle";
})(ELocalLogType || (ELocalLogType = {}));

var kAppxVersion = /* PURE */ undefined;
function isConsoleAvaliableToDeveloper(packageAndSceneType) {
    return ifIsMiniProgramEnv();
}
/**
 * 要让 Rollup + Terser 能把 IIFE Shake 掉的话
 * 下面的两个函数里就不能再有条件判断了
 * 比如如下代码是不能被 Shake 的
 * function thisFnWontBeShaken(then, or) {
 *   if (undefined) {
 *     then();
 *   }
 *   // 这里有了 if 条件判断，就不能被 Shake 了
 *   else if (or) {
 *     or();
 *   }
 * }
 */
/**
 * 不允许被作为「三元条件判断」以及「或表达式」等条件判断语句的一部分，
 * 否则无法被代码压缩。
 * 如果不同环境有不同执行，请使用 switchIsMiniProgramEnv
 */
// @ts-ignore
function ifIsMiniProgramEnv(then) {
}

var insideFeatureRuntimeConfig;
var insideFeatureRuntimeVersion;
var insideFeatureRuntimeClientName;
var insideFeatureRuntimePlatform;
/* eslint-enable no-var */
/**
 * @description !!!! 编译扫描全局符号映射标识 DO NOT REMOVE LINES BEGIN
 */
/**
 * @description 仅提供 version, platform 的解析能力，启动参数以及函数解析不可用
 */
var hasInsideFeature = (typeof HAS_INSIDE_FEATURE !== 'undefined' && HAS_INSIDE_FEATURE) || hasInsideFeatureRuntimeImplemention;
/**
 * @description !!!! 编译扫描全局符号映射标识 DO NOT REMOVE LINES END
 */
function hasInsideSupport(value, startupParams) {
    if (value === false || value === true) {
        return value;
    }
    if (typeof value === 'number') {
        return insideFeatureRuntimeVersion >= value;
    }
    // ios && 10.1.80 后续编译期搞定
    // 如果运行时没注入启动参数，则默认不可使用启动参数
    if (typeof value === 'function') {
        return value({
            clientName: insideFeatureRuntimeClientName,
            platform: insideFeatureRuntimePlatform,
            startupParams: (startupParams || {}),
            version: insideFeatureRuntimeVersion,
        });
    }
    return false;
}
function hasInsideFeatureRuntimeImplemention(feature) {
    return hasInsideSupport(insideFeatureRuntimeConfig );
}

function isAppxDomain4Empty(appxDomain) {
    return appxDomain && appxDomain.type === "empty" /* EBridgeAppxDomainType.empty */;
}
function isAppxDomain4App(appxDomain) {
    return appxDomain && appxDomain.type === "app" /* EBridgeAppxDomainType.app */;
}
function isAppxDomain4Extension(appxDomain) {
    return appxDomain && appxDomain.type === "extension" /* EBridgeAppxDomainType.extension */;
}
function isAppxDomain4OpenCapability(appxDomain) {
    return appxDomain && appxDomain.type === "openCapability" /* EBridgeAppxDomainType.openCapability */;
}

var zephyrHasInsideFeatureRuntimeImplemention = function () { return false; };
var zephyrIsInsideUnsupportElementImpl = function () { return false; };
/* eslint-enable no-var */

/**
 * @description !!!! 编译扫描全局符号映射标识 DO NOT REMOVE LINES BEGIN
 */
/**
 * @description 仅提供 version, platform 的解析能力，启动参数以及函数解析不可用
 */
(typeof ZEPHYR_HAS_INSIDE_FEATURE !== 'undefined' && ZEPHYR_HAS_INSIDE_FEATURE) ||
    zephyrHasInsideFeatureRuntimeImplemention;
/**
 * @description !!!! 编译扫描全局符号映射标识 DO NOT REMOVE LINES END
 */

(typeof ZEPHYR_IS_INSIDE_UNSUPPORT_ELEMENT !== 'undefined' && ZEPHYR_IS_INSIDE_UNSUPPORT_ELEMENT) ||
    zephyrIsInsideUnsupportElementImpl;

function extractBridgeCallback(success, fail, complete, treatErrorZeroAsSuccess) {
    if (treatErrorZeroAsSuccess === void 0) { treatErrorZeroAsSuccess = false; }
    if (success || fail || complete) {
        return functionBind(handleCallbackUnion, null, success, fail, complete, treatErrorZeroAsSuccess);
    }
}
function handleCallbackUnion(success, fail, complete, treatErrorZeroAsSuccess, finalResult) {
    var hasError = false;
    if (treatErrorZeroAsSuccess) {
        finalResult = normalizeErrorCode(finalResult);
        hasError = !!finalResult.error;
    }
    else {
        if (typeof finalResult === 'object') {
            hasError = 'error' in finalResult || 'errorMessage' in finalResult;
        }
    }
    if (hasError && typeof fail === 'function') {
        fail(finalResult);
    }
    if (!hasError && typeof success === 'function') {
        success(finalResult);
    }
    if (typeof complete === 'function') {
        complete(finalResult);
    }
}
function normalizeErrorCode(finalResult) {
    if (typeof finalResult.error === 'string') {
        finalResult.error = parseInt(finalResult.error, 10);
    }
    if (finalResult.error === 0) {
        delete finalResult.error;
        delete finalResult.errorMessage;
    }
    return finalResult;
}

function canUseProxy() {
    /**
     * 一些 util 库会通过 {}.toString.call(value) !== '[object Object]' 判断是否是 plain object
     * iOS 10.3+  ({}).toString.call(proxy) === '[object Object]'
     * iOS [10.0,10,2]  ({}).toString.call(proxy) === [object ProxyObject]，因此在此版本上禁用 Proxy
     */
    try {
        return typeof Proxy === 'function' && Object.prototype.toString.call(new Proxy({}, {})) === '[object Object]';
    }
    catch (_a) {
        return false;
    }
}

function isAppSupportCustomizeTabBar(tabBar, startupParams) {
    var isCustomizeTabBar = tabBar && tabBar.customize;
    return isCustomizeTabBar && startupParams && startupParams.hideDefaultTabBar;
}

/* eslint-enable no-var */
var hasNativeLog = typeof nativeLog !== 'undefined' && typeof mqEnvironment !== 'undefined';
function error(str) {
    if (hasNativeLog) {
        nativeLog(str, Date.now());
    }
    else {
        console.error(str, Date.now()); // eslint-disable-line
    }
}

/**
 * @namespace @alipay/appx
 * @copyright @chengyu
 */
function objectKeys(obj) {
    if (obj && typeof obj === 'object') {
        return Object.keys(obj);
    }
    return [];
}

/**
 * 拆分类型键名里真正的 key 和对应的 type
 * @method _separateTypeKey
 * @param  {String}         key 带类型标识的键名
 * @return {Object}             返回键名和类型标识两个字段，
 *                              如{k: 'content', t: '%s'}
 */
function _separateTypeKey(key) {
    var matches = (key || '').match(/(\w+)(%\w)$/i);
    var tk = {
        k: key,
    };
    if (matches) {
        tk.k = matches[1];
        tk.t = matches[2];
    }
    return tk;
}
/**
 * 超级字符串转换
 */
function __superToString(content) {
    var str = content;
    if (typeof content === 'object') {
        str = stringifyJSON(content);
    }
    else {
        str = content + '';
    }
    return str;
}
/**
 * 16进制颜色转成10进制数字
 * @method __h2dColor
 * @param  {String}   hex 16进制颜色字符串
 * @return {Number}       10进制数字
 */
function __h2dColor(hex) {
    var dec = '' + hex;
    // 如果加了#号，去掉
    if (dec.indexOf('#') === 0) {
        dec = dec.substr(1);
    }
    // 如果是3位简写，补全成6位
    if (dec.length === 3) {
        dec = dec.replace(/(.)/g, '$1$1');
    }
    var ret = parseInt(dec, 16);
    if (isNaN(ret)) {
        error("".concat(hex, " is invalid hex color."));
    }
    return ret;
}
/**
 * 移除 base64 数据头，native 接口不需要传入头部
 * @method __removeBase64Head
 * @param  {String}           base64 有头数据
 * @return {String}                  无头数据
 */
function __removeBase64Head(base64) {
    if (typeof base64 === 'string') {
        base64 = base64.replace(/^data:(\/|\w|\-|\.)+;base64,/i, '');
    }
    return base64;
}
function toType(type, value) {
    if (type === "%s" /* EToType.String */) {
        value = __superToString(value);
    }
    else if (type === "%c" /* EToType.Color */) {
        value = __h2dColor(value);
    }
    else if (type === "%b" /* EToType.Base64 */) {
        value = __removeBase64Head(value);
    }
    else if (type === "%d" /* EToType.Decimal */) {
        value = parseInt(value, 10);
    }
    else if (type === "%f" /* EToType.Float */) {
        value = parseFloat(value);
    }
    return value;
}
function mapping(tObj, map, sObj) {
    var typeKey;
    sObj = sObj || {};
    objectKeys(map).forEach(function (sKey) {
        var tKey = map[sKey];
        typeKey = _separateTypeKey(tKey);
        // 目标 key
        tKey = typeKey.k;
        // 映射条件，否则不赋值，避免添加 value 为 undefined 的 key
        if (tKey !== undefined && // 目标 key 定义过
            (sKey in tObj || sKey in sObj) && // 源数据至少有一个有效
            tObj[tKey] === undefined // 目标数据空缺待赋值
        ) {
            // sKey 既可以是 sObj 的，也可以是 tObj 自己的，但sObj 优先级高于原始 tObj
            // 即 sObj[sKey]的值 会覆盖 tObj[sKey]的值
            // 并且要根据 type 占位符做相应类型转换
            tObj[tKey] = toType(typeKey.t, sObj[sKey] === undefined ? tObj[sKey] : sObj[sKey]);
            // 删除原始 tObj 中的 sKey，tKey 和 sKey 同名时不做删除
            if (tKey !== sKey) {
                delete tObj[sKey];
            }
        }
    });
    return tObj;
}
function toConstructorString(obj) {
    return Object.prototype.toString.call(obj);
}

/**
 *
 * @copyright af-appx
 */
/* eslint-disable no-bitwise */
/**
 * encode
 * @param str
 */
function encode(str) {
    var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var strValue = String(str);
    var result = '';
    var currentIndex = 0;
    var sum = 0;
    while (
    // currentIndex | 0 : 取整数
    strValue.charAt(0 | currentIndex) ||
        // eslint-disable-next-line
        ((encodings = '='), currentIndex % 1)) {
        currentIndex += 0.75; // 每次移动3/4个位置
        var currentCode = strValue.charCodeAt(currentIndex); // 获取code point
        if (currentCode > 255) {
            // 大于255无法处理
            throw new Error('"btoa" failed');
        }
        sum = (sum << 8) | currentCode; // 每次在上次的基础上左移8位再加上当前code point
        var encodeIndex = 63 & (sum >> (8 - (currentIndex % 1) * 8)); // 去除多余的位数，再去最后6位
        result += encodings.charAt(encodeIndex);
    }
    return result;
}
function decode(str) {
    var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var res = '';
    var strValue = String(str).replace(/=+$/, '');
    if (strValue.length % 4 === 1) {
        throw new Error('"atob" failed');
    }
    var o = 0;
    var r = 0;
    var i = 0;
    var currentIndex = 0;
    // eslint-disable-next-line
    while ((r = strValue.charAt(currentIndex))) {
        currentIndex = currentIndex + 1;
        r = encodings.indexOf(r);
        if (~r) {
            o = i % 4 ? 64 * o + r : r;
            if (i++ % 4) {
                res += String.fromCharCode(255 & (o >> ((-2 * i) & 6)));
            }
        }
    }
    return res;
}
function arrayBufferToBase64(buffer) {
    var result = '';
    var uintArray = new Uint8Array(buffer);
    var byteLength = uintArray.byteLength;
    for (var i = 0; i < byteLength; i++) {
        result += String.fromCharCode(uintArray[i]);
    }
    return encode(result);
}
function base64ToArrayBuffer(base64) {
    var str = decode(base64);
    var length = str.length;
    var uintArray = new Uint8Array(length);
    for (var i = 0; i < length; i++) {
        uintArray[i] = str.charCodeAt(i);
    }
    return uintArray.buffer;
}
function isArrayBuffer(data) {
    return toConstructorString(data) === '[object ArrayBuffer]' && data.byteLength !== undefined;
}

/**
 * 按屏幕高度判断是否为 iPhone X 系列
 * @method iphoneXSeriesIdentify
 * @param  {Number} screenHeight  屏幕高度
 * iphone xs max 414*896
 * iphone xs     375*812
 * iphone xr     414*896
 * iphone x      375*812
 * @return {boolean}       返回是否为 iPhone X 系列的布尔值
 */
function iphoneXSeriesIdentify(screenHeight) {
    return screenHeight === 812 || screenHeight === 896;
}

var showActionSheet$1 = {
    m: 'actionSheet',
    v: function (opt) {
        if (!opt.items) {
            return {
                error: '99',
                errorMessage: 'items is required!',
            };
        }
    },
    b: function (opt) {
        mapping(opt, {
            cancelButtonText: 'cancelBtn%s',
            items: 'btns',
        });
        // 把按钮字段转成字符串，非字符串会导致钱包闪退
        if (Array.isArray(opt.btns)) {
            var btns = opt.btns;
            opt.btns = [];
            btns.forEach(function (item) { return opt.btns.push(item + ''); });
        }
        // 把取消按钮字段转成字符串，非字符串会导致 actionSheet 全屏
        if (!opt.cancelBtn) {
            opt.cancelBtn = '取消';
        }
    },
    a: function (res, opt) {
        if (Array.isArray(opt.btns) && res.index === opt.btns.length) {
            res.index = -1;
        }
    },
};

var kMediaBusiness = 'apm-h5';
function handleResultSuccess(res, mappingError, successValue) {
    if (!('error' in res) && res.success === successValue) {
        res.error = mappingError;
    }
    delete res.success;
    return res;
}
var startRecord$1 = {
    m: 'startAudioRecord',
    b: function (opt) {
        var finalOpt = opt || {};
        mapping(finalOpt, {
            maxDuration: 'maxRecordTime%f',
            minDuration: 'minRecordTime%f',
        }, {
            maxDuration: opt.maxDuration || 60,
            minDuration: opt.minDuration || 1,
        });
        finalOpt.business = kMediaBusiness;
        return finalOpt;
    },
    a: function (res) {
        mapping(res, {
            // 不要改它们的顺序！！
            // 改了就崩了！！
            tempFilePath: 'apFilePath',
            identifier: 'apFilePath',
        });
    },
};
var stopRecord$1 = {
    m: 'stopAudioRecord',
};
var cancelRecord$1 = {
    m: 'cancelAudioRecord',
};
var playVoice$1 = {
    m: 'startPlayAudio',
    b: function (opt) {
        mapping(opt, {
            filePath: 'identifier',
        });
        opt.business = kMediaBusiness;
    },
    a: function (res) {
        /**
         * @description 客户端代码均表示不存在 identifier 反馈字段
         */
        mapping(res, {
            identifier: 'filePath',
        });
    },
};
var pauseVoice$1 = {
    m: 'pauseAudioPlay',
};
var resumeVoice$1 = {
    m: 'resumeAudioPlay',
};
var stopVoice$1 = {
    m: 'stopAudioPlay',
};
var playBackgroundAudio$1 = {
    b: function (opt) {
        mapping(opt, {
            url: 'audioDataUrl%s',
            title: 'audioName%s',
            singer: 'singerName%s',
            describe: 'audioDescribe%s',
            logo: 'audioLogoURL%s',
            cover: 'coverImgUrl%s',
        });
        opt.business = kMediaBusiness;
    },
    a: function (res) {
        mapping(res, {
            describe: 'errorMessage',
        });
        handleResultSuccess(res, 12, 0);
    },
};
var pauseBackgroundAudio$1 = {
    a: function (res) {
        mapping(res, {
            describe: 'errorMessage',
        });
        handleResultSuccess(res, 12, 0);
    },
};
var stopBackgroundAudio$1 = {
    a: function (res) {
        /**
         * @description 客户端代码均表示不存在 describe 字段
         */
        mapping(res, {
            describe: 'errorMessage',
        });
        handleResultSuccess(res, 12, 0);
    },
};
var seekBackgroundAudio$1 = {
    b: function (opt) {
        opt.business = kMediaBusiness;
        opt.position = toType('%f', opt.position);
    },
    a: function (res) {
        mapping(res, {
            describe: 'errorMessage',
        });
        handleResultSuccess(res, 12, 0);
    },
};

function transformAdvertisData(devices) {
    if (devices) {
        devices.forEach(function (val) {
            val.advertisData = val.manufacturerData;
        });
    }
}
var openBluetoothAdapter$1 = {};
var closeBluetoothAdapter$1 = {};
var getBluetoothAdapterState$1 = {};
var startBluetoothDevicesDiscovery$1 = {};
var stopBluetoothDevicesDiscovery$1 = {};
var getBluetoothDevices$1 = {
    a: function (res) {
        transformAdvertisData(res.devices);
    },
};
var getConnectedBluetoothDevices$1 = {
    a: function (res) {
        transformAdvertisData(res.devices);
    },
};
var connectBLEDevice$1 = {};
var disconnectBLEDevice$1 = {};
var writeBLECharacteristicValue$1 = {};
var readBLECharacteristicValue$1 = {};
var notifyBLECharacteristicValueChange$1 = {};
var getBLEDeviceServices$1 = {};
var getBLEDeviceCharacteristics$1 = {};
var onBLECharacteristicValueChange$1 = {
    // 真正的事件名，会把首字母自动转成小写，因此这里使用 map 可避免这个问题
    m: 'BLECharacteristicValueChange',
};
var offBLECharacteristicValueChange$1 = {
    m: 'BLECharacteristicValueChange',
};
var onBluetoothAdapterStateChange$1 = {};
var offBluetoothAdapterStateChange$1 = {};
var onBLEConnectionStateChanged$1 = {
    m: 'BLEConnectionStateChanged',
};
var offBLEConnectionStateChanged$1 = {
    m: 'BLEConnectionStateChanged',
};
var onBluetoothDeviceFound$1 = {
    a: function (res) {
        res.advertisData = res.manufacturerData;
    },
};
var offBluetoothDeviceFound$1 = {};
var startBeaconDiscovery$1 = {};
var stopBeaconDiscovery$1 = {};
var getBeacons$1 = {};
var onBeaconUpdate$1 = {
    m: 'beaconUpdate',
};
var offBeaconUpdate$1 = {
    m: 'beaconUpdate',
};
var onBeaconServiceChange$1 = {
    m: 'beaconServiceChange',
};
var offBeaconServiceChange$1 = {
    m: 'beaconServiceChange',
};
var openBLEPeripheral$1 = {};
var closeBLEPeripheral$1 = {};
var addPeripheralService$1 = {};
var removePeripheralService$1 = {};
var updateCharacteristic$1 = {};
var startBLEAdvertising$1 = {};
var stopBLEAdvertising$1 = {};
var onCharacteristicRead$1 = {};
var offCharacteristicRead$1 = {};
var onCharacteristicWrite$1 = {};
var offCharacteristicWrite$1 = {};
var onCharacteristicDidSubscribe$1 = {};
var offCharacteristicDidSubscribe$1 = {};
var onCharacteristicDidUnsubscribe$1 = {};
var offCharacteristicDidUnsubscribe$1 = {};

var alert$1 = {
    tapMark: function () {
        return this.runtime().getEnv().isPortalWorkerScene;
    },
    b: function (opt) {
        return mapping(opt, {
            buttonText: 'button%s',
            content: 'message%s',
        });
    },
};
var showLoading$1 = {
    b: function (opt) {
        return mapping(opt, {
            content: 'text%s', // 因为最后调用接口时真正入参是 text
        });
    },
    d: function (finalOption, resolve) {
        this.callScopedBridge('showLoading', finalOption, resolve, this.optionPageViewId);
    },
};
var hideLoading$1 = {
    d: function (finalOption, resolve) {
        this.callScopedBridge('hideLoading', finalOption, resolve, this.optionPageViewId);
    },
};
var multiLevelSelect$1 = {
    m: 'beehiveMultilevelSelect',
};
var prompt$1 = {
    b: function (opt) {
        opt.message = opt.message || '请输入内容';
        opt.okButtonText = opt.okButtonText || '确定';
        opt.cancelButtonText = opt.cancelButtonText || '取消';
        mapping(opt, {
            cancelButtonText: 'cancelButton%s',
            okButtonText: 'okButton%s',
        });
    },
};
var stopPullDownRefresh$1 = {
    d: function (_, resolve) {
        var viewId = this.optionPageViewId;
        this.callScopedBridge('restorePullToRefresh', { viewId: viewId }, undefined, viewId);
        resolve({});
    },
    m: 'restorePullToRefresh',
};
var setBackgroundColor$1 = {};
var setBackgroundTextStyle$1 = {};
var setBackButton$1 = {};
var removeBackgroundImage$1 = {};
var setCanPullDown$1 = {};
var startPullDownRefresh$1 = {};
var setTransparentTitle$1 = {};
var showAuthGuide$1 = {
    b: function (opt) {
        opt.bizType = 'AppletPG';
        opt.source = this.getEnvAppId();
    },
};
var optionsSelect$1 = {
    m: 'beehiveOptionsPicker',
};

var confirm$1 = {
    tapMark: function () {
        return this.runtime().getEnv().isPortalWorkerScene;
    },
    b: function (opt) {
        return mapping(opt, {
            cancelButtonText: 'cancelButton%s',
            confirmButtonText: 'okButton%s',
            content: 'message%s',
        });
    },
    a: function (res) {
        return mapping(res, {
            ok: 'confirm', // 更改之前返回值里的 ok 为 confirm
        });
    },
};

function endsWith(str, suffix) {
    return str && str.slice(0 - suffix.length) === suffix;
}
function commaCount(str) {
    var m = str.match(/:/g);
    if (!m) {
        return 0;
    }
    return m.length;
}
function removeSS(str) {
    return str.replace(/:\d+$/, '');
}
var datePicker$1 = {
    b: function (opt) {
        function addSS() {
            ['beginDate', 'minDate', 'maxDate'].forEach(function (f) {
                if (opt[f]) {
                    if (commaCount(opt[f]) === 1) {
                        opt[f] += ':00';
                    }
                }
            });
        }
        mapping(opt, {
            format: 'mode',
            currentDate: 'beginDate',
            startDate: 'minDate',
            endDate: 'maxDate',
        });
        switch (opt.mode) {
            case 'HH:mm:ss':
                opt.mode = 0;
                break;
            case 'HH:mm':
                opt.mode = 0;
                addSS();
                break;
            case 'yyyy-MM-dd':
                opt.mode = 1;
                break;
            case 'yyyy-MM-dd HH:mm:ss':
                opt.mode = 2;
                break;
            case 'yyyy-MM-dd HH:mm':
                opt.mode = 2;
                addSS();
                break;
            case 'yyyy-MM':
                opt.mode = 3;
                break;
            case 'yyyy':
                opt.mode = 4;
                break;
            default:
                opt.mode = 1;
        }
    },
    a: function (res, _opt, opt) {
        if (typeof res.date === 'string') {
            if (endsWith(opt.format, ':mm')) {
                if (commaCount(res.date) === 2) {
                    res.date = removeSS(res.date);
                }
            }
            // 返回格式为yyyy-MM-dd
            res.date = res.date.replace(/\//g, '-').trim();
        }
    },
};

var defaultInterval = 0.5;
var getNetworkType$1 = {
    a: function (res) {
        if (res.networkInfo) {
            res.networkType = res.networkInfo.toUpperCase();
        }
    },
};
var vibrate$1 = {};
var choosePhoneContact$1 = {
    m: 'contact',
};
var chooseAlipayContact$1 = {
    m: 'chooseContact',
    b: function (opt) {
        var multi = 'multi';
        var single = 'single';
        if (!opt.count) {
            opt.count = 1;
        }
        if (opt.count === 1) {
            opt.type = single;
        }
        else {
            opt.type = multi;
            if (opt.count <= 0 || opt.count > 10) {
                opt.multiMax = 10;
            }
            else {
                opt.multiMax = opt.count;
            }
        }
        delete opt.count;
    },
    a: function (res) {
        if (Array.isArray(res.contacts)) {
            res.contacts.forEach(function (contact) {
                mapping(contact, {
                    headImageUrl: 'avatar',
                    name: 'realName',
                });
                delete contact.from;
            });
        }
    },
};
var chooseContact$1 = {
    m: 'APSocialNebulaPlugin.selectContactJSAPI',
    b: function (opt) {
        mapping(opt, {
            chooseType: 'type',
            includeMe: 'withMe',
            multiChooseMax: 'multiMax',
            multiChooseMaxTips: 'multiMaxTips',
        });
        if (!opt.type) {
            opt.type = 'multi';
        }
        opt.model = 'friend';
        switch (opt.includeMobileContactMode) {
            case 'known':
                // 包含双向手机联系人
                opt.showKnownMobileContact = true;
                break;
            case 'all':
                // 包含所有手机联系人
                opt.showMobileContact = true;
                break;
        }
    },
    a: function (res) {
        if (res.contactsDicArray && res.contactsDicArray.length > 0) {
            for (var i = 0; i < res.contactsDicArray.length; ++i) {
                mapping(res.contactsDicArray[i], {
                    headUrl: 'avatar',
                    phoneString: 'mobile',
                    name: 'realName',
                    userID: 'userId',
                });
                delete res.contactsDicArray[i].account;
            }
        }
    },
};
var watchShake$1 = {};
var setClipboard$1 = {};
var getClipboard$1 = {};
var scan$1 = {
    b: function (opt) {
        var actionTypes = ['scanAndRpc', 'scan', 'scanAndRoute', 'route'];
        if (!opt.actionType) {
            opt.actionType = opt.needPath === true ? 'scanAndRpc' : 'scan';
        }
        if (actionTypes.indexOf(opt.actionType) < 0) {
            opt.actionType = 'scan';
        }
        opt.type = opt.type || 'qr';
        mapping(opt, {
            onlyFromCamera: 'hideAlbum',
        });
    },
    a: function (res) {
        // 没有 = charSet
        // 有 = path 10.1.32
        if (res.codeContent) {
            res.code = res.codeContent;
        }
        mapping(res, {
            codeContent: 'result',
            codeType: 'scanType',
        });
    },
};
var getServerTime$1 = {};
var getScreenBrightness$1 = {};
// const brightnessData = {
//   initialized: false,
//   changed: false,
//   origiBrightness: 0,
//   newBrightness: 0,
// };
// const initBrightness = () => {
//   if (brightnessData.initialized) {
//     return;
//   }
//   const foreground = () => {
//     if (brightnessData.changed) {
//       callBridge('setScreenBrightness', {
//         brightness: brightnessData.newBrightness,
//       });
//     }
//   };
//   const background = () => {
//     if (brightnessData.changed) {
//       callBridge('setScreenBrightness', {
//         brightness: brightnessData.origiBrightness,
//       });
//     }
//   };
//   EventHub.addListener('foreground', foreground);
//   EventHub.addListener('background', background);
//   callBridge('getScreenBrightness', {}, res => {
//     if (res.brightness) {
//       // 初始化
//       brightnessData.initialized = true;
//       brightnessData.origiBrightness = res.brightness;
//       brightnessData.newBrightness = res.brightness;
//     }
//   });
// };
var setScreenBrightness$1 = {};
// export const setScreenBrightness: IBridgeAPITypedInfo<MiniAPI.setScreenBrightness> = {
//   b(opt: any) {
//     if (typeof opt.brightness === 'number') {
//       initBrightness();
//     }
//   },
//   a(res: any, _opt: any, opt: any) {
//     if (!('error' in res)) {
//       brightnessData.changed = true;
//       brightnessData.newBrightness = opt.brightness;
//     }
//   },
// }
var setKeepScreenOn$1 = {
    b: function (opt) {
        opt.actionType = opt.keepScreenOn ? 'disable' : 'enable';
    },
    d: function (opt, resolve) {
        this.callDefaultBridge('setScreenAutolock', opt, resolve);
    },
};
// export const SDKVersion: IBridgeAPITypedInfo<MiniAPI.SDKVersion> = {}; // 暂时跳过，待续
var addPhoneContact$1 = {};
var onGyroscopeChange$1 = {
    start: function () {
        var _a;
        var extraInfo = this.runtime().getBridge().extraInfo;
        // 没主动执行过 my.startGyroscope
        if (!extraInfo["startGyroscopeExecuted" /* EBridgeExtraInfoKey.startGyroscopeExecuted */]) {
            this.callDefaultBridge('watchShake', (_a = {},
                _a["monitorGyroscope" /* EWatchShakeType.monitorGyroscope */] = true,
                _a.interval = defaultInterval,
                _a));
        }
    },
};
var offGyroscopeChange$1 = {
    end: function () {
        var _a;
        var extraInfo = this.runtime().getBridge().extraInfo;
        // 开发者执行了 my.startGyroscope，所以不能再依赖事件监听的end钩子
        if (!extraInfo["startGyroscopeExecuted" /* EBridgeExtraInfoKey.startGyroscopeExecuted */]) {
            this.callDefaultBridge('watchShake', (_a = {}, _a["monitorGyroscope" /* EWatchShakeType.monitorGyroscope */] = false, _a));
        }
    },
};
var onAccelerometerChange$1 = {
    start: function () {
        var _a;
        var extraInfo = this.runtime().getBridge().extraInfo;
        if (!extraInfo["startAccelerometerExecuted" /* EBridgeExtraInfoKey.startAccelerometerExecuted */]) {
            this.callDefaultBridge('watchShake', (_a = {},
                _a["monitorAccelerometer" /* EWatchShakeType.monitorAccelerometer */] = true,
                _a.interval = defaultInterval,
                _a));
        }
    },
    a: function (evt) {
        var res = {};
        mapping(res, {
            timestamp: 'timestamp%d',
            x: 'x',
            y: 'y',
            z: 'z',
        }, typeof evt.data === 'object' ? evt.data : evt);
        return res;
    },
};
var offAccelerometerChange$1 = {
    end: function () {
        var _a;
        var extraInfo = this.runtime().getBridge().extraInfo;
        if (!extraInfo["startAccelerometerExecuted" /* EBridgeExtraInfoKey.startAccelerometerExecuted */]) {
            this.callDefaultBridge('watchShake', (_a = {}, _a["monitorAccelerometer" /* EWatchShakeType.monitorAccelerometer */] = false, _a));
        }
    },
};
var onCompassChange$1 = {
    start: function () {
        var _a;
        var extraInfo = this.runtime().getBridge().extraInfo;
        if (!extraInfo["startCompassExecuted" /* EBridgeExtraInfoKey.startCompassExecuted */]) {
            this.callDefaultBridge('watchShake', (_a = {},
                _a["monitorCompass" /* EWatchShakeType.monitorCompass */] = true,
                _a.interval = defaultInterval,
                _a));
        }
    },
    a: function (evt) {
        var res = {};
        mapping(res, {
            direction: 'direction%d',
            timestamp: 'timestamp%d',
        }, typeof evt.data === 'object' ? evt.data : evt);
        return res;
    },
};
var offCompassChange$1 = {
    end: function () {
        var _a;
        var extraInfo = this.runtime().getBridge().extraInfo;
        if (!extraInfo["startCompassExecuted" /* EBridgeExtraInfoKey.startCompassExecuted */]) {
            this.callDefaultBridge('watchShake', (_a = {}, _a["monitorCompass" /* EWatchShakeType.monitorCompass */] = false, _a));
        }
    },
};
var rsa$1 = {};
var sendSMS$1 = {
    a: function (res) {
        if (res.status) {
            switch (res.status) {
                case 'Success':
                    res = {};
                    break;
                case 'Failed':
                    res.error = 21;
                    res.errorMessage = '发送失败';
                    break;
                case 'Canceled':
                    res.error = 22;
                    res.errorMessage = '用户取消发送';
                    break;
            }
            delete res.status;
        }
    },
};
var startWifi$1 = {};
var stopWifi$1 = {};
var getWifiList$1 = {};
var setWifiList$1 = {};
var getConnectedWifi$1 = {};
var vibrateLong$1 = {};
var vibrateShort$1 = {};
var getHCEState$1 = {};
var startHCE$1 = {};
var sendHCEMessage$1 = {};
var getBatteryInfo$1 = {
    m: 'getBatteryInfo',
};
var onDeviceMotionChange$1 = {
    start: function () {
        this.callDefaultBridge('startDeviceMotionListening', {
            interval: 'ui',
        });
    },
};
var offDeviceMotionChange$1 = {
    end: function () {
        this.callDefaultBridge('stopDeviceMotionListening');
    },
};
var getDeviceInfo$1 = {};
var getTitleColor$1 = {
    a: function (res) {
        if (res && res.color) {
            var color = res.color.toString(16);
            if (color.length === 8) {
                var alpha = color.slice(0, 2);
                var rgb = color.slice(2);
                color = rgb + alpha;
            }
            res.color = '#' + color;
        }
    },
};
var registerSSID$1 = {
    a: function (finalResult) {
        if (this.runtime().getEnv().isAndroid && finalResult && finalResult.error === 1) {
            finalResult.errorMessage = 'registerSSID is only avaliable on iOS platform';
        }
    },
};
var unregisterSSID$1 = {
    a: function (finalResult) {
        if (this.runtime().getEnv().isAndroid && finalResult && finalResult.error === 1) {
            finalResult.errorMessage = 'unregisterSSID is only avaliable on iOS platform';
        }
    },
};
var getCarrierName$1 = {};
var isSystemRoot$1 = {};
var seNFCServiceIsv$1 = {
    m: 'virtualServiceH5PluginIsv',
};
var getAuthStatus$1 = {};
var regionPicker$1 = {};
var setScreenOrientation$1 = {};
var getScreenOrientation$1 = {};
var getDeviceID$1 = {};

var onUserCaptureScreen$1 = {
    m: 'screenshotbyuser',
    b: function () {
        if (this.getEnvPlatformAndroid()) {
            this.callDefaultBridge('addScreenshotListener');
        }
    },
};
var offUserCaptureScreen$1 = {
    m: 'screenshotbyuser',
};

var isCollected$1 = {
    a: function (res) {
        if (res.error) {
            res.error = -1;
        }
        else {
            delete res.success;
            delete res.resultCode;
            delete res.resultMsg;
            mapping(res, {
                hasKeep: 'isCollected',
            });
        }
    },
    d: function (_opt, cb) {
        this.callScopedBridge('isCollected', {}, cb);
    },
};

var saveFile$1 = {};
var removeSavedFile$1 = {};
var getSavedFileInfo$1 = {};
var getSavedFileList$1 = {};
var getFileInfo$1 = {};
var openDocument$1 = {};

var getOpenUserData$1 = {};

var chooseCityTask = {
    state: function () {
        return {
            locatedCityId: undefined,
        };
    },
    proto: {
        onLocatedComplete: {
            feature: function () {
                return hasInsideFeature("a_chooseCity_task_2_8_0" /* EInsideFeature.a_chooseCity_task_2_8_0 */);
            },
            a: function (res) {
                var state = this.getState();
                var longitude = res.longitude, latitude = res.latitude, locatedCityId = res.locatedCityId;
                state.locatedCityId = locatedCityId;
                return {
                    longitude: longitude,
                    latitude: latitude,
                };
            },
        },
        offLocatedComplete: {
            feature: function () {
                return hasInsideFeature("a_chooseCity_task_2_8_0" /* EInsideFeature.a_chooseCity_task_2_8_0 */);
            },
        },
        setLocatedCity: {
            feature: function () {
                return hasInsideFeature("a_chooseCity_task_2_8_0" /* EInsideFeature.a_chooseCity_task_2_8_0 */);
            },
            d: function (opt, resolve) {
                var state = this.getState();
                if (state.locatedCityId) {
                    this.callScopedBridge("setLocatedCity" /* NativeAPI.setLocatedCity */, __assign(__assign({}, opt), { locatedCityId: state.locatedCityId }), resolve);
                }
                else {
                    resolve({
                        error: 14,
                        errorMessage: '请等chooseCityTask.onLocatedComplete触发后再调用chooseCityTask.setLocatedCity',
                    });
                }
            },
        },
    },
};

var getLocation$1 = {
    m: 'getCurrentLocation',
    b: function (opt, _) {
        mapping(opt, {
            accuracy: 'horizontalAccuracy',
            type: 'requestType',
        });
        if (!opt.requestType) {
            opt.requestType = 0;
            opt.useDefault = true;
        }
        opt.bizType = opt.bizType ? "".concat(this.getEnvAppId(), "-").concat(opt.bizType) : this.getEnvAppId();
        if (this.getEnvPlatformAndroid()) {
            if (typeof opt.isHighAccuracy === 'undefined') {
                opt.isHighAccuracy = true;
            }
            if (typeof opt.isNeedSpeed === 'undefined') {
                opt.isNeedSpeed = true;
            }
        }
    },
    a: function (res) {
        /**
         * @description 以下参数在最新客户端已不存在，且不在对外透出文档中
         */
        mapping(res, {
            adcode: 'adCode',
            citycode: 'cityCode',
        });
        if (!res.city && res.province) {
            res.city = res.province;
        }
        if (res.latitude) {
            res.latitude += '';
        }
        if (res.longitude) {
            res.longitude += '';
        }
        if (res.accuracy) {
            res.accuracy += '';
            res.horizontalAccuracy = res.accuracy;
        }
        delete res.speed;
    },
};
var openLocation$1 = {
    b: function (opt) {
        opt.scale = opt.scale || 15; // 默认缩放15级
        opt.hidden = '1';
    },
};
var chooseLocation$1 = {
    m: 'beehiveGetPOI',
    b: function (opt) {
        opt.sendBtnText = '选择';
    },
    a: function (res) {
        if (res.error) {
            return;
        }
        if (res.poiId) {
            // 只有一个的时候
            res.address = res.snippet;
            res.name = res.title;
        }
        else {
            if (this.getEnvPlatformAndroid()) {
                // 只管ios
                res.address = res.snippet;
            }
            else {
                res.address = res.title;
            }
            res.name = res.address;
        }
        delete res.snippet;
        delete res.title;
        if (res.latLonPoint) {
            res.latitude = res.latLonPoint.latitude;
            res.longitude = res.latLonPoint.longitude;
            delete res.latLonPoint;
        }
    },
};
var chooseCity$1 = {
    m: 'getCities',
    returnProto: function () {
        return this.callProtoAPI(chooseCityTask, []);
    },
    b: function (opt) {
        var customCities;
        var customHotCities;
        var customHistoryCities;
        mapping(opt, {
            cities: 'customCities',
            hotCities: 'customHotCities',
            showHotCities: 'needHotCity',
        });
        // 显示定位城市
        if (opt.showLocatedCity === true) {
            opt.currentCity = '';
            opt.adcode = '';
        }
        else {
            delete opt.currentCity;
            delete opt.adcode;
        }
        delete opt.showLocatedCity;
        // 自定义城市
        customCities = opt.customCities;
        if (opt.customCities) {
            opt.customCities = mapArray(customCities);
        }
        // 自定义热门城市
        customHotCities = opt.customHotCities;
        if (opt.customHotCities) {
            opt.customHotCities = mapArray(customHotCities);
        }
        // 自定义历史记录城市
        customHistoryCities = opt.customHistoryCities;
        if (opt.customHistoryCities) {
            opt.customHistoryCities = mapArray(customHistoryCities);
        }
        function mapArray(arr) {
            var tempArr;
            if (Array.isArray(arr)) {
                tempArr = [];
                arr.forEach(function (city) {
                    tempArr.push(mapping({}, {
                        adCode: 'adcode%s',
                        city: 'name',
                        spell: 'pinyin',
                    }, city));
                });
                arr = tempArr;
            }
            return arr;
        }
    },
    a: function (res) {
        mapping(res, {
            adcode: 'adCode',
        });
    },
};
var reGeoCode$1 = {};
var geoCode$1 = {};
var startContinuousLocation$1 = {
    d: function (opt, cb) {
        this.callScopedBridge(this.getEnvPlatformAndroid()
            ? "startNewContinuousLocation" /* EBridgeContinuousLocationMethod.AndroidStart */
            : "startContinuousLocation" /* EBridgeContinuousLocationMethod.DefaultStart */, opt, cb);
    },
};
var stopContinuousLocation$1 = {
    d: function (opt, cb) {
        this.callScopedBridge(this.getEnvPlatformAndroid()
            ? "stopNewContinuousLocation" /* EBridgeContinuousLocationMethod.AndroidStop */
            : "stopContinuousLocation" /* EBridgeContinuousLocationMethod.DefaultStop */, opt, cb);
    },
};

var chooseImage$1 = {
    b: function (opt) {
        opt.count = opt.count || 1;
        if (typeof opt.sourceType === 'string') {
            opt.sourceType = [opt.sourceType];
        }
    },
    a: function (res) {
        mapping(res, {
            errorCode: 'error',
            errorDesc: 'errorMessage',
            localIds: 'apFilePaths',
            tempFilePaths: 'apFilePaths',
        });
        // android 返回字符串
        if (typeof res.apFilePaths === 'string') {
            res.apFilePaths = parseJSON(res.apFilePaths);
        }
        res.tempFilePaths = res.apFilePaths;
    },
};
var previewImage$1 = {
    m: 'imageViewer',
    b: function (opt) {
        mapping(opt, {
            current: 'init%d',
            enableSavePhoto: 'enablesavephoto',
        });
        // 处理默认索引
        if (!opt.init) {
            opt.init = 0;
        }
        // 处理图片链接
        opt.images = [];
        (opt.urls || []).forEach(function (url) {
            opt.images.push({
                u: url,
            });
        });
        delete opt.urls;
    },
};
var chooseVideo$1 = {
    b: function (opt) {
        if (typeof opt.sourceType === 'string') {
            opt.sourceType = [opt.sourceType];
        }
        if (typeof opt.camera === 'string') {
            opt.camera = [opt.camera];
        }
    },
    a: function (res) {
        mapping(res, {
            errorCode: 'error',
            errorDesc: 'errorMessage',
            msg: 'errorMessage',
            localId: 'apFilePath',
            tempFilePath: 'apFilePath',
            tempFile: 'apFilePath',
        });
        if (res.apFilePath) {
            res.tempFilePath = res.apFilePath;
        }
        // ios和android都统一返回filePath
        if (!res.filePath) {
            res.filePath = res.apFilePath || res.tempFilePath;
        }
        switch (res.error) {
            case 0: // ios 成功
                delete res.error;
                break;
            case 1: // ios 参数出错
                res.error = 2; // 通用参数无效
                break;
            case 2: // ios 用户取消
                res.error = 10; // android 用户取消
                break;
            case 3: // ios 操作失败
                res.error = 11; // android 操作失败
                break;
            case 4: // ios 数据处理失败
                res.error = 12;
                break;
        }
    },
};
var saveImage$1 = {
    b: function (opt) {
        mapping(opt, {
            url: 'src',
        });
        // 支持用户设置 showActionSheet
        return __assign({ showActionSheet: false, cusHandleResult: true }, opt);
    },
};
var getImageInfo$1 = {};
var compressImage$1 = {
    b: function (opt) {
        // 封装压缩图片宽高字段
        mapping(opt, {
            compressedWidth: 'maxWidth',
            compressedHeight: 'maxHeight',
        });
        // fix appx/af-appx#1179
        if (opt && typeof opt === 'object' && 'data' in opt) {
            delete opt.data;
        }
        if (opt && typeof opt === 'object' && 'dataType' in opt) {
            delete opt.dataType;
        }
    },
};
var getAvailableAudioSources$1 = {};
var saveVideoToPhotosAlbum$1 = {};
var generateImageFromCode$1 = {
    b: function (opt) {
        if (opt && typeof opt === 'object' && opt.format && opt.format === 'BARCODE') {
            opt.bizType = 'GENERAL_REPLACE';
        }
        return opt;
    },
};
var saveImageToPhotosAlbum$1 = {};
var textToSpeech$1 = {};
var chooseFileFromDisk$1 = {};

var showNavigationBarLoading$1 = {
    m: 'showTitleLoading',
};
var hideNavigationBarLoading$1 = {
    m: 'hideTitleLoading',
};
var setNavigationBar$1 = {
    v: function (opt) {
        /**
         * 前景色只支持 #000000 和 #FFFFFF
         */
        if (typeof opt.frontColor !== 'undefined') {
            var transformedFrontColor = toType('%c', opt.frontColor);
            if (transformedFrontColor !== 16777215 /* EFrontColorValidValue.White */ &&
                transformedFrontColor !== 0 /* EFrontColorValidValue.Black */) {
                return {
                    error: 2,
                    errorMessage: "frontColor \u53C2\u6570 ".concat(opt.frontColor, " \u989C\u8272\u503C\u4E0D\u5408\u6CD5"),
                };
            }
        }
    },
    b: function (opt) {
        // 如果 reset 为 true，就将背景色置为默认色白色
        if (opt.reset) {
            opt.backgroundColor = '#ffffff';
        }
        // 删除 reset 否则会与其他字段耦合导致其他字段设置不成功
        delete opt.reset;
        // JSAPI 名称太长又多次引用，不利于代码压缩，固单独记录
        var st = 'setTitle';
        var stc = 'setTitleColor';
        var sblc = 'setBarBottomLineColor';
        var optionPageViewId = this.optionPageViewId;
        var _opt;
        if (optionPageViewId) {
            _opt = {
                setTitle: { viewId: optionPageViewId },
                setTitleColor: { viewId: optionPageViewId },
                setBarBottomLineColor: { viewId: optionPageViewId },
            };
        }
        else {
            _opt = {
                setTitle: {},
                setTitleColor: {},
                setBarBottomLineColor: {},
            };
        }
        // 映射不同 JSAPI 的入参
        _opt[st] = mapping(_opt[st], {
            title: 'title%s',
            image: 'image%b', // 处理 image 为 base64 的情况，为 native 移除格式头
        }, opt);
        _opt[stc] = mapping(_opt[stc], {
            backgroundColor: 'color%c',
            frontColor: 'frontColor%c',
        }, opt);
        _opt[sblc] = mapping(_opt[sblc], {
            borderBottomColor: 'color%c',
        }, opt);
        return _opt;
    },
    d: function (_opt, resolve) {
        var st = 'setTitle';
        var stc = 'setTitleColor';
        var sblc = 'setBarBottomLineColor';
        var res = {};
        // setTitle
        if (objectKeys(_opt[st]).length !== 0) {
            this.callDefaultBridge(st, _opt[st], undefined, this.optionPageViewId);
        }
        // setBarBottomLineColor
        if (objectKeys(_opt[sblc]).length !== 0) {
            if (isNaN(_opt[sblc].color)) {
                res.error = 2;
                res.errorMessage = 'borderBottomColor 颜色值不合法';
            }
            else {
                this.callDefaultBridge(sblc, _opt[sblc], undefined, this.optionPageViewId);
            }
        }
        // setTitleColor
        if (objectKeys(_opt[stc]).length !== 0) {
            if (isNaN(_opt[stc].color)) {
                res.error = 2;
                res.errorMessage = 'frontColor 需和 backgroundColor 同时设置';
                resolve(res);
            }
            else {
                this.callDefaultBridge(stc, _opt[stc], function (result) {
                    res = __assign(__assign({}, result), res);
                    resolve(res);
                }, this.optionPageViewId);
            }
        }
        else {
            // setTitle 和 setBarBottomLineColor 本身没有回调
            // 为保持接口一致性要模拟一个异步回调
            resolve(res);
        }
    },
};

// c, p方法待续
function addBase64Head(base64, mimeType) {
    // 如果已经以 data: 开头，则不加 base64 头
    if (base64 && base64.startsWith && base64.startsWith('data:')) {
        return base64;
    }
    if (base64 && mimeType) {
        base64 = "data:".concat(mimeType, ";base64,") + base64;
    }
    return base64;
}
function stringUrl(params) {
    return stringify(params);
}
function buildUrl(url, params) {
    var query = params || '';
    if (typeof params === 'object') {
        query = stringUrl(params);
    }
    if (query === '') {
        return url;
    }
    if (!/\?/.test(url)) {
        query = '?' + query;
    }
    else if (!/&$/.test(url) && !/\?$/.test(url)) {
        query = '&' + query;
    }
    return url + query;
}
function _isLocalId(localId) {
    return /^[a-z0-9|]+$/i.test(localId);
}
function isFormUrlEncode(contentType) {
    return /^application\/x-www-form-urlencoded\b/i.test(contentType);
}
function map(fn, obj) {
    var realData = {};
    for (var _i = 0, _a = objectKeys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        realData[key] = fn(obj[key]);
    }
    return realData;
}
function transformUrlData(contentType, data) {
    var realData = data;
    if (isFormUrlEncode(contentType) && typeof data === 'object') {
        realData = map(function (value) { return (typeof value === 'object' ? stringifyJSON(value) : value); }, data);
    }
    return realData;
}
function buildHeader(originalHeaders) {
    var androidHeaders = [];
    var headers = objectKeys(originalHeaders);
    for (var _i = 0, headers_1 = headers; _i < headers_1.length; _i++) {
        var header = headers_1[_i];
        var androidHeader = {};
        androidHeader[header] = originalHeaders[header];
        androidHeaders.push(androidHeader);
    }
    return androidHeaders;
}
function transformData(contentType, data) {
    if (typeof data === 'undefined') {
        data = '';
    }
    else {
        if ('string' != typeof data) {
            if (isFormUrlEncode(contentType)) {
                data = stringUrl(data);
            }
            else if (/^application\/json\b/i.test(contentType)) {
                data = stringifyJSON(data);
            }
            else {
                data = 'object' === typeof data ? stringifyJSON(data) : data.toString();
            }
        }
    }
    return data;
}
var rpc$1 = {
    allowAbort: true,
    d: function (opt, cb) {
        // appx 这个竟然没加 domain？？
        this.callScopedBridge('rpc', opt, cb);
    },
};
var request$1 = {
    allowAbort: true,
    returnEvent: {
        headersReceived: {
            feature: function () { return hasInsideFeature("a_request_headersReceived_2_8_7" /* EInsideFeature.a_request_headersReceived_2_8_7 */); },
            eventName: 'requestTaskHeadersReceived',
            getPayload: function (userEvent) {
                var headers = userEvent.data.headers;
                return {
                    header: headers,
                };
            },
            getTaskId: function (userEvent) {
                return [userEvent.data.requestTaskId];
            },
            taskId: function () {
                return "".concat(this.taskId);
            },
        },
    },
    t: true,
    /**
     * 接口可直接传入一个字符串（opt.url）
     * 参数 opt.data 支持对象，会转成 queryString
     * 入参改造 opt.dataType => opt.responseType，
     * opt.dataType 支持 json|text|base64，json 时会对返回数据调用一次 JSON.parse
     */
    b: function (opt) {
        mapping(opt, {
            header: 'headers',
        });
        opt.requestTaskId = this.taskId;
        var get = 'GET';
        // method 默认 'GET'
        opt.method = (opt.method || get).toUpperCase();
        opt.enableSubErrorCode = true;
        /**
         * https://developers.weixin.qq.com/miniprogram/dev/api/network/request/wx.request.html
         * 微信request入参分析
         * dataType: 返回的数据格式 枚举值有 json | 其它，值为json时，会对结果做一次JSON.parse
         * responseType: 响应的数据类型 枚举值有 text | arraybuffer
         * https://baiyan.antfin.com/task/152098?bqlKey=277a5c5
         * 上述白雁里的case，开发者只传入{ responseType: 'arraybuffer' } 不传dataType
         * 为了兼容直接从微信转过来的代码使用姿势，在不设置dataTyp 且responseType值为arraybuffer/text时 做定向处理
         */
        // wx.request.responseType 的合法值只有text | arraybuffer
        var runtime = this.runtime();
        if (opt.dataType === undefined && (opt.responseType === 'arraybuffer' || opt.responseType === 'text')) {
            var _a = runtime
                .getBehaviorManager()
                .get("requestBehaviors" /* ESharedAppxSwitchManagerName.RequestBehaviors */, 0 /* ESharedAppxSwitchManagerValue4RequestAPIIndex.ResponseType */), standard = _a.standard, report = _a.report;
            // 只能配开关，才会有report
            if (report) {
                report('request.dataType is undefined and has request.responseType', {
                    url: opt.url,
                    responseType: opt.responseType,
                });
            }
            if (standard) {
                opt.dataType = opt.responseType;
            }
            else {
                // 保持原样
                // dataType 默认 'json'
                opt.dataType = (opt.dataType || 'json').toLowerCase();
                opt.responseType = opt.dataType;
            }
        }
        else {
            // dataType 默认 'json'
            opt.dataType = (opt.dataType || 'json').toLowerCase();
            opt.responseType = opt.dataType;
        }
        // 处理 responseType，非 base64 全当 text 对待
        opt.responseType = opt.responseType !== 'base64' && opt.responseType !== 'arraybuffer' ? 'text' : opt.responseType;
        // 处理 contentType，并强制 headers 为 object
        var headers = (opt.headers = opt.headers || {});
        var contentType = '';
        for (var key in headers) {
            if (key.toLowerCase() == 'content-type') {
                contentType = headers[key];
                break;
            }
        }
        if (!contentType) {
            contentType = headers['content-type'] = 'application/json';
        }
        // 处理 android headers 转换为 JSONArray 格式
        if (this.getEnvPlatformAndroid()) {
            opt.headers = buildHeader(opt.headers);
        }
        // 处理 GET 时，手动拼装上 queryString
        if (opt.method === get) {
            // const { closeAssembleParams } = this.runtime().getEnv().originalStartupParams;
            // if (closeAssembleParams !== true) {
            opt.hasAssembleParams = true;
            opt.url = buildUrl(opt.url, transformUrlData(contentType, opt.data));
            // }
        }
        else if (opt.method === 'DELETE') {
            opt.hasAssembleParams = false;
        }
        if (typeof opt.data !== 'string' && isArrayBuffer(opt.data)) ;
        else {
            opt.data = transformData(contentType, opt.data);
        }
        // 没显示传入 referrerStrategy 才去 behavior 拿
        if (!opt.referrerStrategy) {
            // empty 或者 app 表示在小程序的执行上下文中
            if (isAppxDomain4Empty(this.appxDomain) || isAppxDomain4App(this.appxDomain)) {
                var appBehavior = runtime.getMeta().getAppBehavior();
                if (appBehavior && appBehavior["requestReferrerStrategy" /* ESharedAppMetaBehaviorMapValue.RequestReferrerStrategy */]) {
                    if (appBehavior["requestReferrerStrategy" /* ESharedAppMetaBehaviorMapValue.RequestReferrerStrategy */] ===
                        "page" /* ESharedRequestReferrerStrategyBehaviorType.Page */) {
                        opt.referrerStrategy = "page" /* ESharedRequestReferrerStrategyBehaviorType.Page */;
                    }
                    else if (appBehavior["requestReferrerStrategy" /* ESharedAppMetaBehaviorMapValue.RequestReferrerStrategy */] ===
                        "index" /* ESharedRequestReferrerStrategyBehaviorType.Index */) {
                        opt.referrerStrategy = "index" /* ESharedRequestReferrerStrategyBehaviorType.Index */;
                    }
                }
            }
            else if (isAppxDomain4Extension(this.appxDomain)) {
                // extension 表示在插件中
                var meta = runtime.getMiniExtensionManager().getMetaByExtensionId({
                    type: 4 /* EMiniExtensionStringType._$_extension_id_$_ */,
                    value: this.appxDomain.origin,
                });
                if (meta && meta.config && meta.config.behavior) {
                    var pluginBehavior = meta.config.behavior;
                    if (pluginBehavior["requestReferrerStrategy" /* ESharedMiniExtensionMetaBehaviorMapValue.RequestReferrerStrategy */]) {
                        if (pluginBehavior["requestReferrerStrategy" /* ESharedMiniExtensionMetaBehaviorMapValue.RequestReferrerStrategy */] ===
                            "page" /* ESharedRequestReferrerStrategyBehaviorType.Page */) {
                            opt.referrerStrategy = "page" /* ESharedRequestReferrerStrategyBehaviorType.Page */;
                        }
                        else if (pluginBehavior["requestReferrerStrategy" /* ESharedMiniExtensionMetaBehaviorMapValue.RequestReferrerStrategy */] ===
                            "index" /* ESharedRequestReferrerStrategyBehaviorType.Index */) {
                            opt.referrerStrategy = "index" /* ESharedRequestReferrerStrategyBehaviorType.Index */;
                        }
                    }
                }
            }
        }
    },
    a: function (res, opt) {
        mapping(res, {
            header: 'headers',
            statusCode: 'status',
        });
        switch (opt.dataType) {
            // 处理 json
            case 'json':
                if (res.data) {
                    try {
                        res.data = parseJSON(res.data);
                    }
                    catch (e) {
                        if (res.error === undefined || res.error === 0) {
                            res.error = 14;
                            res.errorMessage = 'JSON parse data error';
                        }
                    }
                }
                break;
            // 处理 base64
            case 'base64':
                if (res.data && res.headers) {
                    res.data = addBase64Head(res.data, res.headers['Content-Type'] || res.headers['content-type']);
                }
                break;
            // 处理 arraybuffer
            case 'arraybuffer':
                if (res.data && !isArrayBuffer(res.data)) {
                    try {
                        res.data = base64ToArrayBuffer(res.data);
                    }
                    catch (e) {
                        if (res.error === undefined || res.error === 0) {
                            res.error = 14;
                            res.errorMessage = 'parse arraybuffer data error';
                        }
                    }
                }
                break;
        }
        // 处理错误
        if ('status' in res) {
            var status = res.status + '';
            if (/^[45]/.test(status)) {
                if (res.error === undefined || res.error === 0) {
                    res.error = 19;
                    res.errorMessage = 'http status error';
                }
            }
        }
        if (res.appxProfile) {
            delete res.appxProfile;
        }
        if (res.status) {
            res.statusCode = res.status;
        }
        if (res.headers) {
            res.header = res.headers;
        }
    },
    a_l: function (res) {
        if (res.subErrorCode) {
            delete res.subErrorCode;
        }
    },
    c: function () {
        this.callScopedBridge('operateRequestTask', {
            operationType: 'abort',
            requestTaskId: this.taskId,
        });
    },
};
var httpRequest$1 = {
    allowAbort: true,
    /**
     * 接口可直接传入一个字符串（opt.url）
     * 参数 opt.data 支持对象，会转成 queryString
     * 入参改造 opt.dataType => opt.responseType，
     * opt.dataType 支持 json|text|base64，json 时会对返回数据调用一次 JSON.parse
     */
    b: function (opt) {
        var get = 'GET';
        // method 默认 'GET'
        opt.method = (opt.method || get).toUpperCase();
        // dataType 默认 'json'
        opt.dataType = (opt.dataType || 'json').toLowerCase();
        opt.responseType = opt.dataType;
        // 强制 headers 为 object
        opt.headers = opt.headers || {};
        // 如果 data 是对象，则转成 queryString，
        if (typeof opt.data === 'object') {
            var headers = opt.headers;
            var contentType = headers['Content-Type'] || headers['content-type'];
            if (/^application\/json\b/i.test(contentType) && opt.method === 'POST') {
                opt.data = stringifyJSON(opt.data);
            }
            else {
                if (opt.method === get) {
                    opt.data = stringUrl(transformUrlData(contentType, opt.data));
                }
                else {
                    opt.data = stringUrl(opt.data);
                }
            }
        }
        // 所以要处理 GET 时，手动拼装上 queryString
        if (opt.method === get && typeof opt.data === 'string') {
            opt.url = buildUrl(opt.url, opt.data);
        }
        // 处理 responseType，非 base64 全当 text 对待
        opt.responseType = opt.responseType !== 'base64' ? 'text' : 'base64';
        // 处理 android headers 转换为 JSONArray 格式
        if (this.getEnvPlatformAndroid()) {
            opt.headers = buildHeader(opt.headers);
        }
    },
    a: function (res, opt) {
        // 处理 json
        if (opt.dataType === 'json' && res.data) {
            try {
                res.data = parseJSON(res.data);
            }
            catch (e) {
                res.error = 14;
                res.errorMessage = 'JSON parse data error';
                return;
            }
        }
        // 处理 base64
        if (opt.dataType === 'base64' && res.data && res.headers) {
            res.data = addBase64Head(res.data, res.headers['Content-Type'] || res.headers['content-type']);
        }
        // 处理错误
        if ('status' in res) {
            var status = res.status + '';
            if (/^[45]/.test(status)) {
                res.error = 19;
                res.errorMessage = 'http status error';
            }
        }
    },
};
var uploadFile$1 = {
    allowAbort: true,
    progress: {
        key: 'uploadTask',
        getPayload: function (userEvent) {
            var _a = userEvent.data; _a.uploadTaskId; var rest = __rest(_a, ["uploadTaskId"]);
            return rest;
        },
        getTaskId: function (userEvent) {
            return [userEvent.data.uploadTaskId];
        },
    },
    returnEvent: {
        headersReceived: {
            feature: function () { return hasInsideFeature("a_uploadFile_headersReceived_2_8_2" /* EInsideFeature.a_uploadFile_headersReceived_2_8_2 */); },
            eventName: 'uploadTaskHeadersReceived',
            getPayload: function (userEvent) {
                var header = userEvent.data.header;
                return {
                    header: header,
                };
            },
            getTaskId: function (userEvent) {
                return [userEvent.data.uploadTaskId];
            },
            taskId: function () {
                return "".concat(this.taskId);
            },
        },
    },
    t: true,
    b: function (opt) {
        opt.uploadTaskId = this.taskId;
        mapping(opt, {
            fileName: 'name',
            fileType: 'type',
            headers: 'header',
        });
        if (_isLocalId(opt.filePath)) {
            opt.localId = opt.filePath;
            delete opt.filePath;
        }
        opt.enableSubErrorCode = true;
        opt.type = opt.fileType || 'image';
    },
    a: function (res) {
        if (res.error === 2) {
            res.error = 11;
        }
        if (res.appxProfile) {
            delete res.appxProfile;
        }
    },
    a_l: function (res) {
        if (res.subErrorCode) {
            delete res.subErrorCode;
        }
    },
    c: function () {
        this.callScopedBridge('operateUploadTask', {
            operationType: 'abort',
            uploadTaskId: this.taskId,
        });
    },
};
var downloadFile$1 = {
    progress: {
        key: 'downloadTask',
        getPayload: function (userEvent) {
            var _a = userEvent.data; _a.downloadTaskId; var rest = __rest(_a, ["downloadTaskId"]);
            return rest;
        },
        getTaskId: function (userEvent) {
            return [userEvent.data.downloadTaskId];
        },
    },
    returnEvent: {
        headersReceived: {
            feature: function () { return hasInsideFeature("a_downloadFile_headersReceived_2_8_7" /* EInsideFeature.a_downloadFile_headersReceived_2_8_7 */); },
            eventName: 'downloadTaskHeadersReceived',
            getPayload: function (userEvent) {
                var headers = userEvent.data.headers;
                return {
                    header: headers,
                };
            },
            getTaskId: function (userEvent) {
                return [userEvent.data.downloadTaskId];
            },
            taskId: function () {
                return "".concat(this.taskId);
            },
        },
    },
    t: true,
    allowAbort: true,
    b: function (opt) {
        opt.downloadTaskId = this.taskId;
        /**
         *插件需要加上 plugin_isolation 否则，获取文件时会有权限问题
         * 1. 宿主加不加此参数，插件都获取不到文件
         * 2. 插件只有加此参数，才能正常通过 getFileInfo 获取文件
         */
        if (isAppxDomain4Extension(this.appxDomain)) {
            opt.plugin_isolation = 'true';
        }
        opt.enableSubErrorCode = true;
        /**
         * @description 经考证，客户端无 headers 参数
         */
        mapping(opt, {
            headers: 'header',
        });
    },
    a: function (res) {
        mapping(res, {
            errorCode: 'error',
            tempFilePath: 'apFilePath',
            header: 'headers',
        });
        // 对齐微信，返回值暴露tempFilePath字段
        if (res.apFilePath) {
            res.tempFilePath = res.apFilePath;
        }
        if (res.headers) {
            res.header = res.headers;
        }
        if (res.appxProfile) {
            delete res.appxProfile;
        }
    },
    a_l: function (res) {
        if (res.subErrorCode) {
            delete res.subErrorCode;
        }
    },
    c: function () {
        // c for cancel
        this.callScopedBridge('operateDownloadTask', {
            downloadTaskId: this.taskId,
            operationType: 'abort',
        });
    },
};
var onNetworkStatusChange$1 = {
    m: 'h5NetworkChange',
    a: function (res) {
        delete res.NBPageUrl;
    },
};
var offNetworkStatusChange$1 = {
    m: 'h5NetworkChange',
};
var getTBSessionInfo$1 = {};

function getNavigateToMiniProgramOptions(appId, config, enableQuery) {
    var referrerInfo = {
        appId: appId,
    };
    var param = {};
    if (config.path) {
        param.page = config.path;
    }
    if (config.extraData) {
        referrerInfo.extraData = config.extraData;
    }
    param.referrerInfo = stringifyJSON(referrerInfo);
    if (enableQuery && config.query && typeof config.query === 'object') {
        param.query = stringify(__assign(__assign({}, config.query), { __queryObjectFromNavigateToMiniProgram__: 1 }));
    }
    var options = __assign(__assign({ appId: config.appId }, config), { param: param });
    // 使用 联调设置 方案: https://opendocs.alipay.com/mini/ide/integration-testing 明确不开放envVersion
    // const versions = ['develop', 'trial', 'release', 'examine'];
    // if (config.envVersion && versions.indexOf(config.envVersion) !== -1) {
    //   options.envVersion = config.envVersion;
    // }
    return options;
}
/**
 * 打开半屏小程序
 * 入参和 navigateToMiniProgram 保持一致
 */
var openEmbeddedMiniProgram$1 = {
    feature: function () { return hasInsideFeature("f_openEmbeddedMiniProgram_2_7_19" /* EInsideFeature.f_openEmbeddedMiniProgram_2_7_19 */); },
    d: function (opt, cb) {
        var appxDomain = this.appxDomain;
        var isMiniExtension = isAppxDomain4Extension(appxDomain);
        if (isMiniExtension) {
            // 增加一个额外参数 __miniExtensionId，先通过 metrics 采集线上是否有小程序插件在调用打开半屏小程序
            var miniExtensionId = appxDomain.origin;
            opt.__miniExtensionId = miniExtensionId;
        }
        var enableOpenEmbeddedMiniProgramScopedBridgeCall = this.getFlag("enableOpenEmbeddedMiniProgramScopedBridgeCall" /* EBridgeFlagName.EnableOpenEmbeddedMiniProgramScopedBridgeCall */);
        // 切换到 scoped bridge 调用
        if (enableOpenEmbeddedMiniProgramScopedBridgeCall) {
            // 如果有少数的插件在线上已经通过宿主的权限调用了，加白并联系他们修改，添加功能包到插件中
            var openEmbeddedMiniProgramDefaultBridgeCallExtensionsWhiteList = this.getFlag("openEmbeddedMiniProgramDefaultBridgeCallExtensionsWhiteList" /* EBridgeFlagName.OpenEmbeddedMiniProgramDefaultBridgeCallExtensionsWhiteList */);
            if (openEmbeddedMiniProgramDefaultBridgeCallExtensionsWhiteList &&
                openEmbeddedMiniProgramDefaultBridgeCallExtensionsWhiteList.length > 0 &&
                isMiniExtension &&
                openEmbeddedMiniProgramDefaultBridgeCallExtensionsWhiteList.indexOf(appxDomain.origin) > -1) {
                return this.callDefaultBridge('openEmbeddedMiniProgram', getNavigateToMiniProgramOptions(this.getEnvAppId(), opt, true), cb);
            }
            return this.callScopedBridge('openEmbeddedMiniProgram', getNavigateToMiniProgramOptions(this.getEnvAppId(), opt, true), cb);
        }
        this.callDefaultBridge('openEmbeddedMiniProgram', getNavigateToMiniProgramOptions(this.getEnvAppId(), opt, true), cb);
    },
};

var navigateToMiniProgram$1 = {
    tapMark: function () {
        var appxDomain = this.appxDomain;
        var isExtension = isAppxDomain4Extension(appxDomain);
        var disableNavigateToMiniProgramTapMark4Widget = this.ctx.getFlag("disableNavigateToMiniProgramTapMark4Widget" /* EBridgeFlagName.DisableNavigateToMiniProgramTapMark4Widget */) || [];
        /**
         * tapMark 为 true 的条件为：
         * 1. 运行时为 widget 环境
         * 2. 有 extensionId
         * 3. extensionId 不在黑名单内
         * 4. 黑名单不存在 all 字段
         */
        return (this.runtime().getEnv().isPortalWorkerScene &&
            isExtension &&
            disableNavigateToMiniProgramTapMark4Widget.indexOf(appxDomain.origin) === -1 &&
            disableNavigateToMiniProgramTapMark4Widget.indexOf('all') === -1);
    },
    d: function (opt, cb) {
        // 默认支持query参数
        var enableQuery = this.getFlag("navigateToMiniProgramQuery" /* EBridgeFlagName.NavigateToMiniProgramQuery */) !== 0;
        var enableNavigateToMiniProgramScopedBridgeCall = this.getFlag("enableNavigateToMiniProgramScopedBridgeCall" /* EBridgeFlagName.EnableNavigateToMiniProgramScopedBridgeCall */);
        // 小橱窗 native 模式尚未落地，默认加 appxDomain
        if (enableNavigateToMiniProgramScopedBridgeCall ||
            this.runtime().getEnv().startupParams.workerStartupScene === "widget" /* EAppxWidgetType.Native */) {
            this.callScopedBridge('navigateToMiniProgram', getNavigateToMiniProgramOptions(this.getEnvAppId(), opt, enableQuery), cb);
        }
        else {
            this.callDefaultBridge('navigateToMiniProgram', getNavigateToMiniProgramOptions(this.getEnvAppId(), opt, enableQuery), cb);
        }
    },
};

var hideAddToDesktopMenu$1 = {
    m: 'hideOptionMenuItem',
    b: function (opt) {
        opt.scope = 'single';
        opt.name = 'add2Desktop';
    },
};
var hideAllAddToDesktopMenu$1 = {
    m: 'hideOptionMenuItem',
    b: function (opt) {
        opt.scope = 'all';
        opt.name = 'add2Desktop';
    },
};
var hideFavoriteMenu$1 = {
    m: 'hideOptionMenuItem',
    b: function (opt) {
        opt.scope = 'single';
        opt.name = 'favorite';
    },
};

// shareToChannel原始版
// function shareToChannel() {
//   callBridge('shareToChannel', opts, cb);
// }
var hideShareMenu$1 = {};

var kOpenCapabilityPrefix = '_appx_open_capability_';
function formatKey4OpenCapability(origin, originalKey) {
    // 官方能力使用 storage相关API时 为了避免与宿主使用 key相冲突，appx内部加个前缀
    return "".concat(kOpenCapabilityPrefix).concat(origin, "_").concat(originalKey);
}
function validateStorageKey4OpenCapability(method, key, runtimeGetter) {
    // 不允许传入的key 以 ${kOpenCapabilityPrefix} 为前缀
    if (key.indexOf(kOpenCapabilityPrefix) === 0) {
        var isolation4OpenCapabilityStorageBehavior = runtimeGetter()
            .getBehaviorManager()
            .get("enableIsolation4OCStorage" /* ESharedAppxSwitchManagerName.EnableIsolation4OpenCapabilityStorage */);
        if (isolation4OpenCapabilityStorageBehavior.report) {
            isolation4OpenCapabilityStorageBehavior.report("unexpected key when using storage API: ".concat(key, ", type: ").concat(method));
        }
        if (isolation4OpenCapabilityStorageBehavior.standard) {
            return {
                error: 15,
                errorMessage: "\u65E0\u6548key\uFF0Ckey\u4E0D\u80FD\u4EE5".concat(kOpenCapabilityPrefix, "\u5F00\u5934"),
            };
        }
    }
}
var setStorage$1 = {
    m: 'setTinyLocalStorage',
    v: function (opt) {
        return validateStorageKey4OpenCapability('setStorage', String(opt.key), this.runtime);
    },
    b: function (opt) {
        opt.value = stringifyJSON({ APDataStorage: opt.data });
        opt.data = opt.value;
        /**
         * 从 10.3.90 开始，期望去掉无用入参 value
         */
        if (hasInsideFeature("a_setStorage_value_remove_2_8_16" /* EInsideFeature.a_setStorage_value_remove_2_8_16 */) &&
            this.getFlag("removeSetStorageParamValue" /* EBridgeFlagName.RemoveSetStorageParamValue */)) {
            opt.value = undefined;
        }
        if (isAppxDomain4OpenCapability(this.appxDomain) &&
            !hasInsideFeature("a_storage_open_capability_2_8_15" /* EInsideFeature.a_storage_open_capability_2_8_15 */)) {
            opt.key = formatKey4OpenCapability(this.appxDomain.origin, String(opt.key));
        }
        else {
            opt.key = String(opt.key);
        }
        opt.type = 'user';
    },
    cache: {
        key: 'jsApi_tinyLocalStorage',
        set: function (persistInfo, option) {
            if (!persistInfo.cache) {
                persistInfo.cache = {};
            }
            persistInfo.cache[option.key] = {
                data: option.data,
            };
        },
    },
};
var getStorage$1 = {
    m: 'getTinyLocalStorage',
    v: function (opt) {
        return validateStorageKey4OpenCapability('getStorage', String(opt.key), this.runtime);
    },
    cache: {
        key: 'jsApi_tinyLocalStorage',
        get: function (persistInfo, option) {
            // 保证一定是新对象
            if (!persistInfo.cache) {
                persistInfo.cache = {};
            }
            var rawResult = persistInfo.cache[option.key];
            if (rawResult && typeof rawResult === 'object') {
                if (rawResult.data) {
                    // 避免原型链
                    return {
                        success: true,
                        data: rawResult.data,
                    };
                }
                else if (rawResult.error === 11) {
                    // 查无此 key 的近端拦截
                    return {
                        success: false,
                        error: 11,
                    };
                }
            }
        },
        update: function (persistInfo, option, result) {
            if (!persistInfo.cache) {
                persistInfo.cache = {};
            }
            if (result.data) {
                persistInfo.cache[option.key] = {
                    data: result.data,
                };
            }
            else if (result.error === 11) {
                // 查无此 key 的记录
                persistInfo.cache[option.key] = {
                    error: 11,
                };
            }
        },
    },
    b: function (opt) {
        if (isAppxDomain4OpenCapability(this.appxDomain) &&
            !hasInsideFeature("a_storage_open_capability_2_8_15" /* EInsideFeature.a_storage_open_capability_2_8_15 */)) {
            opt.key = formatKey4OpenCapability(this.appxDomain.origin, String(opt.key));
        }
        else {
            opt.key = String(opt.key);
        }
        opt.type = 'user';
        var runtime = this.runtime();
        var nav = runtime.getNav();
        opt.isAppFirstPage = nav.isFirstPage();
    },
    a: function (res) {
        if (res.error === 11) {
            res.data = null;
            delete res.error;
            delete res.errorMessage;
            delete res.success;
        }
        if (res.data) {
            var data = parseJSON(res.data);
            res.data = data.APDataStorage;
        }
    },
};
var removeStorage$1 = {
    m: 'removeTinyLocalStorage',
    v: function (opt) {
        return validateStorageKey4OpenCapability('removeStorage', String(opt.key), this.runtime);
    },
    b: function (opt) {
        if (isAppxDomain4OpenCapability(this.appxDomain) &&
            !hasInsideFeature("a_storage_open_capability_2_8_15" /* EInsideFeature.a_storage_open_capability_2_8_15 */)) {
            opt.key = formatKey4OpenCapability(this.appxDomain.origin, String(opt.key));
        }
        else {
            opt.key = String(opt.key);
        }
        opt.type = 'user';
    },
    cache: {
        key: 'jsApi_tinyLocalStorage',
        set: function (persistInfo, option) {
            if (!persistInfo.cache) {
                persistInfo.cache = {};
            }
            // 这里不存储 { error: 11 }
            // 开发者主动 remove 后再调用强制向下打穿
            persistInfo.cache[option.key] = null;
        },
    },
};
var clearStorage$1 = {
    m: 'clearTinyLocalStorage',
    b: function (opt) {
        opt.type = 'user';
    },
    cache: {
        key: 'jsApi_tinyLocalStorage',
        set: function (persistInfo, option) {
            persistInfo.cache = {};
        },
    },
};
var getStorageInfo$1 = {
    m: 'getTinyLocalStorageInfo',
    a: function (res) {
        if (res && res.keys) {
            // 开放能力内调用的，只返回以 kOpenCapabilityPrefix 开头的key
            if (isAppxDomain4OpenCapability(this.appxDomain)) {
                if (!hasInsideFeature("a_storage_open_capability_2_8_15" /* EInsideFeature.a_storage_open_capability_2_8_15 */)) {
                    res.keys = res.keys.filter(function (key) { return key.indexOf(kOpenCapabilityPrefix) === 0; });
                    // 逆向裁剪掉内部拼上的前缀
                    if (res.keys.length) {
                        var prefix4OpenCapability_1 = "".concat(kOpenCapabilityPrefix).concat(this.appxDomain.origin, "_");
                        res.keys = res.keys.map(function (key) { return key.substr(prefix4OpenCapability_1.length); });
                    }
                }
                // 未来开放能力提供『组件』时，appxDomain 可能是小程序/插件。
            }
            else {
                // 避免之前已经存储过的带前缀的key被读取到，故这个filter仍然需要
                res.keys = res.keys.filter(function (key) { return key.indexOf(kOpenCapabilityPrefix) !== 0; });
            }
        }
    },
};

var showToast$1 = {
    m: 'toast',
    tapMark: function () {
        return this.runtime().getEnv().isPortalWorkerScene;
    },
};
var hideToast$1 = {};

function getTaskIdFromWebSocketEvent(event, taskContext) {
    var data = event.data || {};
    return [data.socketTaskID];
}
function getPayloadFromWebSocketEvent(event) {
    return event;
}
var BridgeWebSocketTask = /** @class */ /*#__PURE__*/ (function () {
    function BridgeWebSocketTask(appId, getRuntime, callScopedBridge, idPrefix) {
        if (idPrefix === void 0) { idPrefix = ''; }
        this.type = 'SocketTask';
        var runtime = getRuntime();
        var bridge = runtime.getBridge();
        var extraInfo = bridge.extraInfo;
        if (!extraInfo["socketTaskIdBase" /* EBridgeExtraInfoKey.socketTaskIdBase */]) {
            extraInfo["socketTaskIdBase" /* EBridgeExtraInfoKey.socketTaskIdBase */] = 1;
        }
        else {
            ++extraInfo["socketTaskIdBase" /* EBridgeExtraInfoKey.socketTaskIdBase */];
        }
        var taskId = extraInfo["socketTaskIdBase" /* EBridgeExtraInfoKey.socketTaskIdBase */];
        this.id = idPrefix + String(taskId);
        var getEvent = function () { return getRuntime().getBridge().event; };
        this._getParams = functionBind(this.__getParams, this, appId);
        this.__doAction = functionBind(this.___doAction, this, callScopedBridge);
        this._listen = functionBind(this.__listen, this, getEvent);
        this._unListen = functionBind(this.__unListen, this, getEvent);
    }
    BridgeWebSocketTask.prototype.__getParams = function (appId) {
        return {
            bizIdentifier: appId,
            socketTaskID: this.id,
        };
    };
    BridgeWebSocketTask.prototype.__listen = function (getEventManager, eventName, callback) {
        getEventManager().taskManager.addMatcher(eventName, this.id, callback, getTaskIdFromWebSocketEvent, getPayloadFromWebSocketEvent);
    };
    BridgeWebSocketTask.prototype.__unListen = function (getEventManager, eventName, callback) {
        getEventManager().taskManager.removeMatcher(eventName, this.id, callback);
    };
    BridgeWebSocketTask.prototype.___doAction = function (callScopedBridge, opt, method) {
        var _a = opt || {}, success = _a.success, fail = _a.fail, complete = _a.complete, rest = __rest(_a, ["success", "fail", "complete"]);
        var callback = extractBridgeCallback(success, fail, complete, true);
        callScopedBridge(method, __assign(__assign({}, rest), this._getParams()), callback);
    };
    BridgeWebSocketTask.prototype.send = function (opt) {
        this.__doAction(opt, 'sendSocketMessage');
    };
    BridgeWebSocketTask.prototype.close = function (opt) {
        this.__doAction(opt, 'closeSocket');
    };
    BridgeWebSocketTask.prototype.onClose = function (handler) {
        this._listen('onSocketTaskClose', handler);
    };
    BridgeWebSocketTask.prototype.offClose = function (handler) {
        this._unListen('onSocketTaskClose', handler);
    };
    BridgeWebSocketTask.prototype.onError = function (handler) {
        this._listen('onSocketTaskError', handler);
    };
    BridgeWebSocketTask.prototype.offError = function (handler) {
        this._unListen('onSocketTaskError', handler);
    };
    BridgeWebSocketTask.prototype.onMessage = function (handler) {
        this._listen('onSocketTaskMessage', handler);
    };
    BridgeWebSocketTask.prototype.offMessage = function (handler) {
        this._unListen('onSocketTaskMessage', handler);
    };
    BridgeWebSocketTask.prototype.onOpen = function (handler) {
        this._listen('onSocketTaskOpen', handler);
    };
    BridgeWebSocketTask.prototype.offOpen = function (handler) {
        this._unListen('onSocketTaskOpen', handler);
    };
    return BridgeWebSocketTask;
}());
var connectSocket$1 = {
    fnOptionIndex: 0,
    fn: function (opt) {
        var success = opt.success, fail = opt.fail, complete = opt.complete, __taskIdPrefix = opt.__taskIdPrefix, rest = __rest(opt, ["success", "fail", "complete", "__taskIdPrefix"]);
        var callback = extractBridgeCallback(success, fail, complete, true);
        if (!opt.multiple) {
            this.callScopedBridge('connectSocket', __assign({}, opt), callback);
        }
        else {
            var task = new BridgeWebSocketTask(this.getEnvAppId(), this.runtime, functionBind(this.callScopedBridge, this), __taskIdPrefix);
            this.callScopedBridge('connectSocket', __assign(__assign({}, rest), task._getParams()), callback);
            return task;
        }
    },
};
var sendSocketMessage$1 = {};
var closeSocket$1 = {};
var onSocketOpen$1 = {};
var offSocketOpen$1 = {};
var onSocketMessage$1 = {};
var offSocketMessage$1 = {};
var onSocketError$1 = {};
var offSocketError$1 = {};
var onSocketClose$1 = {};
var offSocketClose$1 = {};

var isSpeechRecognizeAvailable$1 = {
    m: 'isSpeechAvailable',
};
var startSpeechRecognize$1 = {
    m: 'startSpeech',
};
var stopSpeechRecognize$1 = {
    m: 'stopSpeech',
};

var preloadCanvasImage$1 = {
    a: function (finalResult) {
        var data = finalResult.data;
        if (data) {
            var ret_1 = {
                loaded: {},
                failed: {},
            };
            data.forEach(function (img) {
                if (img.id === -1) {
                    ret_1.failed[img.url] = img;
                }
                else {
                    ret_1.loaded[img.url] = img;
                }
            });
            return ret_1;
        }
        else {
            return {
                loaded: {},
                failed: {},
            };
        }
    },
};

var reportAnalytics$1 = {
    fnOptionIndex: false,
    fn: function (eventName, data) {
        var _a = this.runtime().getEnv().originalStartupParams, appId = _a.appId, chInfo = _a.chInfo, _b = _a.cdpchinfo, cdpchinfo = _b === void 0 ? '' : _b, _c = _a.scm, scm = _c === void 0 ? '' : _c;
        var param4 = __assign(__assign({}, data), { SDKVersion: kAppxVersion, appId: appId, cdpchinfo: cdpchinfo, chInfo: chInfo, scm: scm });
        if (isAppxDomain4Extension(this.appxDomain)) {
            param4._host_appId = appId;
            param4.appId = this.appxDomain.origin;
        }
        this.callDefaultBridge('remoteLog', {
            spmId: eventName,
            param4: escapeLogParams(param4),
            type: 'behavior',
            bizType: this.getEnvAppBiz(),
            actionId: 'event',
            logLevel: 1,
        });
        // TODO: emit到new-tracker逻辑等埋点NPM包模块合并再实现
    },
};

var kCacheTimeout4GetSystemInfo = 60000;
var cacheOfGetSystemInfo = {
    key: 'jsApi_systemInfo',
    public: true,
    get: function (persistInfo, finalOption) {
        // 不是首页 或者 needCache 为 false，不走缓存流程
        if (!finalOption.isAppFirstPage || finalOption.needCache === false) {
            return;
        }
        if (!persistInfo.refreshTime) {
            persistInfo.refreshTime = Date.now();
        }
        if (persistInfo.cache && Date.now() - persistInfo.refreshTime < kCacheTimeout4GetSystemInfo) {
            return __assign({}, persistInfo.cache);
        }
    },
    update: function (persistInfo, finalOption, rawResult) {
        if (rawResult && typeof rawResult === 'object' && !('error' in rawResult)) {
            // 有效数据才进行缓存
            persistInfo.cache = __assign({}, rawResult);
            persistInfo.refreshTime = Date.now();
        }
    },
};

function createSystemInfoProxy4Android(target, userAgent, startupParams, getResponseAsync, getResponseSync, disableGetWidthFromUA, extraInfo) {
    var response;
    var cache = Object.create(null);
    function tryFetchResponse(target, reason) {
        if (!response) {
            var extraCache = extraInfo ? extraInfo["systemInfoLegacyTaskCache" /* EBridgeExtraInfoKey.systemInfoLegacyTaskCache */] : null;
            var res = void 0;
            if (extraCache) {
                res = parseJSON(extraCache);
            }
            else {
                res = getResponseSync(reason);
                if (res) {
                    if (extraInfo) {
                        extraInfo["systemInfoLegacyTaskCache" /* EBridgeExtraInfoKey.systemInfoLegacyTaskCache */] = stringifyJSON(res);
                    }
                }
            }
            if (res) {
                response = __assign(__assign({}, res), cache);
            }
            else {
                response = __assign({ error: 999, errorMessage: "System Error: Return ".concat(res) }, cache);
            }
            Object.assign(target, response);
        }
        return response;
    }
    if (extraInfo && extraInfo["systemInfoLegacyTaskCache" /* EBridgeExtraInfoKey.systemInfoLegacyTaskCache */]) {
        // ignore async
        response = parseJSON(extraInfo["systemInfoLegacyTaskCache" /* EBridgeExtraInfoKey.systemInfoLegacyTaskCache */]);
    }
    else {
        getResponseAsync(function (res) {
            if (res && !response) {
                // remove when async callback return
                // keep cache avaliable in macrotask
                if (extraInfo) {
                    extraInfo["systemInfoLegacyTaskCache" /* EBridgeExtraInfoKey.systemInfoLegacyTaskCache */] = undefined;
                }
                response = __assign(__assign({}, res), cache);
                Object.assign(target, response);
            }
        });
    }
    function getDirectValue(p) {
        switch (p) {
            case "app" /* ESystemInfoProperty.app */:
                return 'alipay';
            case "isIphoneXSeries" /* ESystemInfoProperty.isIphoneXSeries */:
                return false;
            case "platform" /* ESystemInfoProperty.platform */:
                return 'Android';
            case "platformType" /* ESystemInfoProperty.platformType */:
                return 'ap';
            case "titleBarHeight" /* ESystemInfoProperty.titleBarHeight */:
                return 48;
            case "language" /* ESystemInfoProperty.language */:
            case "pixelRatio" /* ESystemInfoProperty.pixelRatio */:
            case "screenWidth" /* ESystemInfoProperty.screenWidth */:
            case "version" /* ESystemInfoProperty.version */:
            case "system" /* ESystemInfoProperty.system */:
            case "windowWidth" /* ESystemInfoProperty.windowWidth */: {
                // 看 UA 是否存在
                var info = getUserAgentInfo(userAgent, disableGetWidthFromUA);
                if (info[p]) {
                    return info[p];
                }
                break;
            }
            case "apiLevel" /* ESystemInfoProperty.apiLevel */:
            case "model" /* ESystemInfoProperty.model */:
            case "brand" /* ESystemInfoProperty.brand */:
            case "statusBarHeight" /* ESystemInfoProperty.statusBarHeight */:
                {
                    // 看 _preset_systeminfo 数据
                    var info = getPreset(startupParams);
                    if (info[p]) {
                        return info[p];
                    }
                }
                break;
        }
    }
    return {
        defineProperty: function (target, p, attributes) {
            return Reflect.defineProperty(tryFetchResponse(target, "defineProperty:".concat(typeof p === 'symbol' ? p.toString() : p)), p, attributes);
        },
        deleteProperty: function (target, p) {
            return Reflect.deleteProperty(tryFetchResponse(target, "deleteProperty:".concat(typeof p === 'symbol' ? p.toString() : p)), p);
        },
        getOwnPropertyDescriptor: function (target, p) {
            if (response && response[p] !== undefined) {
                return Reflect.getOwnPropertyDescriptor(response, p);
            }
            if (p in cache) {
                return Reflect.getOwnPropertyDescriptor(cache, p);
            }
            var value = getDirectValue(p);
            if (value !== undefined) {
                return {
                    configurable: true,
                    enumerable: true,
                    value: value,
                    writable: true,
                };
            }
            return Reflect.getOwnPropertyDescriptor(tryFetchResponse(target, "getOwnPropertyDescriptor:".concat(typeof p === 'symbol' ? p.toString() : p)), p);
        },
        isExtensible: function (target) {
            return Reflect.isExtensible(tryFetchResponse(target, 'isExtensible'));
        },
        preventExtensions: function (target) {
            return Reflect.preventExtensions(tryFetchResponse(target, 'preventExtensions'));
        },
        getPrototypeOf: function (target) {
            return Reflect.getPrototypeOf(tryFetchResponse(target, 'getPrototypeOf'));
        },
        setPrototypeOf: function (target, v) {
            return Reflect.setPrototypeOf(tryFetchResponse(target, 'setPrototypeOf'), v);
        },
        has: function (target, p) {
            return Reflect.has(tryFetchResponse(target, "has:".concat(typeof p === 'symbol' ? p.toString() : p)), p);
        },
        get: function (target, p) {
            if (p === '__proto__') {
                return Object.prototype;
            }
            if (p === 'constructor') {
                return Object;
            }
            if (response && response[p] !== undefined) {
                return response[p];
            }
            if (p in cache) {
                return cache[p];
            }
            var value = getDirectValue(p);
            if (value !== undefined) {
                return value;
            }
            var str = p;
            if (typeof p === 'symbol') {
                if (typeof Symbol === 'function' && p === Symbol.toStringTag) {
                    return 'Object';
                }
                str = p.toString();
            }
            return tryFetchResponse(target, "get:".concat(str))[p];
        },
        ownKeys: function (target) {
            return Reflect.ownKeys(tryFetchResponse(target, 'ownKeys'));
        },
        set: function (target, p, v) {
            if (response) {
                response[p] = v;
                target[p] = v;
            }
            else {
                cache[p] = v;
            }
            return true;
        },
    };
}
/**
 *
 * @param startupParams
 * @example {
 *   _preset_systeminfo: "{"build_board":"sdm845","build_manufacturer":"OnePlus","build_model":"ONEPLUS A6000","build_sdk_int":29,"statusBarHeight":30.47619,"titleBarHeight":48}"
 * }
 */
function getPreset(startupParams) {
    var ret = {};
    if (startupParams && startupParams._preset_systeminfo) {
        try {
            var _a = parseJSON(startupParams._preset_systeminfo), build_brand = _a.build_brand, build_manufacturer = _a.build_manufacturer, build_model = _a.build_model, build_sdk_int = _a.build_sdk_int, statusBarHeight = _a.statusBarHeight;
            if (typeof build_manufacturer === 'string' && typeof build_model === 'string') {
                ret.model = "".concat(build_manufacturer, " ").concat(build_model);
            }
            if (typeof build_sdk_int === 'number') {
                ret.apiLevel = build_sdk_int;
            }
            if (typeof build_brand === 'string') {
                ret.brand = build_brand;
            }
            if (typeof statusBarHeight === 'number') {
                ret.statusBarHeight = Math.floor(statusBarHeight);
            }
        }
        catch (_) { }
    }
    return ret;
}
/**
 *
 * @param ua
 * @example "Mozilla/5.0 (Linux; U; Android 10; zh-CN; ONEPLUS A6000 Build/QKQ1.190716.003) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/69.0.3497.100 UWS/3.22.2.17 Mobile Safari/537.36 UCBS/3.22.2.19_210719105448 Region/CN AlipayDefined(nt:WIFI,ws:411|0|2.625) AliApp(AP/10.2.30.7001) AlipayClient/10.2.30.7001 Language/zh-Hans isConcaveScreen/true ProductType/dev Ariver/1.0.0"
 * @returns
 */
function getUserAgentInfo(ua, disableGetWidthFromUA) {
    var ret = {};
    // Language/zh-Hans
    var langMatch = ua.match(/Language\/(\S+)/);
    if (langMatch) {
        ret.language = langMatch[1];
    }
    // AlipayDefined(nt:WIFI,ws:360|0|3.0)
    var screenMatch = ua.match(/AlipayDefined\(.*ws:(\d+(?:\.\d+)?)\|(\d+(?:\.\d+)?)\|(\d+(?:\.\d+)?)/);
    if (screenMatch) {
        var pixelRatio = parseFloat(screenMatch[3]);
        var width = parseInt(screenMatch[1]);
        if (!isNaN(pixelRatio)) {
            ret.pixelRatio = pixelRatio;
            if (!isNaN(width) && !disableGetWidthFromUA) {
                ret.windowWidth = width;
                ret.screenWidth = Math.floor(width * pixelRatio + 0.5);
            }
        }
    }
    // AlipayClient/10.2.28.1769
    var versionMatch = ua.match(/AlipayClient\/(\S+)/);
    if (versionMatch) {
        ret.version = versionMatch[1];
    }
    var androidSystemMatch = ua.match(/;\s?Android\s(\d+);/);
    if (androidSystemMatch) {
        ret.system = androidSystemMatch[1];
    }
    return ret;
}

var getSystemInfo$1 = {
    m: 'getSystemInfo',
    cache: cacheOfGetSystemInfo,
    b: function (option) {
        var runtime = this.runtime();
        var nav = runtime.getNav();
        option.isAppFirstPage = nav.isFirstPage();
    },
    a: function (res) {
        afterProcess4SystemInfo(res);
    },
    responseProxy: function (finalOption, getResponseSync, getResponseAsync) {
        if (!canUseProxy()) {
            // 不支持 Proxy 时关闭代理
            return;
        }
        // iOS 先不搞， Devtool + Proxy + mutex 死锁了。。
        var factory = this.getEnvPlatformAndroid() ? createSystemInfoProxy4Android : undefined;
        if (!factory) {
            return;
        }
        var runtime = this.runtime();
        if (runtime.getEnv().clientName !== 'ap') {
            return;
        }
        var target = {};
        var disableGetWidthFromUA = this.getFlag("disableGetWidthFromUA" /* EBridgeFlagName.DisableGetWidthFromUA */);
        var disableSystemInfoTaskCache = this.getFlag("disableSystemInfoTaskCache282" /* EBridgeFlagName.DisableSystemInfoTaskCache282 */);
        var proxyedTarget = new Proxy(target, factory(target, runtime.getEnv().userAgent, runtime.getEnv().originalStartupParams, function (cb) {
            if (runtime.getEnv().originalStartupParams.profileEnable) {
                finalOption.__reason = 'async';
            }
            return getResponseAsync(cb);
        }, function (reason) {
            if (runtime.getEnv().originalStartupParams.profileEnable) {
                finalOption.__reason = reason;
            }
            return getResponseSync();
        }, disableGetWidthFromUA, disableSystemInfoTaskCache ? undefined : this.getBridgeExtraInfo()));
        return proxyedTarget;
    },
};
function afterProcess4SystemInfo(res) {
    var pixelRatio = 'pixelRatio';
    var windowWidth = 'windowWidth';
    var windowHeight = 'windowHeight';
    var language = 'language';
    var isIphoneXSeries = 'isIphoneXSeries';
    if (!('error' in res)) {
        res[pixelRatio] = toType('%f', res[pixelRatio]);
        res[windowWidth] = toType('%d', res[windowWidth]);
        res[language] = (res[language] || '').replace(/\s?\w+\/((?:\w|-)+)$/, '$1');
        res[windowHeight] = toType('%d', res[windowHeight]);
        res[isIphoneXSeries] = iphoneXSeriesIdentify(res['screenHeight']);
    }
}

function callBridgeSync(res, callScopedBridgeSync, jsapiName, params, cache, updateCache, item, report) {
    var result = callScopedBridgeSync(jsapiName, params);
    if (!result) {
        // 上报 同步调用超时
        if (report) {
            report('getSystemInfo-ownKeys-callSyncTimeout', { jsapiName: jsapiName, params: params, result: result });
        }
        res.error = 999;
        res.errorMessage = "System Error: Return ".concat(result);
        result = {
            error: 999,
            errorMessage: "System Error: Return ".concat(result),
        };
        if (item) {
            result[item] = undefined;
        }
        else {
            var _a = params.options, options = _a === void 0 ? [] : _a;
            options.forEach(function (key) {
                result[key] = undefined;
            });
        }
    }
    updateCache(result, cache);
}
function getAll(res, callScopedBridgeSync, jsapiName, opt, allOptions, cache, updateCache, profileEnable, report) {
    var noCachedOpts = allOptions.filter(function (key) { return !cache.hasOwnProperty(key); });
    if (noCachedOpts.length > 0) {
        var params = __assign(__assign({}, opt), { options: noCachedOpts });
        if (profileEnable) {
            params.__reason = 'ownKeys';
        }
        callBridgeSync(res, callScopedBridgeSync, jsapiName, params, cache, updateCache, undefined, report);
    }
}

// 将 getAppAuthorizeSetting 接口的返回参数作映射，其中 overlayAuthorized 字段不作转化
var keys2Exchange = [
    'cameraAuthorized',
    'locationAuthorized',
    'microphoneAuthorized',
    'notificationAuthorized',
    'albumAuthorized',
    'bluetoothAuthorized',
    'notificationAlertAuthorized',
    'notificationBadgeAuthorized',
    'notificationSoundAuthorized',
];
var EAppAuthorizeSettingRes;
/*#__PURE__*//*#__PURE__*/(function (EAppAuthorizeSettingRes) {
    EAppAuthorizeSettingRes["Authorized"] = "authorized";
    EAppAuthorizeSettingRes["Denied"] = "denied";
    EAppAuthorizeSettingRes["NotDetermined"] = "not determined";
})(EAppAuthorizeSettingRes || (EAppAuthorizeSettingRes = {}));
function privateProxy(opts, callScopedBridgeSync, profileEnable) {
    var res = {};
    var cache = {};
    opts.forEach(function (item) {
        Object.defineProperty(res, item, {
            configurable: true,
            enumerable: true,
            get: function () {
                if (!cache.hasOwnProperty(item)) {
                    var params = { options: [item] };
                    callBridgeSync(res, callScopedBridgeSync, "getSystemInfo" /* NativeAPI.getSystemInfo */, params, cache, updateCacheWithExchange, item);
                }
                return cache[item];
            },
            set: function (newVal) {
                cache[item] = newVal;
                return true;
            },
        });
    });
    if (canUseProxy()) {
        return new Proxy(res, {
            ownKeys: function (target) {
                getAll(target, callScopedBridgeSync, "getSystemInfo" /* NativeAPI.getSystemInfo */, {}, opts, cache, updateCacheWithExchange, profileEnable);
                return Reflect.ownKeys(target);
            },
        });
    }
    else {
        return res;
    }
}
function updateCacheWithExchange(result, cache) {
    Object.keys(result).forEach(function (key) {
        if (keys2Exchange.indexOf(key) > -1 && typeof result[key] === 'boolean') {
            // false 包含 请求授权被拒绝(denied) 和 尚未请求授权(non determined) 两种情况
            cache[key] = result[key] === true ? EAppAuthorizeSettingRes.Authorized : EAppAuthorizeSettingRes.Denied;
        }
        else {
            cache[key] = result[key];
        }
    });
}

var getAppAuthorizeSetting$1 = {
    fnOptionIndex: false,
    fn: function () {
        var platform = this.runtime().getEnv().platform;
        var opts = buildOptions$1(platform);
        var callScopedBridgeSync = functionBind(this.callScopedBridgeSync, this);
        return privateProxy(opts, callScopedBridgeSync);
    },
};
var EProperty4AppAuthorizeSetting;
/*#__PURE__*//*#__PURE__*/(function (EProperty4AppAuthorizeSetting) {
    EProperty4AppAuthorizeSetting["cameraAuthorized"] = "cameraAuthorized";
    EProperty4AppAuthorizeSetting["locationAuthorized"] = "locationAuthorized";
    EProperty4AppAuthorizeSetting["microphoneAuthorized"] = "microphoneAuthorized";
    EProperty4AppAuthorizeSetting["notificationAuthorized"] = "notificationAuthorized";
    //ios only
    EProperty4AppAuthorizeSetting["albumAuthorized"] = "albumAuthorized";
    EProperty4AppAuthorizeSetting["bluetoothAuthorized"] = "bluetoothAuthorized";
    EProperty4AppAuthorizeSetting["notificationAlertAuthorized"] = "notificationAlertAuthorized";
    EProperty4AppAuthorizeSetting["notificationBadgeAuthorized"] = "notificationBadgeAuthorized";
    EProperty4AppAuthorizeSetting["notificationSoundAuthorized"] = "notificationSoundAuthorized";
    //android only
    EProperty4AppAuthorizeSetting["overlayAuthorized"] = "overlayAuthorized";
})(EProperty4AppAuthorizeSetting || (EProperty4AppAuthorizeSetting = {}));
function buildOptions$1(platform) {
    var opts = [
        EProperty4AppAuthorizeSetting.cameraAuthorized,
        EProperty4AppAuthorizeSetting.locationAuthorized,
        EProperty4AppAuthorizeSetting.microphoneAuthorized,
        EProperty4AppAuthorizeSetting.notificationAuthorized,
    ];
    if (platform === 'ios') {
        opts.push(EProperty4AppAuthorizeSetting.bluetoothAuthorized, EProperty4AppAuthorizeSetting.albumAuthorized, EProperty4AppAuthorizeSetting.notificationAlertAuthorized, EProperty4AppAuthorizeSetting.notificationBadgeAuthorized, EProperty4AppAuthorizeSetting.notificationSoundAuthorized);
    }
    else if (platform === 'android') {
        opts.push(EProperty4AppAuthorizeSetting.overlayAuthorized);
    }
    return opts;
}

var getSystemSetting$1 = {
    fnOptionIndex: false,
    fn: function () {
        var opts = buildOptions();
        var callScopedBridgeSync = functionBind(this.callScopedBridgeSync, this);
        return privateProxy(opts, callScopedBridgeSync);
    },
};
var EProperty4SystemSetting;
/*#__PURE__*//*#__PURE__*/(function (EProperty4SystemSetting) {
    EProperty4SystemSetting["wifiEnabled"] = "wifiEnabled";
    EProperty4SystemSetting["bluetoothEnabled"] = "bluetoothEnabled";
    EProperty4SystemSetting["locationEnabled"] = "locationEnabled";
})(EProperty4SystemSetting || (EProperty4SystemSetting = {}));
function buildOptions() {
    var opts = [
        EProperty4SystemSetting.wifiEnabled,
        EProperty4SystemSetting.bluetoothEnabled,
        EProperty4SystemSetting.locationEnabled,
    ];
    return opts;
}

var cacheOfGetUserInfo = {
    key: 'jsApi_userInfo',
    public: true,
    get: function (persistInfo, finalOption) {
        if (persistInfo.cache) {
            return __assign({}, persistInfo.cache);
        }
    },
    update: function (persistInfo, finalOption, rawResult) {
        if (rawResult && typeof rawResult === 'object' && !('error' in rawResult)) {
            // 有效数据才进行缓存
            persistInfo.cache = __assign({}, rawResult);
        }
    },
};

function getLaunchOptionEmpty(callContext) {
    var extraInfo = callContext.getBridgeExtraInfo();
    var launchOptionEmpty = extraInfo["launchOptionsEmpty" /* EBridgeExtraInfoKey.launchOptionsEmpty */];
    if (!launchOptionEmpty) {
        launchOptionEmpty = extraInfo["launchOptionsEmpty" /* EBridgeExtraInfoKey.launchOptionsEmpty */] = {
        // 保持和 1.0 一样的行为，同一个空对象
        };
    }
    return launchOptionEmpty;
}
function getEnterOptionsSync(context) {
    var app = context.runtime().getApp();
    if (app) {
        if (context.getFlag("enterOptionsSkipResume" /* EBridgeFlagName.EnterOptionsSkipResume */)) {
            var enterOptions = app.getEnterOptions();
            if (enterOptions) {
                return enterOptions.getDataForScope(context.appxDomain);
            }
            else {
                return getLaunchOptionEmpty(context);
            }
        }
        var resumeOptions = app.getResumeOptions();
        if (resumeOptions) {
            return resumeOptions.getDataForScope(context.appxDomain);
        }
        var launchOptions = app.getLaunchOptions();
        if (launchOptions) {
            return launchOptions.getDataForScope(context.appxDomain);
        }
    }
    return getLaunchOptionEmpty(context);
}
function getLaunchOptionsSync(context) {
    var app = context.runtime().getApp();
    if (app) {
        var launchOptions = app.getLaunchOptions();
        if (launchOptions) {
            return launchOptions.getDataForScope(context.appxDomain);
        }
    }
    return getLaunchOptionEmpty(context);
}
function getMiniTraceInfo(options) {
    var referrerInfo = options.referrerInfo;
    if (referrerInfo &&
        referrerInfo.extraData &&
        typeof referrerInfo.extraData === 'object' &&
        referrerInfo.extraData.miniTraceInfo) {
        return referrerInfo.extraData.miniTraceInfo;
    }
    return null;
}
var tradePay$1 = {
    topNS: true,
    d: function (opt, resolve) {
        var _this = this;
        var enableTradePayIntercept = this.getFlag("enableTradePayIntercept" /* EBridgeFlagName.EnableTradePayIntercept */);
        var tradePayInterceptTargetClientVersion = this.getFlag("tradePayInterceptTargetClientVersion" /* EBridgeFlagName.TradePayInterceptTargetClientVersion */);
        // 拦截开关未打开
        if (!enableTradePayIntercept) {
            this.callScopedBridge("tradePay" /* NativeAPI.tradePay */, opt, resolve);
        }
        else {
            var env = this.runtime().getEnv();
            var clientVersionSequence = env.clientVersionSequence, clientVersion = env.clientVersion;
            // 拉到开关并且大于等于目标版本，那么就不增加额外处理
            if (tradePayInterceptTargetClientVersion && clientVersionSequence >= tradePayInterceptTargetClientVersion) {
                this.callScopedBridge("tradePay" /* NativeAPI.tradePay */, opt, resolve);
                return;
            }
            var enterOptions = getEnterOptionsSync(this);
            var launchOptions = getLaunchOptionsSync(this);
            var launchOptionsReferrerInfoMiniTraceInfo = getMiniTraceInfo(launchOptions);
            var enterOptionsReferrerInfoMiniTraceInfo = getMiniTraceInfo(enterOptions);
            var miniTraceInfo = enterOptionsReferrerInfoMiniTraceInfo || launchOptionsReferrerInfoMiniTraceInfo;
            var referrerInfoFromLaunchOptions = launchOptions.referrerInfo;
            var referrerInfoFromEnterOptions = enterOptions.referrerInfo;
            var referrerInfo = referrerInfoFromEnterOptions || referrerInfoFromLaunchOptions || {};
            var path = enterOptions.path || launchOptions.path;
            var query = enterOptions.query || launchOptions.query;
            var scene = enterOptions.scene || launchOptions.scene;
            if (miniTraceInfo) {
                var lastHopAppId = referrerInfo.appId;
                var _a = env.originalStartupParams, _b = _a.chInfo, chInfo = _b === void 0 ? '' : _b, hostAppId_1 = _a.appId;
                this.callInternalAPI('appxrpc', {
                    operationType: "alipay.openservice.mini.service.pretrade.decision" /* ESharedRPCOperationType4AppxInternal.API_TRADE_PAY */,
                    timeout: 500,
                    requestData: [
                        {
                            hostAppId: hostAppId_1,
                            pluginAppId: isAppxDomain4Extension(this.appxDomain) ? this.appxDomain.origin : '',
                            bizInputMap: {
                                tradeNo: opt.tradeNO ? opt.tradeNO : null,
                                orderStr: opt.orderStr ? opt.orderStr : null,
                                actionStage: 'tradePay',
                            },
                            actionStage: 'tradePay',
                            miniTraceInfoValue: miniTraceInfo,
                            referrerInfo: referrerInfo,
                            page: path,
                            query: query,
                            lastHopAppId: lastHopAppId,
                            clientVersion: clientVersion,
                            appxVersion: kAppxVersion,
                            chInfo: chInfo,
                            sceneId: scene,
                        },
                    ],
                }, function (res) {
                    // appxrpc 返回的 error 透传
                    if (res.error || !res.success) {
                        _this.callScopedBridge("tradePay" /* NativeAPI.tradePay */, opt, resolve);
                        _this.callScopedBridge("remoteLog" /* NativeAPI.remoteLog */, {
                            actionId: 'event',
                            bizType: 'TINYAPP',
                            logLevel: 1,
                            param4: escapeLogParams({
                                appId: hostAppId_1,
                                type: 'tradePay',
                                error: res.error || res.resultMsg,
                            }),
                            seedId: 'appx.tradePay.intercept',
                            type: 'monitor',
                        });
                        return;
                    }
                    var tradeMode = res.tradeMode, interceptorMode = res.interceptorMode, channelId = res.channelId, decisionErrorCode = res.decisionErrorCode, logExtMap = res.logExtMap;
                    _this.callScopedBridge("remoteLog" /* NativeAPI.remoteLog */, {
                        actionId: 'event',
                        bizType: 'TINYAPP',
                        logLevel: 1,
                        param4: escapeLogParams({
                            appId: hostAppId_1,
                            type: 'tradePay',
                            tradeMode: tradeMode,
                            interceptorMode: interceptorMode,
                            channelId: channelId,
                            decisionErrorCode: decisionErrorCode,
                            logExtMap: logExtMap,
                        }),
                        seedId: 'appx.tradePay.intercept',
                        type: 'monitor',
                    });
                    if (tradeMode === 'TRADE_PLUGIN') {
                        if (interceptorMode === 'BLOCK') {
                            resolve({
                                error: 60002,
                                errorMessage: '该场景下订单创建方式错误',
                            });
                        }
                        else {
                            _this.callScopedBridge("tradePay" /* NativeAPI.tradePay */, opt, resolve);
                        }
                    }
                    else {
                        _this.callScopedBridge("tradePay" /* NativeAPI.tradePay */, opt, resolve);
                    }
                });
            }
            else {
                this.callScopedBridge("tradePay" /* NativeAPI.tradePay */, opt, resolve);
            }
        }
    },
};
var getUserInfo$1 = {
    a: function (res) {
        mapping(res, {
            iconUrl: 'avatar',
        });
    },
    cache: cacheOfGetUserInfo,
    topNS: true,
};
var getAuthCode$1 = {
    b: function (opt) {
        if (typeof opt.scopes === 'string') {
            opt.scopeNicks = [opt.scopes];
        }
        else if (Array.isArray(opt.scopes)) {
            opt.scopeNicks = opt.scopes;
        }
        else {
            opt.scopeNicks = ["auth_base" /* EGetAuthorizeScopeNicks.auth_base */];
        }
        delete opt.scopes;
    },
    a: function (res) {
        mapping(res, {
            authcode: 'authCode',
        });
    },
    topNS: true,
};
var getAuthUserInfo$1 = {
    a: function (res) {
        mapping(res, {
            nick: 'nickName',
            userAvatar: 'avatar',
        });
    },
    topNS: true,
};
var startZMVerify$1 = {
    d: function (opt, cb) {
        this.callScopedBridge('startBizService', {
            name: 'zm-service',
            param: stringifyJSON({
                bizNo: opt.bizNo,
                zmType: 'zm-verify',
            }),
        }, cb);
    },
    topNS: true,
};
var openSetting$1 = {
    topNS: true,
};
var getSetting$1 = {
    topNS: true,
};

// 注释都留着，等测试都通过了再删
var bizAppId = '20000021';
function deleteAB(opt) {
    if (opt.a) {
        delete opt.a;
    }
    if (opt.b) {
        delete opt.b;
    }
}
function makeOpt(opt, a, b) {
    return {
        appId: bizAppId,
        param: __assign({ a: a, b: b }, opt),
    };
}
var chooseAddress$1 = {
    b: function (opt) {
        return {
            name: 'shopping-address',
            param: stringifyJSON({
                sceneCode: 'TINY-APP',
            }),
        };
    },
    m: 'startBizService',
    topNS: true,
};
var openCardList$1 = {
    b: function (opt) {
        deleteAB(opt);
        return makeOpt(opt, 'lb', 'm');
    },
    m: 'startApp',
    // callback: false,
    topNS: true,
};
var openVoucherList$1 = {
    b: function (opt) {
        deleteAB(opt);
        return makeOpt(opt, 'lb', 'c');
    },
    m: 'startApp',
    // callback: false,
    topNS: true,
};
var openTicketList$1 = {
    b: function (opt) {
        deleteAB(opt);
        return makeOpt(opt, 'lb', 't');
    },
    m: 'startApp',
    // callback: false,
    topNS: true,
};
var openCardDetail$1 = {
    b: function (opt) {
        mapping(opt, {
            passId: 'p',
        });
        if (opt.b) {
            delete opt.b;
        }
        return {
            appId: bizAppId,
            param: __assign({ b: 'm' }, opt),
        };
    },
    m: 'startApp',
    // callback: false,
    topNS: true,
};
var openVoucherDetail$1 = {
    b: function (opt) {
        mapping(opt, {
            passId: 'p',
        });
        if (opt.b) {
            delete opt.b;
        }
        return {
            appId: bizAppId,
            param: __assign({ b: 'c' }, opt),
        };
    },
    m: 'startApp',
    // callback: false,
    topNS: true,
};
var openTicketDetail$1 = {
    b: function (opt) {
        mapping(opt, { passId: 'p' });
        if (opt.b) {
            delete opt.b;
        }
        return { appId: bizAppId, param: __assign({ b: 't' }, opt) };
    },
    m: 'startApp',
    // callback: false,
    topNS: true,
};
var openMerchantCardList$1 = {
    b: function (opt) {
        deleteAB(opt);
        return makeOpt(opt, 'lb', 'm');
    },
    m: 'startApp',
    // callback: false,
    topNS: true,
};
var openMerchantVoucherList$1 = {
    b: function (opt) {
        deleteAB(opt);
        return makeOpt(opt, 'lb', 'c');
    },
    m: 'startApp',
    // callback: false,
    topNS: true,
};
var openMerchantTicketList$1 = {
    b: function (opt) {
        deleteAB(opt);
        return makeOpt(opt, 'lb', 't');
    },
    m: 'startApp',
    // callback: false,
    topNS: true,
};
var navigateToCouponDetail$1 = {
    a: function (res) {
        if (res.resultStatus) {
            switch (res.resultStatus) {
                case '9000':
                    break;
                case '6001':
                    res.errorMessage = res.errMsg || '用户取消操作';
                    res.error = '6001';
                    break;
                case '6002':
                    res.errorMessage = res.errMsg || '网络异常';
                    res.error = '6002';
                    break;
                case '4000':
                    res.errorMessage = res.errMsg || '系统异常';
                    res.error = '4000';
                    break;
                default:
                    res.errorMessage = res.errMsg || '未知异常';
                    res.error = res.resultStatus;
                    break;
            }
            delete res.resultStatus;
            if (res.errMsg) {
                delete res.errMsg;
            }
        }
    },
    b: function (opt) {
        return {
            name: 'coupon-detail',
            param: stringifyJSON(opt),
        };
    },
    m: 'startBizService',
    topNS: true,
};
var paySignCenter$1 = {
    b: function (opt) {
        return {
            name: 'deduct',
            param: stringifyJSON({
                sign_params: opt.signStr,
            }),
        };
    },
    m: 'startBizService',
    topNS: true,
};
var zmCreditBorrow$1 = {
    b: function (opt) {
        return {
            name: 'zm-borrow',
            param: stringifyJSON(__assign({}, opt)),
        };
    },
    m: 'startBizService',
    topNS: true,
};
var textRiskIdentification$1 = {
    topNS: true,
};
var openCarService$1 = {
    v: function (opt) {
        if (!('serviceId' in opt)) {
            return {
                error: 2,
                errorMessage: 'serviceId is required',
            };
        }
        else if (typeof opt.serviceId === 'number') {
            return {
                error: 2,
                errorMessage: "serviceId is 'String' type",
            };
        }
    },
    b: function (opt) {
        switch (opt.serviceId) {
            case '0': // 保养服务
                opt.serviceId = 'CARLIFE016';
                break;
            case '1': // 爱车估值
                opt.serviceId = 'CARLIFE020';
                break;
            case '2': // 加油充值
                opt.serviceId = 'CARLIFE011';
                break;
        }
    },
    d: function (opt, resolve) {
        var _this = this;
        var doOpenCarService = function (addressCode, serviceId) {
            _this.callScopedBridge('startApp', {
                appId: '20000919',
                param: {
                    url: 'https://mycar-vbizplatformsit.alipay-eco.com/vbizplatform/category/index?cityCode=' +
                        addressCode +
                        '&serviceId=' +
                        serviceId,
                },
            });
        };
        if (opt.addressCode) {
            doOpenCarService(opt.addressCode, opt.serviceId);
        }
        else {
            this.callDefaultBridge('getCurrentLocation', {
                bizType: this.getEnvAppId(),
                cacheTimeout: 3600,
                requestType: 1,
            }, function (res) {
                if (res.error) {
                    res.error = 2;
                    res.errorMessage = 'addressCode is required';
                    resolve(res);
                }
                else {
                    doOpenCarService(res.cityAdcode, opt.serviceId);
                }
            });
        }
    },
    topNS: true,
};
var openChatWindow$1 = {
    v: function (opt) {
        if (!('userId' in opt)) {
            return {
                error: 2,
                errorMessage: 'userId is required',
            };
        }
        else if (typeof opt.userId !== 'string') {
            return {
                error: 2,
                errorMessage: "userId is 'String' type",
            };
        }
    },
    b: function (opt) {
        return {
            appId: '20000167',
            param: {
                returnAppId: 'back',
                tUserId: opt.userId,
                tUserType: '1',
            },
        };
    },
    m: 'startApp',
    topNS: true,
};
var startZMCreditRent$1 = {
    b: function (opt) {
        return {
            name: 'credit-rent',
            param: stringifyJSON(__assign({ creditRentType: 'rent' }, opt)),
        };
    },
    m: 'startBizService',
    topNS: true,
};
var zmRentTransition$1 = {
    b: function (opt) {
        return {
            name: 'rent-transition',
            param: stringifyJSON(__assign({ creditRentType: 'signPay' }, opt)),
        };
    },
    m: 'startBizService',
    topNS: true,
};
var chooseInvoiceTitle$1 = {
    d: function (opt, resolve) {
        this.callScopedBridge('startBizService', {
            name: 'invoice-title',
            param: stringifyJSON(opt),
        }, resolve);
    },
    topNS: true,
};
var zmFreeDeposit$1 = {
    d: function (opt, resolve) {
        this.callScopedBridge('startBizService', {
            name: 'zmep-freedeposit',
            param: stringifyJSON(opt),
        }, resolve);
    },
    topNS: true,
};
function checkPermission(callBridge, url, cb) {
    var reg = /^(\w+):\/\//;
    callBridge('configService.getConfig', {
        configKey: 'APPX_OPENTAOBAO_IN_BROWSER',
    }, function (res) {
        var perError = {
            error: 4,
            errorMessage: '无权调用该接口',
        };
        if (res.configKey) {
            var config = void 0;
            try {
                config = parseJSON(res.configKey);
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
            }
            var hasPermission = false;
            if (Array.isArray(config)) {
                if (url) {
                    var urlMatch = url.match(reg);
                    var scheme = urlMatch && urlMatch[1];
                    if ((scheme && config.indexOf(scheme) > -1) || config.indexOf('*') > -1) {
                        hasPermission = true;
                    }
                }
            }
            if (hasPermission) {
                cb({ success: true });
            }
            else {
                cb(perError);
            }
            // 拉不到开关值，认为是有权限
        }
        else {
            cb({ success: true });
        }
    });
}
var openTaobao$1 = {
    d: function (finalOpt, resolve) {
        var _this = this;
        var isLite = finalOpt.isLite;
        this.callDefaultBridge('isInstalledApp', {
            packagename: isLite ? 'com.taobao.litetao' : 'com.taobao.taobao',
            scheme: isLite ? 'taobaolite://' : 'taobao://',
        }, function (result) { return __awaiter(_this, void 0, void 0, function () {
            var url, login, hasPermission, downloadUrl;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = finalOpt.url;
                        login = finalOpt.login;
                        if (!('installed' in result)) return [3 /*break*/, 2];
                        return [4 /*yield*/, new Promise(function (resolve) {
                                return checkPermission(functionBind(_this.callDefaultBridge, _this), finalOpt.url, resolve);
                            })];
                    case 1:
                        hasPermission = _a.sent();
                        if (hasPermission.error) {
                            return [2 /*return*/];
                        }
                        if (result.installed) {
                            if (login) {
                                this.callDefaultBridge('getLoginToken', {}, function (res) {
                                    var loginToken = null;
                                    var encrypted = false;
                                    if ('token' in res && res.token !== '') {
                                        loginToken = res.token;
                                        encrypted = res.encrypted;
                                    }
                                    if (loginToken) {
                                        url += "&loginToken=".concat(loginToken, "&tokenEncrypted=").concat(encrypted);
                                    }
                                    _this.callDefaultBridge('openInBrowser', {
                                        url: url,
                                    });
                                });
                            }
                            else {
                                this.callDefaultBridge('openInBrowser', {
                                    url: url,
                                });
                            }
                        }
                        else {
                            downloadUrl = isLite
                                ? 'https://pages.tmall.com/wow/sale/act/download-page-new'
                                : 'https://h5.m.taobao.com/bcec/downloadTaobao.html';
                            this.callDefaultBridge('openInBrowser', {
                                url: downloadUrl + (typeof finalOpt.extraQuery === 'string' ? '?' + finalOpt.extraQuery : ''),
                            });
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    },
    topNS: true,
};

var openOtherApplication$1 = {};

var addEventCal$1 = {};
var addEventCalendar$1 = {};
var isLowPowerMode$1 = {};

function createUpdateManager(runtime, bridgeCallContext) {
    bridgeCallContext.callScopedBridge('registerUpdateManager');
    return {
        applyUpdate: function (params) {
            bridgeCallContext.callDefaultBridge('applyUpdate', {
                params: params,
            });
        },
        onCheckForUpdate: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.addEventListener('checkForUpdate', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        onUpdateReady: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.addEventListener('updateReady', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        onUpdateFailed: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.addEventListener('updateFailed', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        offCheckForUpdate: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.removeEventListener('checkForUpdate', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        offUpdateReady: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.removeEventListener('updateReady', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        offUpdateFailed: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.removeEventListener('updateFailed', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
    };
}

var getUpdateManager$1 = {
    fnOptionIndex: false,
    fn: function () {
        return createUpdateManager(this.runtime, this);
    },
};

function getPayloadFromFrameRecordedEvent(e) {
    var payload = __assign({}, e.data);
    if (payload.frameBuffer && typeof payload.frameBuffer === 'string') {
        payload.frameBuffer = base64ToArrayBuffer(payload.frameBuffer);
    }
    return payload;
}
function getTaskIdFromFrameRecordedEvent(event, taskContext) {
    if (event.data.appInstanceId) {
        return [event.data.appInstanceId];
    }
    else {
        return Object.keys(taskContext.callbacks);
    }
}
var allowedFormats = ['aac', 'mp3'];
function createRecorderManager(runtime, bridgeCallContext) {
    return {
        start: function (params) {
            params = __assign({ format: 'aac' }, params);
            // https://baiyan.antfin.com/task/242484 兼容大小写
            params.format = params.format.toLowerCase();
            if (allowedFormats.indexOf(params.format) === -1) {
                bridgeCallContext.runtime().getEnv().packageAndRunSceneType;
                var errorMsg = 'format格式非法，允许的格式：' + allowedFormats.join('、');
                if (isConsoleAvaliableToDeveloper()) {
                    // eslint-disable-next-line
                    console.error(errorMsg);
                }
                throw new Error(errorMsg);
            }
            else {
                bridgeCallContext.callScopedBridge('startAudioRecord', params);
            }
        },
        stop: function (params) {
            bridgeCallContext.callScopedBridge('stopAudioRecord', __assign({}, params));
        },
        resume: function (params) {
            bridgeCallContext.callScopedBridge('resumeAudioRecord', __assign({}, params));
        },
        pause: function (params) {
            bridgeCallContext.callScopedBridge('pauseAudioRecord', __assign({}, params));
        },
        onStart: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.addEventListener('recordStart', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        onResume: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.addEventListener('recordResume', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        onStop: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.addEventListener('recordStop', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        onPause: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.addEventListener('recordPause', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        onError: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.addEventListener('recordError', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        onDecibelChange: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.addEventListener('recordDecibelChange', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        onFrameRecorded: function (callback) {
            var taskId = runtime().getApp().appInstanceId;
            var taskManager = bridgeCallContext.runtime().getBridge().event.taskManager;
            taskManager.addMatcher('recordFrameRecorded', taskId, callback, getTaskIdFromFrameRecordedEvent, getPayloadFromFrameRecordedEvent, true);
        },
        offDecibelChange: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.removeEventListener('recordDecibelChange', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        offPause: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.removeEventListener('recordPause', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        offResume: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.removeEventListener('recordResume', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        offStart: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.removeEventListener('recordStart', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        offStop: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.removeEventListener('recordStop', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        offError: function (callback) {
            var bridge = runtime().getBridge();
            bridge.event.removeEventListener('recordError', 2 /* EBridgeEventCustomTypeContext.UserData */, callback);
        },
        offFrameRecorded: function (callback) {
            var taskId = runtime().getApp().appInstanceId;
            var taskManager = bridgeCallContext.runtime().getBridge().event.taskManager;
            taskManager.removeMatcher('recordFrameRecorded', taskId, callback);
        },
    };
}

var getRecorderManager$1 = {
    fnOptionIndex: false,
    fn: function () {
        return createRecorderManager(this.runtime, this);
    },
};

var InnerAudioContext = /** @class */ /*#__PURE__*/ (function () {
    function InnerAudioContext(callContext, contextDefinition) {
        this._state = {};
        this.listenerCount = 0;
        var runtime = callContext.runtime();
        var appId = runtime.getEnv().startupParams.appId;
        var bridge = runtime.getBridge();
        var callBridge = functionBind(callContext.callDefaultBridge, callContext);
        var callBridgeSync = functionBind(callContext.callDefaultBridgeSync, callContext);
        var getEvent = function () { return callContext.runtime().getBridge().event; };
        var writes = contextDefinition.writes, reads = contextDefinition.reads, type = contextDefinition.type;
        this.writes = writes;
        this.reads = reads;
        this.type = type;
        var extraInfo = bridge.extraInfo;
        if (!extraInfo["innerAudioContextIdBase" /* EBridgeExtraInfoKey.innerAudioContextIdBase */]) {
            extraInfo["innerAudioContextIdBase" /* EBridgeExtraInfoKey.innerAudioContextIdBase */] = 1;
        }
        else {
            ++extraInfo["innerAudioContextIdBase" /* EBridgeExtraInfoKey.innerAudioContextIdBase */];
        }
        var taskId = extraInfo["innerAudioContextIdBase" /* EBridgeExtraInfoKey.innerAudioContextIdBase */];
        this.id = String(taskId);
        this.params = {
            audioPlayerID: this.id,
            bizIdentifier: appId,
        };
        var enableGetterFromState = callContext.getFlag("enableGetterFromState4Audio" /* EBridgeFlagName.EnableGetterFromState4Audio */);
        this.play = functionBind(this.play, this, callBridge);
        this.pause = functionBind(this.pause, this, callBridge);
        this.stop = functionBind(this.stop, this, callBridge);
        this.destroy = functionBind(this.destroy, this, callBridge);
        this.seek = functionBind(this.seek, this, callBridge);
        this._setter = functionBind(this.__setter, this, callBridge, runtime);
        this._getter = functionBind(enableGetterFromState ? this.__getterFromState : this.__getter, this, callBridgeSync);
        this._getFromNative = functionBind(this.__getFromNative, this, callBridgeSync);
        this._listen = functionBind(this.__listen, this, callBridge, getEvent);
        this._unListen = functionBind(this.__unListen, this, callBridge, getEvent);
        this.onCanPlay = this.onCanplay = functionBind(this._onCanPlay, this);
        this.offCanPlay = this.offCanplay = functionBind(this._offCanPlay, this);
    }
    InnerAudioContext.prototype.onPlay = function (callback) {
        this._listen('Play', callback);
    };
    InnerAudioContext.prototype.offPlay = function (callback) {
        this._unListen('Play', callback);
    };
    InnerAudioContext.prototype.onPause = function (callback) {
        this._listen('Pause', callback);
    };
    InnerAudioContext.prototype.offPause = function (callback) {
        this._unListen('Pause', callback);
    };
    InnerAudioContext.prototype.onStop = function (callback) {
        this._listen('Stop', callback);
    };
    InnerAudioContext.prototype.offStop = function (callback) {
        this._unListen('Stop', callback);
    };
    InnerAudioContext.prototype.onEnded = function (callback) {
        this._listen('Ended', callback);
    };
    InnerAudioContext.prototype.offEnded = function (callback) {
        this._unListen('Ended', callback);
    };
    InnerAudioContext.prototype.onTimeUpdate = function (callback) {
        this._listen('TimeUpdate', callback);
    };
    InnerAudioContext.prototype.offTimeUpdate = function (callback) {
        this._unListen('TimeUpdate', callback);
    };
    InnerAudioContext.prototype.onPrev = function (callback) {
        this._listen('Prev', callback);
    };
    InnerAudioContext.prototype.offPrev = function (callback) {
        this._unListen('Prev', callback);
    };
    InnerAudioContext.prototype.onNext = function (callback) {
        this._listen('Next', callback);
    };
    InnerAudioContext.prototype.offNext = function (callback) {
        this._unListen('Next', callback);
    };
    InnerAudioContext.prototype.onError = function (callback) {
        this._listen('Error', callback);
    };
    InnerAudioContext.prototype.offError = function (callback) {
        this._unListen('Error', callback);
    };
    InnerAudioContext.prototype.onWaiting = function (callback) {
        this._listen('Waiting', callback);
    };
    InnerAudioContext.prototype.offWaiting = function (callback) {
        this._unListen('Waiting', callback);
    };
    InnerAudioContext.prototype.onSeeking = function (callback) {
        this._listen('Seeking', callback);
    };
    InnerAudioContext.prototype.offSeeking = function (callback) {
        this._unListen('Seeking', callback);
    };
    InnerAudioContext.prototype.onSeeked = function (callback) {
        this._listen('Seeked', callback);
    };
    InnerAudioContext.prototype.offSeeked = function (callback) {
        this._unListen('Seeked', callback);
    };
    InnerAudioContext.prototype.play = function (callBridge) {
        callBridge("play".concat(this.type), __assign({ playWithNoParam: true }, this.params));
    };
    InnerAudioContext.prototype.pause = function (callBridge) {
        callBridge("pause".concat(this.type), __assign({ playWithNoParam: true }, this.params));
    };
    InnerAudioContext.prototype.stop = function (callBridge) {
        callBridge("stop".concat(this.type), __assign({ playWithNoParam: true }, this.params));
    };
    // destroyBackgroundAudio不存在， 可以destroyForegroundAudio
    InnerAudioContext.prototype.destroy = function (callBridge) {
        callBridge("stopMonitor".concat(this.type), this.params);
        callBridge("destroy".concat(this.type), __assign({ playWithNoParam: true }, this.params));
        // Object.keys(this.callBackMap).forEach(k => {
        //   ap.offUserEvent(k, this.callBackMap[k]);
        // });
    };
    InnerAudioContext.prototype.seek = function (callBridge, position) {
        callBridge("seek".concat(this.type), __assign(__assign({}, this.params), { position: position }));
    };
    InnerAudioContext.prototype._onCanPlay = function (callback) {
        this._listen('CanPlay', callback);
    };
    InnerAudioContext.prototype._offCanPlay = function (callback) {
        this._unListen('CanPlay', callback);
    };
    InnerAudioContext.prototype.__setter = function (callBridge, runtime, propName, value) {
        var _a;
        if (this.writes[propName] && this.writes[propName](value)) {
            runtime.getEnv().packageAndRunSceneType;
            if (isConsoleAvaliableToDeveloper()) {
                // eslint-disable-next-line no-console
                console.warn('传入的 %s 不符合 %s 的类型要求，请检查。', value, propName);
                return;
            }
        }
        this._state[propName] = value;
        callBridge("set".concat(this.type, "Option"), __assign(__assign({}, this.params), { option: (_a = {},
                _a[propName] = value,
                _a) }));
    };
    InnerAudioContext.prototype.__getter = function (callBridgeSync, propName) {
        var stateValue = this._state[propName];
        if (stateValue) {
            return stateValue;
        }
        return callBridgeSync("get".concat(this.type, "Option"), __assign(__assign({}, this.params), { optionName: propName }))[propName];
    };
    InnerAudioContext.prototype.__getterFromState = function (callBridgeSync, propName) {
        var stateValue = this._state[propName];
        if (this.writes[propName] && !this.writes[propName](stateValue)) {
            return stateValue;
        }
        return callBridgeSync("get".concat(this.type, "Option"), __assign(__assign({}, this.params), { optionName: propName }))[propName];
    };
    InnerAudioContext.prototype.__listen = function (callBridge, getEventManager, eventName, callback) {
        var methodName = "on".concat(this.type).concat(eventName);
        // if (!data.audioPlayerID || data.audioPlayerID === this.id) { 要判断一个audioPlayerID
        var addedListenerCount = getEventManager().taskManager.addMatcher(methodName, this.id, callback, getTaskIdFromAudioEvent, getPayloadFromAudioEvent);
        this.listenerCount += addedListenerCount;
        if (this.listenerCount === 1) {
            callBridge("startMonitor".concat(this.type), this.params);
        }
    };
    InnerAudioContext.prototype.__unListen = function (callBridge, getEventManager, eventName, callback) {
        var methodName = "on".concat(this.type).concat(eventName);
        var removedListenerCount = getEventManager().taskManager.removeMatcher(methodName, this.id, callback);
        this.listenerCount -= removedListenerCount;
        if (this.listenerCount === 0) {
            callBridge("stopMonitor".concat(this.type), this.params);
        }
    };
    InnerAudioContext.prototype.__getFromNative = function (callBridgeSync, propName) {
        return callBridgeSync("get".concat(this.type, "Option"), __assign(__assign({}, this.params), { optionName: propName }))[propName];
    };
    return InnerAudioContext;
}());
function getTaskIdFromAudioEvent(event, taskContext) {
    var data = event.data || {};
    if (data.audioPlayerID) {
        return [data.audioPlayerID];
    }
    else {
        return Object.keys(taskContext.callbacks);
    }
}
function getPayloadFromAudioEvent(event) {
    return event;
}
function getForegroundAudioConstructorImpl() {
    return /** @class */ (function (_super) {
        __extends(ForegroundAudioContext, _super);
        function ForegroundAudioContext(callContext) {
            var contextDefinition = {
                type: 'ForegroundAudio',
                writes: {
                    src: function (value) {
                        // eslint-disable-next-line
                        return 'string' != typeof value || 0 === value.length;
                    },
                    startTime: function (value) {
                        // eslint-disable-next-line
                        return 'number' != typeof value;
                    },
                    autoplay: function (value) {
                        // eslint-disable-next-line
                        return 'boolean' != typeof value;
                    },
                    loop: function (value) {
                        // eslint-disable-next-line
                        return 'boolean' != typeof value;
                    },
                    obeyMuteSwitch: function (value) {
                        // eslint-disable-next-line
                        return 'boolean' != typeof value;
                    },
                    volume: function (value) {
                        // eslint-disable-next-line
                        return 'number' != typeof value || value < 0 || value > 1 || isNaN(value);
                    },
                    // 10.1.62 肯定支持
                    isRecordAudioPlayState: function (value) {
                        // eslint-disable-next-line
                        return 'boolean' != typeof value;
                    },
                    playbackRate: function (value) {
                        // eslint-disable-next-line
                        return 'number' != typeof value || value < 0.5 || value > 2;
                    },
                    supportBackgroundPlay: function (value) {
                        // eslint-disable-next-line
                        return 'boolean' != typeof value;
                    },
                    ccode: function () { },
                },
                // reads: ['duration', 'currentTime', 'paused', 'buffered'],
                // config,
            };
            return _super.call(this, callContext, contextDefinition) || this;
        }
        Object.defineProperty(ForegroundAudioContext.prototype, "src", {
            get: function () {
                return this._getter('src');
            },
            set: function (value) {
                this._setter('src', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ForegroundAudioContext.prototype, "startTime", {
            get: function () {
                return this._getter('startTime');
            },
            set: function (value) {
                this._setter('startTime', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ForegroundAudioContext.prototype, "autoplay", {
            get: function () {
                return this._getter('autoplay');
            },
            set: function (value) {
                this._setter('autoplay', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ForegroundAudioContext.prototype, "loop", {
            get: function () {
                return this._getter('loop');
            },
            set: function (value) {
                this._setter('loop', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ForegroundAudioContext.prototype, "obeyMuteSwitch", {
            get: function () {
                return this._getter('obeyMuteSwitch');
            },
            set: function (value) {
                this._setter('obeyMuteSwitch', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ForegroundAudioContext.prototype, "volume", {
            get: function () {
                return this._getter('volume');
            },
            set: function (value) {
                this._setter('volume', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ForegroundAudioContext.prototype, "isRecordAudioPlayState", {
            get: function () {
                return this._getter('isRecordAudioPlayState');
            },
            set: function (value) {
                this._setter('isRecordAudioPlayState', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ForegroundAudioContext.prototype, "playbackRate", {
            get: function () {
                return this._getter('playbackRate');
            },
            set: function (value) {
                this._setter('playbackRate', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ForegroundAudioContext.prototype, "duration", {
            // 通用
            get: function () {
                return this._getFromNative('duration');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ForegroundAudioContext.prototype, "currentTime", {
            get: function () {
                return this._getFromNative('currentTime');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ForegroundAudioContext.prototype, "paused", {
            get: function () {
                return this._getFromNative('paused');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ForegroundAudioContext.prototype, "buffered", {
            get: function () {
                return this._getFromNative('buffered');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ForegroundAudioContext.prototype, "supportBackgroundPlay", {
            get: function () {
                return this._getter('supportBackgroundPlay');
            },
            set: function (value) {
                this._setter('supportBackgroundPlay', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ForegroundAudioContext.prototype, "ccode", {
            get: function () {
                return this._getter('ccode');
            },
            set: function (value) {
                this._setter('ccode', value);
            },
            enumerable: false,
            configurable: true
        });
        return ForegroundAudioContext;
    }(InnerAudioContext));
}
function getBackgroundAudioContextConstructorImpl() {
    return /** @class */ (function (_super) {
        __extends(BackgroundAudioContext, _super);
        function BackgroundAudioContext(callContext) {
            var contextDefinition = {
                type: 'BackgroundAudio',
                writes: {
                    src: function (value) {
                        // eslint-disable-next-line
                        return 'string' != typeof value || 0 === value.length;
                    },
                    startTime: function (value) {
                        // eslint-disable-next-line
                        return 'number' != typeof value; // eslint-disable-line
                    },
                    title: function () { },
                    epname: function () { },
                    singer: function () { },
                    coverImgUrl: function () { },
                    webUrl: function () { },
                    // 10.1.62 肯定支持
                    isRecordAudioPlayState: function (value) {
                        // eslint-disable-next-line
                        return 'boolean' != typeof value;
                    },
                    playbackRate: function (value) {
                        // eslint-disable-next-line
                        return 'number' != typeof value || value < 0.5 || value > 2;
                    },
                    ccode: function () { },
                },
                // reads: ['duration', 'currentTime', 'paused', 'buffered'],
                // config,
            };
            return _super.call(this, callContext, contextDefinition) || this;
        }
        Object.defineProperty(BackgroundAudioContext.prototype, "src", {
            get: function () {
                return this._getter('src');
            },
            set: function (value) {
                this._setter('src', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BackgroundAudioContext.prototype, "startTime", {
            get: function () {
                return this._getter('startTime');
            },
            set: function (value) {
                this._setter('startTime', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BackgroundAudioContext.prototype, "title", {
            get: function () {
                return this._getter('title');
            },
            set: function (value) {
                this._setter('title', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BackgroundAudioContext.prototype, "epname", {
            get: function () {
                return this._getter('epname');
            },
            set: function (value) {
                this._setter('epname', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BackgroundAudioContext.prototype, "singer", {
            get: function () {
                return this._getter('singer');
            },
            set: function (value) {
                this._setter('singer', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BackgroundAudioContext.prototype, "coverImgUrl", {
            get: function () {
                return this._getter('coverImgUrl');
            },
            set: function (value) {
                this._setter('coverImgUrl', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BackgroundAudioContext.prototype, "webUrl", {
            get: function () {
                return this._getter('webUrl');
            },
            set: function (value) {
                this._setter('webUrl', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BackgroundAudioContext.prototype, "isRecordAudioPlayState", {
            get: function () {
                return this._getter('isRecordAudioPlayState');
            },
            set: function (value) {
                this._setter('isRecordAudioPlayState', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BackgroundAudioContext.prototype, "playbackRate", {
            get: function () {
                return this._getter('playbackRate');
            },
            set: function (value) {
                this._setter('playbackRate', value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BackgroundAudioContext.prototype, "duration", {
            // 通用
            get: function () {
                return this._getFromNative('duration');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BackgroundAudioContext.prototype, "currentTime", {
            get: function () {
                return this._getFromNative('currentTime');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BackgroundAudioContext.prototype, "paused", {
            get: function () {
                return this._getFromNative('paused');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BackgroundAudioContext.prototype, "buffered", {
            get: function () {
                return this._getFromNative('buffered');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BackgroundAudioContext.prototype, "ccode", {
            get: function () {
                return this._getter('ccode');
            },
            set: function (value) {
                this._setter('ccode', value);
            },
            enumerable: false,
            configurable: true
        });
        return BackgroundAudioContext;
    }(InnerAudioContext));
}
var bgAudioCtxImplCache;
function getBackgroundAudioContextConstructor() {
    if (!bgAudioCtxImplCache) {
        bgAudioCtxImplCache = getBackgroundAudioContextConstructorImpl();
    }
    return bgAudioCtxImplCache;
}
var fgAudioCtxImplCache;
function getForegroundAudioContextConstructor() {
    if (!fgAudioCtxImplCache) {
        fgAudioCtxImplCache = getForegroundAudioConstructorImpl();
    }
    return fgAudioCtxImplCache;
}

var kBridgeExtraInfoKey4AudioManager = 'backgroundAudioManager';
// const kBridgeExtraInfoKey4AudioContext = 'innerAudioContext';
var getBackgroundAudioManager$1 = {
    fnOptionIndex: false,
    fn: function () {
        var bridge = this.runtime().getBridge();
        if (!bridge.extraInfo[kBridgeExtraInfoKey4AudioManager]) {
            bridge.extraInfo[kBridgeExtraInfoKey4AudioManager] = new (getBackgroundAudioContextConstructor())(this);
        }
        return bridge.extraInfo[kBridgeExtraInfoKey4AudioManager];
    },
};
var createInnerAudioContext$1 = {
    fnOptionIndex: false,
    fn: function () {
        return new (getForegroundAudioContextConstructor())(this);
    },
};

function verifyTabBarAPI4Customize(callContext, name) {
    var runtime = callContext.runtime();
    var page = callContext.getPageInstance();
    var isSupportCustomizeTabBar = isAppSupportCustomizeTabBar(runtime.getMeta().getTabBar(), runtime.getEnv().originalStartupParams);
    if (isSupportCustomizeTabBar && page && runtime.getMeta().isTabPage(page.pagePath)) {
        return {
            error: 1,
            errorMessage: "Currently using customize tabBar. The API [".concat(name, "] does not support!"),
        };
    }
}
var hideTabBar$1 = {
    m: 'setTabBar',
    b: function (opt) {
        opt.actionType = 'hideTabBar';
    },
    v: function () {
        return verifyTabBarAPI4Customize(this, 'hideTabBar');
    },
};
var showTabBar$1 = {
    m: 'setTabBar',
    b: function (opt) {
        opt.actionType = 'showTabBar';
    },
    v: function () {
        return verifyTabBarAPI4Customize(this, 'showTabBar');
    },
};
var setTabBarItem$1 = {
    m: 'setTabBar',
    b: function (opt) {
        opt.actionType = 'setTabBarItem';
    },
    v: function () {
        return verifyTabBarAPI4Customize(this, 'setTabBarItem');
    },
};
var setTabBarStyle$1 = {
    m: 'setTabBar',
    b: function (opt) {
        opt.actionType = 'setTabBarStyle';
    },
    v: function () {
        return verifyTabBarAPI4Customize(this, 'setTabBarStyle');
    },
};
var hideTabBarRedDot$1 = {
    m: 'setTabBar',
    b: function (opt) {
        opt.actionType = 'hideTabBarRedDot';
    },
    v: function () {
        return verifyTabBarAPI4Customize(this, 'hideTabBarRedDot');
    },
};
var showTabBarRedDot$1 = {
    m: 'setTabBar',
    b: function (opt) {
        opt.actionType = 'showTabBarRedDot';
    },
    v: function () {
        return verifyTabBarAPI4Customize(this, 'showTabBarRedDot');
    },
};
var removeTabBarBadge$1 = {
    m: 'setTabBar',
    b: function (opt) {
        opt.actionType = 'removeTabBarBadge';
    },
    v: function () {
        return verifyTabBarAPI4Customize(this, 'removeTabBarBadge');
    },
};
var setTabBarBadge$1 = {
    m: 'setTabBar',
    b: function (opt) {
        opt.actionType = 'setTabBarBadge';
    },
    v: function () {
        return verifyTabBarAPI4Customize(this, 'setTabBarBadge');
    },
};

var showFuCard$1 = {
    m: "AlipayNewYearNebulaPlugin.showFuCard" /* NativeAPI.AlipayNewYearNebulaPlugin$showFuCard */,
    ns: 'ap',
    in: ['fuCard', 'sourceType', 'hideToast'],
    out: ['toastViewDismiss', 'received'],
    // b(finalOption: Partial<INativeAPIRegistry[NativeAPI.AlipayNewYearNebulaPlugin$showFuCard]['request']
    //  & IMiniAPIRegistry[MiniAPI.ap$showFuCard]['request']>) {
    b: function (finalOption) {
        if (finalOption.fuCard) {
            finalOption.showFuCard = finalOption.fuCard;
            delete finalOption.fuCard;
        }
        return finalOption;
    },
    // a(res: Partial<INativeAPIRegistry[NativeAPI.AlipayNewYearNebulaPlugin$showFuCard]['response']
    //  & INativeAPIRegistry[NativeAPI.AlipayNewYearNebulaPlugin$showFuCard]['error'] & IMiniAPIRegistry[MiniAPI.ap$showFuCard]['response']>) {
    a: function (res) {
        // 确保无error字段或者error不为0
        if (res && (!res.error || res.error !== 0)) {
            res.received = res.success === 1 || res.success === 'YES' || res.success === true;
            delete res.success;
            res.toastViewDismiss = res.toastViewDimiss;
            delete res.toastViewDimiss;
        }
        return res;
    },
};
// export const removeFuCard: IBridgeInsideAPITypedInfo<MiniAPI.ap$removeFuCard> = {
//   m: 'AlipayNewYearNebulaPlugin.removeFuCard',
//   ns: 'ap',
// };
// export const addFuCard: IBridgeInsideAPITypedInfo<MiniAPI.ap$addFuCard> = {
//   m: 'AlipayNewYearNebulaPlugin.addFuCard',
//   ns: 'ap',
// };
// export const getFuCardTasks: IBridgeInsideAPITypedInfo<MiniAPI.ap$getFuCardTasks> = {
//   m: 'AlipayNewYearNebulaPlugin.fuCardTasks',
//   ns: 'ap',
// };
// export const getFuCardList: IBridgeInsideAPITypedInfo<MiniAPI.ap$getFuCardList> = {
//   m: 'AlipayNewYearNebulaPlugin.fuCardList',
//   ns: 'ap',
// };
// export const getZodiacPrizeList: IBridgeInsideAPITypedInfo<MiniAPI.ap$getZodiacPrizeList> = {
//   m: 'AlipayNewYearNebulaPlugin.zodiacPrizeList',
//   ns: 'ap',
// };

var isScreenReaderEnabled$1 = {};
// 10.2.0
var chooseDistrict$1 = {};

var createRewardedAd$1 = {
    feature: function () { return hasInsideFeature("a_createRewardedAd_2_8_10" /* EInsideFeature.a_createRewardedAd_2_8_10 */); },
    fnOptionIndex: false,
    fn: function (option) {
        // 单例
        var bridge = this.runtime().getBridge();
        var pageId = this.assignedViewId;
        var extraInfo = bridge.extraInfo;
        var extraReward = (extraInfo["createRewardedAd" /* EBridgeExtraInfoKey.createRewardedAd */] =
            extraInfo["createRewardedAd" /* EBridgeExtraInfoKey.createRewardedAd */] || {});
        if (!extraReward[pageId] || option.multiton) {
            if (!extraInfo["RewardedCloseEventId" /* EBridgeExtraInfoKey.RewardedCloseEventId */]) {
                extraInfo["RewardedCloseEventId" /* EBridgeExtraInfoKey.RewardedCloseEventId */] = 1;
            }
            else {
                ++extraInfo["RewardedCloseEventId" /* EBridgeExtraInfoKey.RewardedCloseEventId */];
            }
            var taskId = extraInfo["RewardedCloseEventId" /* EBridgeExtraInfoKey.RewardedCloseEventId */];
            var closeEventId = String(taskId);
            var state_1 = __assign(__assign({}, option), { pageId: pageId, closeEventId: closeEventId, load: [], error: [] });
            if (!option.multiton) {
                extraReward[pageId] = {
                    state: state_1,
                    instance: this.callProtoAPI(RewardedAd, [state_1]),
                };
            }
            this.callScopedBridge('createRewardedAd', __assign(__assign({}, option), { extInfo: { orientation: 'portrait', closeEventId: closeEventId } }), function (res) {
                if (res.success) {
                    state_1.load.map(function (fnc) { return fnc(); });
                }
                else {
                    state_1.error.map(function (fnc) { return fnc(res); });
                }
            });
            if (option.multiton)
                return this.callProtoAPI(RewardedAd, [state_1]);
        }
        return extraInfo["createRewardedAd" /* EBridgeExtraInfoKey.createRewardedAd */][pageId].instance;
    },
};
var RewardedAd = {
    state: function (option) {
        return option;
    },
    proto: {
        destroy: {
            feature: function () { return hasInsideFeature("a_rewardedAd_destroy_2_8_13" /* EInsideFeature.a_rewardedAd_destroy_2_8_13 */); },
            b: function () {
                var adUnitId = this.getState().adUnitId;
                return { adUnitId: adUnitId };
            },
            m: 'destroyAd',
        },
        show: {
            b: function () {
                var adUnitId = this.getState().adUnitId;
                return { adUnitId: adUnitId };
            },
            v: function () {
                var adUnitId = this.getState().adUnitId;
                if (!adUnitId || typeof adUnitId !== 'string') {
                    return {
                        error: 2,
                        errorMessage: '广告实例无效，请检查 createRewardedAd 时传入的广告单元 ID 是否有误',
                    };
                }
            },
            m: 'showAd',
        },
        load: {
            b: function () {
                var state = this.getState();
                var adUnitId = this.getState().adUnitId;
                return {
                    adUnitId: adUnitId,
                    extInfo: {
                        orientation: 'portrait',
                        closeEventId: state.closeEventId,
                    },
                };
            },
            v: function () {
                var adUnitId = this.getState().adUnitId;
                if (!adUnitId || typeof adUnitId !== 'string') {
                    return {
                        error: 2,
                        errorMessage: '广告实例无效，请检查 createRewardedAd 时传入的广告单元 ID 是否有误',
                    };
                }
            },
            m: 'loadAd',
        },
        onLoad: {
            fnOptionIndex: false,
            fn: function (fn) {
                var state = this.getState();
                if (typeof fn === 'function') {
                    state.load.push(fn);
                }
            },
        },
        offLoad: {
            fnOptionIndex: false,
            fn: function (fn) {
                var state = this.getState();
                if (typeof fn === 'function') {
                    state.load = state.load.filter(function (item) { return item !== fn; });
                }
                else if (typeof fn === 'undefined') {
                    // 不传就取消所有监听事件
                    state.load = [];
                }
            },
        },
        onError: {
            fnOptionIndex: false,
            fn: function (fn) {
                var state = this.getState();
                if (typeof fn === 'function') {
                    state.error.push(fn);
                }
            },
        },
        offError: {
            fnOptionIndex: false,
            fn: function (fn) {
                var state = this.getState();
                if (typeof fn === 'function') {
                    state.error = state.error.filter(function (item) { return item !== fn; });
                }
                else if (typeof fn === 'undefined') {
                    // 不传就取消所有监听事件
                    state.error = [];
                }
            },
        },
        onClose: {
            fnOptionIndex: false,
            fn: function (fn) {
                var closeEventId = this.getState().closeEventId;
                var eventManager = this.runtime().getBridge().event;
                eventManager.taskManager.addMatcher('ON_AD_VIEW_CLOSE', closeEventId, fn, getTaskIdFromRtcEvent, getPayloadFromRtcEvent);
            },
        },
        offClose: {
            fnOptionIndex: false,
            fn: function (fn) {
                var closeEventId = this.getState().closeEventId;
                var eventManager = this.runtime().getBridge().event;
                eventManager.taskManager.removeMatcher('ON_AD_VIEW_CLOSE', closeEventId, fn);
            },
        },
    },
};
function getTaskIdFromRtcEvent(event, taskContext) {
    var data = event.data || {};
    if (data.closeEventId) {
        return [data.closeEventId];
    }
    else {
        return Object.keys(taskContext.callbacks);
    }
}
function getPayloadFromRtcEvent(event) {
    return { isEnded: event.data.isEnded };
}

var kFileSystemManagerMethodSyncList = [
    ["mkdir" /* EFileSystemManagerMethodSyncList.mkdir */, ['dirPath', 'recursive']],
    ["rmdir" /* EFileSystemManagerMethodSyncList.rmdir */, ['dirPath', 'recursive']],
    ["readdir" /* EFileSystemManagerMethodSyncList.readdir */, ['dirPath']],
    ["writeFile" /* EFileSystemManagerMethodSyncList.writeFile */, ['filePath', 'data', 'encoding']],
    ["copyFile" /* EFileSystemManagerMethodSyncList.copyFile */, ['srcPath', 'destPath']],
    ["readFile" /* EFileSystemManagerMethodSyncList.readFile */, ['filePath', 'encoding']],
    ["saveFile" /* EFileSystemManagerMethodSyncList.saveFile */, ['tempFilePath', 'filePath']],
    ["appendFile" /* EFileSystemManagerMethodSyncList.appendFile */, ['filePath', 'data', 'encoding']],
    ["access" /* EFileSystemManagerMethodSyncList.access */, ['path']],
    ["rename" /* EFileSystemManagerMethodSyncList.rename */, ['oldPath', 'newPath']],
    ["unlink" /* EFileSystemManagerMethodSyncList.unlink */, ['filePath']],
    ["stat" /* EFileSystemManagerMethodSyncList.stat */, ['path', 'recursive']],
    // 以下 3 个 wx 没有
    ["removeSavedFile" /* EFileSystemManagerMethodSyncList.removeSavedFile */, ['filePath']],
    ["getSavedFileList" /* EFileSystemManagerMethodSyncList.getSavedFileList */, []],
    ["getFileInfo" /* EFileSystemManagerMethodSyncList.getFileInfo */, ['filePath']],
];
function createFileSystemManager(runtime, callContext) {
    var api = {};
    var kFileSystemManagerMethodAsyncList;
    if (hasInsideFeature("a_getFileSystemManager_zip_2_6_7" /* EInsideFeature.a_getFileSystemManager_zip_2_6_7 */)) {
        kFileSystemManagerMethodAsyncList = kFileSystemManagerMethodSyncList.concat([
            ['unzip', []],
            ['zip', []],
        ]);
    }
    else {
        kFileSystemManagerMethodAsyncList = kFileSystemManagerMethodSyncList.concat([['unzip', []]]);
    }
    kFileSystemManagerMethodSyncList.forEach(function (_a) {
        var methodName = _a[0], argNames = _a[1];
        api["".concat(methodName, "Sync")] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var params;
            if (typeof args[0] === 'string') {
                params = {};
                argNames.forEach(function (argName, argIndex) {
                    params[argName] = args[argIndex];
                });
            }
            else {
                params = (args[0] || {});
            }
            return callContext.callSyncLinkedCollection('fileSystemManage', __assign(__assign({}, params), { action: methodName }));
        };
    });
    kFileSystemManagerMethodAsyncList.forEach(function (_a) {
        var methodName = _a[0];
        api[methodName] = function (params) {
            if (params === void 0) { params = {}; }
            return callContext.callLinkedCollection('fileSystemManage', __assign(__assign({}, params), { action: methodName }));
        };
    });
    return api;
}

var Stat = /** @class */ /*#__PURE__*/ (function () {
    function Stat(res) {
        this.mode = res.mode;
        this.size = res.size;
        this.lastAccessedTime = res.lastAccessedTime;
        this.lastModifiedTime = res.lastModifiedTime;
        Object.defineProperty(this, 'isDirectory', {
            value: function () {
                return res.is_directory;
            },
        });
        Object.defineProperty(this, 'isFile', {
            value: function () {
                return res.is_file;
            },
        });
    }
    return Stat;
}());
function handleStatsRes(res, isAndroid) {
    if (res.error) {
        return res;
    }
    var stats = {};
    if (Array.isArray(res.stats)) {
        res.stats.forEach(function (item) {
            stats[item.path] = {
                path: item.path,
                // https://baiyan.antfin.com/task/154867
                // android端item.stats 在<10.2.30前会返回undefined，不排除后续客户端层面双端对齐（或者说inside端已对齐），所以这里多加个!item.stats判断
                stats: !item.stats && isAndroid ? new Stat(item) : new Stat(item.stats),
            };
        });
    }
    else {
        stats = new Stat(res.stats);
    }
    return { stats: stats };
}

var fileSystemManage = {
    private: true,
    b: function (params) {
        switch (params.action) {
            case 'appendFile':
            case 'writeFile':
                if (isArrayBuffer(params.data)) {
                    params.dataType = 'ArrayBuffer';
                    params.data = arrayBufferToBase64(params.data);
                }
            case 'readFile':
                if (params.encoding === '') {
                    delete params['encoding'];
                }
                if (hasInsideFeature("a_readFile_arraybuffer_2_8_3" /* EInsideFeature.a_readFile_arraybuffer_2_8_3 */) && params.encoding === 'arraybuffer') {
                    delete params['encoding'];
                }
        }
        return params;
    },
    m: 'fsManage',
    a: function (res, opt) {
        if (opt.action === 'readFile' && res.dataType === 'ArrayBuffer' && !isArrayBuffer(res.data)) {
            res.data = base64ToArrayBuffer(res.data);
        }
        if (opt.action === 'stat') {
            res = handleStatsRes(res, this.runtime().getEnv().isAndroid);
        }
        return res;
    },
};

var getFileSystemManager$1 = {
    createOptionIndex: false,
    create: function () {
        return createFileSystemManager(this.runtime, this);
    },
    linked: {
        fileSystemManage: fileSystemManage,
    },
};

var addNotifyListener$1 = {};
var removeNotifyListener$1 = {};
var postNotification$1 = {};
var getTitleAndStatusbarHeight$1 = {};
var easyShare$1 = {};
var pushWindow$1 = {};
var popWindow$1 = {};
var startApp$1 = {};
var exitApp$1 = {};
var popTo$1 = {};
var snapshot$1 = {};
var setOptionMenu$1 = {};
var showOptionMenu$1 = {};
var hideOptionMenu$1 = {};
var showBackButton$1 = {};
var hideBackButton$1 = {};
var getCurrentLocation$1 = {};
var setGestureBack$1 = {};
var uploadImage$1 = {};
var setTitle$1 = {};
var getCdpSpaceInfo$1 = {};
var cdpFeedback$1 = {};

var navigateToAlipayPage$1 = {};

var bridgeInstance;
var bridgePublicInstance;

// export type TReverseAPI = {
//   [K in API as K extends keyof TBridgeInstance_ ? `${K}` : never]: K
// };
function uaChecker(apiName) {
  // 没有 userAgent 的场合将会出错。
  if (typeof navigator === 'undefined' || !navigator || typeof navigator.userAgent === 'undefined') {
    return function () {
      throw new Error("API ".concat(apiName, " should not initialized by smallfish. Please check your environment"));
    };
  }
}
function getSharedBridge() {
  if (!bridgeInstance) {
    var runtime = setupRuntime(Promise, setTimeout, clearTimeout, setInterval, clearInterval);
    bridgeInstance = setupBridge([], [], [], runtime);
  }
  return bridgeInstance;
}
function getSharedBridgePublicInstance() {
  if (!bridgePublicInstance) {
    bridgePublicInstance = getSharedBridge().defaultScope.publicInstance;
  }
  return bridgePublicInstance;
}
function getBridgeWithAPI4Base(apiName) {
  var checker = uaChecker(apiName);
  if (checker) return checker;
  var publicInstance = getSharedBridgePublicInstance();
  return publicInstance[apiName];
}
function getBridgeWithAPI4Ap(apiName, apiInfo) {
  var checker = uaChecker(apiName);
  if (checker) return checker;
  var publicInstance = getSharedBridgePublicInstance();
  if (!publicInstance[apiName]) {
    var _bridgeInstance = getSharedBridge();
    var defaultScope = _bridgeInstance.defaultScope;
    defaultScope.getCollection().apiMap[apiName] = apiInfo;
    var bridgeCall4Public = defaultScope.call4PublicNamed;
    publicInstance[apiName] = bridgeCall4Public.bind(null, apiName.split('ap.')[1]);
  }
  return publicInstance[apiName];
}
function getBridgeWithAPI4Async(apiName, apiInfo) {
  var checker = uaChecker(apiName);
  if (checker) return checker;
  var publicInstance = getSharedBridgePublicInstance();
  if (!publicInstance[apiName]) {
    var _bridgeInstance2 = getSharedBridge();
    var defaultScope = _bridgeInstance2.defaultScope;
    defaultScope.getCollection().apiMap[apiName] = apiInfo;
    var bridgeCall4Public = defaultScope.call4PublicNamed;
    publicInstance[apiName] = bridgeCall4Public.bind(null, apiName);
  }
  return publicInstance[apiName];
}
function getBridgeWithAPI4Linked(apiName, apiInfo) {
  var checker = uaChecker(apiName);
  if (checker) return checker;
  var publicInstance = getSharedBridgePublicInstance();
  if (!publicInstance[apiName]) {
    var _bridgeInstance3 = getSharedBridge();
    var defaultScope = _bridgeInstance3.defaultScope;
    defaultScope.getCollection().apiMap[apiName] = apiInfo;
    var call4LinkedContext = defaultScope.call4LinkedContext;
    publicInstance[apiName] = call4LinkedContext.bind(null, apiName);
  }
  return publicInstance[apiName];
}
function getBridgeWithAPI4Native(apiName, apiInfo) {
  var checker = uaChecker(apiName);
  if (checker) return checker;
  var publicInstance = getSharedBridgePublicInstance();
  if (!publicInstance[apiName]) {
    var _bridgeInstance4 = getSharedBridge();
    var defaultScope = _bridgeInstance4.defaultScope;
    defaultScope.getCollection().apiMap[apiName] = apiInfo;
    var bridgeCall4Public = defaultScope.call4PublicNamed;
    publicInstance[apiName] = bridgeCall4Public.bind(null, apiName.replace(/\$/g, '.'));
  }
  return publicInstance[apiName];
}

/* group: ap */
var showFuCard = /*#__PURE__*/getBridgeWithAPI4Ap('ap.showFuCard', showFuCard$1);
var navigateToAlipayPage = /*#__PURE__*/getBridgeWithAPI4Ap('ap.navigateToAlipayPage', navigateToAlipayPage$1);

var ap = /*#__PURE__*/Object.freeze({
    __proto__: null,
    showFuCard: showFuCard,
    navigateToAlipayPage: navigateToAlipayPage
});

/* group: async */
var showActionSheet = /*#__PURE__*/getBridgeWithAPI4Async('showActionSheet', showActionSheet$1);
var startRecord = /*#__PURE__*/getBridgeWithAPI4Async('startRecord', startRecord$1);
var stopRecord = /*#__PURE__*/getBridgeWithAPI4Async('stopRecord', stopRecord$1);
var cancelRecord = /*#__PURE__*/getBridgeWithAPI4Async('cancelRecord', cancelRecord$1);
var playVoice = /*#__PURE__*/getBridgeWithAPI4Async('playVoice', playVoice$1);
var pauseVoice = /*#__PURE__*/getBridgeWithAPI4Async('pauseVoice', pauseVoice$1);
var resumeVoice = /*#__PURE__*/getBridgeWithAPI4Async('resumeVoice', resumeVoice$1);
var stopVoice = /*#__PURE__*/getBridgeWithAPI4Async('stopVoice', stopVoice$1);
var playBackgroundAudio = /*#__PURE__*/getBridgeWithAPI4Async('playBackgroundAudio', playBackgroundAudio$1);
var pauseBackgroundAudio = /*#__PURE__*/getBridgeWithAPI4Async('pauseBackgroundAudio', pauseBackgroundAudio$1);
var stopBackgroundAudio = /*#__PURE__*/getBridgeWithAPI4Async('stopBackgroundAudio', stopBackgroundAudio$1);
var seekBackgroundAudio = /*#__PURE__*/getBridgeWithAPI4Async('seekBackgroundAudio', seekBackgroundAudio$1);
var openBluetoothAdapter = /*#__PURE__*/getBridgeWithAPI4Async('openBluetoothAdapter', openBluetoothAdapter$1);
var closeBluetoothAdapter = /*#__PURE__*/getBridgeWithAPI4Async('closeBluetoothAdapter', closeBluetoothAdapter$1);
var getBluetoothAdapterState = /*#__PURE__*/getBridgeWithAPI4Async('getBluetoothAdapterState', getBluetoothAdapterState$1);
var startBluetoothDevicesDiscovery = /*#__PURE__*/getBridgeWithAPI4Async('startBluetoothDevicesDiscovery', startBluetoothDevicesDiscovery$1);
var stopBluetoothDevicesDiscovery = /*#__PURE__*/getBridgeWithAPI4Async('stopBluetoothDevicesDiscovery', stopBluetoothDevicesDiscovery$1);
var getConnectedBluetoothDevices = /*#__PURE__*/getBridgeWithAPI4Async('getConnectedBluetoothDevices', getConnectedBluetoothDevices$1);
var getBluetoothDevices = /*#__PURE__*/getBridgeWithAPI4Async('getBluetoothDevices', getBluetoothDevices$1);
var connectBLEDevice = /*#__PURE__*/getBridgeWithAPI4Async('connectBLEDevice', connectBLEDevice$1);
var disconnectBLEDevice = /*#__PURE__*/getBridgeWithAPI4Async('disconnectBLEDevice', disconnectBLEDevice$1);
var writeBLECharacteristicValue = /*#__PURE__*/getBridgeWithAPI4Async('writeBLECharacteristicValue', writeBLECharacteristicValue$1);
var readBLECharacteristicValue = /*#__PURE__*/getBridgeWithAPI4Async('readBLECharacteristicValue', readBLECharacteristicValue$1);
var notifyBLECharacteristicValueChange = /*#__PURE__*/getBridgeWithAPI4Async('notifyBLECharacteristicValueChange', notifyBLECharacteristicValueChange$1);
var getBLEDeviceServices = /*#__PURE__*/getBridgeWithAPI4Async('getBLEDeviceServices', getBLEDeviceServices$1);
var getBLEDeviceCharacteristics = /*#__PURE__*/getBridgeWithAPI4Async('getBLEDeviceCharacteristics', getBLEDeviceCharacteristics$1);
var onBLECharacteristicValueChange = /*#__PURE__*/getBridgeWithAPI4Async('onBLECharacteristicValueChange', onBLECharacteristicValueChange$1);
var offBLECharacteristicValueChange = /*#__PURE__*/getBridgeWithAPI4Async('offBLECharacteristicValueChange', offBLECharacteristicValueChange$1);
var onBluetoothAdapterStateChange = /*#__PURE__*/getBridgeWithAPI4Async('onBluetoothAdapterStateChange', onBluetoothAdapterStateChange$1);
var offBluetoothAdapterStateChange = /*#__PURE__*/getBridgeWithAPI4Async('offBluetoothAdapterStateChange', offBluetoothAdapterStateChange$1);
var onBLEConnectionStateChanged = /*#__PURE__*/getBridgeWithAPI4Async('onBLEConnectionStateChanged', onBLEConnectionStateChanged$1);
var offBLEConnectionStateChanged = /*#__PURE__*/getBridgeWithAPI4Async('offBLEConnectionStateChanged', offBLEConnectionStateChanged$1);
var onBluetoothDeviceFound = /*#__PURE__*/getBridgeWithAPI4Async('onBluetoothDeviceFound', onBluetoothDeviceFound$1);
var offBluetoothDeviceFound = /*#__PURE__*/getBridgeWithAPI4Async('offBluetoothDeviceFound', offBluetoothDeviceFound$1);
var startBeaconDiscovery = /*#__PURE__*/getBridgeWithAPI4Async('startBeaconDiscovery', startBeaconDiscovery$1);
var stopBeaconDiscovery = /*#__PURE__*/getBridgeWithAPI4Async('stopBeaconDiscovery', stopBeaconDiscovery$1);
var getBeacons = /*#__PURE__*/getBridgeWithAPI4Async('getBeacons', getBeacons$1);
var onBeaconUpdate = /*#__PURE__*/getBridgeWithAPI4Async('onBeaconUpdate', onBeaconUpdate$1);
var offBeaconUpdate = /*#__PURE__*/getBridgeWithAPI4Async('offBeaconUpdate', offBeaconUpdate$1);
var onBeaconServiceChange = /*#__PURE__*/getBridgeWithAPI4Async('onBeaconServiceChange', onBeaconServiceChange$1);
var offBeaconServiceChange = /*#__PURE__*/getBridgeWithAPI4Async('offBeaconServiceChange', offBeaconServiceChange$1);
var openBLEPeripheral = /*#__PURE__*/getBridgeWithAPI4Async('openBLEPeripheral', openBLEPeripheral$1);
var closeBLEPeripheral = /*#__PURE__*/getBridgeWithAPI4Async('closeBLEPeripheral', closeBLEPeripheral$1);
var addPeripheralService = /*#__PURE__*/getBridgeWithAPI4Async('addPeripheralService', addPeripheralService$1);
var removePeripheralService = /*#__PURE__*/getBridgeWithAPI4Async('removePeripheralService', removePeripheralService$1);
var updateCharacteristic = /*#__PURE__*/getBridgeWithAPI4Async('updateCharacteristic', updateCharacteristic$1);
var startBLEAdvertising = /*#__PURE__*/getBridgeWithAPI4Async('startBLEAdvertising', startBLEAdvertising$1);
var stopBLEAdvertising = /*#__PURE__*/getBridgeWithAPI4Async('stopBLEAdvertising', stopBLEAdvertising$1);
var onCharacteristicRead = /*#__PURE__*/getBridgeWithAPI4Async('onCharacteristicRead', onCharacteristicRead$1);
var offCharacteristicRead = /*#__PURE__*/getBridgeWithAPI4Async('offCharacteristicRead', offCharacteristicRead$1);
var onCharacteristicWrite = /*#__PURE__*/getBridgeWithAPI4Async('onCharacteristicWrite', onCharacteristicWrite$1);
var offCharacteristicWrite = /*#__PURE__*/getBridgeWithAPI4Async('offCharacteristicWrite', offCharacteristicWrite$1);
var onCharacteristicDidSubscribe = /*#__PURE__*/getBridgeWithAPI4Async('onCharacteristicDidSubscribe', onCharacteristicDidSubscribe$1);
var offCharacteristicDidSubscribe = /*#__PURE__*/getBridgeWithAPI4Async('offCharacteristicDidSubscribe', offCharacteristicDidSubscribe$1);
var onCharacteristicDidUnsubscribe = /*#__PURE__*/getBridgeWithAPI4Async('onCharacteristicDidUnsubscribe', onCharacteristicDidUnsubscribe$1);
var offCharacteristicDidUnsubscribe = /*#__PURE__*/getBridgeWithAPI4Async('offCharacteristicDidUnsubscribe', offCharacteristicDidUnsubscribe$1);
var alert = /*#__PURE__*/getBridgeWithAPI4Async('alert', alert$1);
var showLoading = /*#__PURE__*/getBridgeWithAPI4Async('showLoading', showLoading$1);
var hideLoading = /*#__PURE__*/getBridgeWithAPI4Async('hideLoading', hideLoading$1);
var multiLevelSelect = /*#__PURE__*/getBridgeWithAPI4Async('multiLevelSelect', multiLevelSelect$1);
var prompt = /*#__PURE__*/getBridgeWithAPI4Async('prompt', prompt$1);
var stopPullDownRefresh = /*#__PURE__*/getBridgeWithAPI4Async('stopPullDownRefresh', stopPullDownRefresh$1);
var setBackgroundColor = /*#__PURE__*/getBridgeWithAPI4Async('setBackgroundColor', setBackgroundColor$1);
var setBackgroundTextStyle = /*#__PURE__*/getBridgeWithAPI4Async('setBackgroundTextStyle', setBackgroundTextStyle$1);
var setBackButton = /*#__PURE__*/getBridgeWithAPI4Async('setBackButton', setBackButton$1);
var removeBackgroundImage = /*#__PURE__*/getBridgeWithAPI4Async('removeBackgroundImage', removeBackgroundImage$1);
var setCanPullDown = /*#__PURE__*/getBridgeWithAPI4Async('setCanPullDown', setCanPullDown$1);
var startPullDownRefresh = /*#__PURE__*/getBridgeWithAPI4Async('startPullDownRefresh', startPullDownRefresh$1);
var setTransparentTitle = /*#__PURE__*/getBridgeWithAPI4Async('setTransparentTitle', setTransparentTitle$1);
var optionsSelect = /*#__PURE__*/getBridgeWithAPI4Async('optionsSelect', optionsSelect$1);
var confirm = /*#__PURE__*/getBridgeWithAPI4Async('confirm', confirm$1);
var datePicker = /*#__PURE__*/getBridgeWithAPI4Async('datePicker', datePicker$1);
var getNetworkType = /*#__PURE__*/getBridgeWithAPI4Async('getNetworkType', getNetworkType$1);
var vibrate = /*#__PURE__*/getBridgeWithAPI4Async('vibrate', vibrate$1);
var choosePhoneContact = /*#__PURE__*/getBridgeWithAPI4Async('choosePhoneContact', choosePhoneContact$1);
var chooseAlipayContact = /*#__PURE__*/getBridgeWithAPI4Async('chooseAlipayContact', chooseAlipayContact$1);
var chooseContact = /*#__PURE__*/getBridgeWithAPI4Async('chooseContact', chooseContact$1);
var watchShake = /*#__PURE__*/getBridgeWithAPI4Async('watchShake', watchShake$1);
var setClipboard = /*#__PURE__*/getBridgeWithAPI4Async('setClipboard', setClipboard$1);
var getClipboard = /*#__PURE__*/getBridgeWithAPI4Async('getClipboard', getClipboard$1);
var scan = /*#__PURE__*/getBridgeWithAPI4Async('scan', scan$1);
var getServerTime = /*#__PURE__*/getBridgeWithAPI4Async('getServerTime', getServerTime$1);
var getScreenBrightness = /*#__PURE__*/getBridgeWithAPI4Async('getScreenBrightness', getScreenBrightness$1);
var setScreenBrightness = /*#__PURE__*/getBridgeWithAPI4Async('setScreenBrightness', setScreenBrightness$1);
var setKeepScreenOn = /*#__PURE__*/getBridgeWithAPI4Async('setKeepScreenOn', setKeepScreenOn$1);
var addPhoneContact = /*#__PURE__*/getBridgeWithAPI4Async('addPhoneContact', addPhoneContact$1);
var onGyroscopeChange = /*#__PURE__*/getBridgeWithAPI4Async('onGyroscopeChange', onGyroscopeChange$1);
var offGyroscopeChange = /*#__PURE__*/getBridgeWithAPI4Async('offGyroscopeChange', offGyroscopeChange$1);
var onAccelerometerChange = /*#__PURE__*/getBridgeWithAPI4Async('onAccelerometerChange', onAccelerometerChange$1);
var offAccelerometerChange = /*#__PURE__*/getBridgeWithAPI4Async('offAccelerometerChange', offAccelerometerChange$1);
var onCompassChange = /*#__PURE__*/getBridgeWithAPI4Async('onCompassChange', onCompassChange$1);
var offCompassChange = /*#__PURE__*/getBridgeWithAPI4Async('offCompassChange', offCompassChange$1);
var rsa = /*#__PURE__*/getBridgeWithAPI4Async('rsa', rsa$1);
var sendSMS = /*#__PURE__*/getBridgeWithAPI4Async('sendSMS', sendSMS$1);
var startWifi = /*#__PURE__*/getBridgeWithAPI4Async('startWifi', startWifi$1);
var stopWifi = /*#__PURE__*/getBridgeWithAPI4Async('stopWifi', stopWifi$1);
var getWifiList = /*#__PURE__*/getBridgeWithAPI4Async('getWifiList', getWifiList$1);
var setWifiList = /*#__PURE__*/getBridgeWithAPI4Async('setWifiList', setWifiList$1);
var getConnectedWifi = /*#__PURE__*/getBridgeWithAPI4Async('getConnectedWifi', getConnectedWifi$1);
var vibrateLong = /*#__PURE__*/getBridgeWithAPI4Async('vibrateLong', vibrateLong$1);
var vibrateShort = /*#__PURE__*/getBridgeWithAPI4Async('vibrateShort', vibrateShort$1);
var getHCEState = /*#__PURE__*/getBridgeWithAPI4Async('getHCEState', getHCEState$1);
var startHCE = /*#__PURE__*/getBridgeWithAPI4Async('startHCE', startHCE$1);
var sendHCEMessage = /*#__PURE__*/getBridgeWithAPI4Async('sendHCEMessage', sendHCEMessage$1);
var getBatteryInfo = /*#__PURE__*/getBridgeWithAPI4Async('getBatteryInfo', getBatteryInfo$1);
var onDeviceMotionChange = /*#__PURE__*/getBridgeWithAPI4Async('onDeviceMotionChange', onDeviceMotionChange$1);
var offDeviceMotionChange = /*#__PURE__*/getBridgeWithAPI4Async('offDeviceMotionChange', offDeviceMotionChange$1);
var getDeviceInfo = /*#__PURE__*/getBridgeWithAPI4Async('getDeviceInfo', getDeviceInfo$1);
var getTitleColor = /*#__PURE__*/getBridgeWithAPI4Async('getTitleColor', getTitleColor$1);
var registerSSID = /*#__PURE__*/getBridgeWithAPI4Async('registerSSID', registerSSID$1);
var unregisterSSID = /*#__PURE__*/getBridgeWithAPI4Async('unregisterSSID', unregisterSSID$1);
var getCarrierName = /*#__PURE__*/getBridgeWithAPI4Async('getCarrierName', getCarrierName$1);
var isSystemRoot = /*#__PURE__*/getBridgeWithAPI4Async('isSystemRoot', isSystemRoot$1);
var seNFCServiceIsv = /*#__PURE__*/getBridgeWithAPI4Async('seNFCServiceIsv', seNFCServiceIsv$1);
var getAuthStatus = /*#__PURE__*/getBridgeWithAPI4Async('getAuthStatus', getAuthStatus$1);
var regionPicker = /*#__PURE__*/getBridgeWithAPI4Async('regionPicker', regionPicker$1);
var setScreenOrientation = /*#__PURE__*/getBridgeWithAPI4Async('setScreenOrientation', setScreenOrientation$1);
var getScreenOrientation = /*#__PURE__*/getBridgeWithAPI4Async('getScreenOrientation', getScreenOrientation$1);
var getDeviceID = /*#__PURE__*/getBridgeWithAPI4Async('getDeviceID', getDeviceID$1);
var isCollected = /*#__PURE__*/getBridgeWithAPI4Async('isCollected', isCollected$1);
var saveFile = /*#__PURE__*/getBridgeWithAPI4Async('saveFile', saveFile$1);
var removeSavedFile = /*#__PURE__*/getBridgeWithAPI4Async('removeSavedFile', removeSavedFile$1);
var getSavedFileInfo = /*#__PURE__*/getBridgeWithAPI4Async('getSavedFileInfo', getSavedFileInfo$1);
var getSavedFileList = /*#__PURE__*/getBridgeWithAPI4Async('getSavedFileList', getSavedFileList$1);
var getFileInfo = /*#__PURE__*/getBridgeWithAPI4Async('getFileInfo', getFileInfo$1);
var openDocument = /*#__PURE__*/getBridgeWithAPI4Async('openDocument', openDocument$1);
var getOpenUserData = /*#__PURE__*/getBridgeWithAPI4Async('getOpenUserData', getOpenUserData$1);
var getLocation = /*#__PURE__*/getBridgeWithAPI4Async('getLocation', getLocation$1);
var openLocation = /*#__PURE__*/getBridgeWithAPI4Async('openLocation', openLocation$1);
var chooseLocation = /*#__PURE__*/getBridgeWithAPI4Async('chooseLocation', chooseLocation$1);
var chooseCity = /*#__PURE__*/getBridgeWithAPI4Async('chooseCity', chooseCity$1);
var reGeoCode = /*#__PURE__*/getBridgeWithAPI4Async('reGeoCode', reGeoCode$1);
var geoCode = /*#__PURE__*/getBridgeWithAPI4Async('geoCode', geoCode$1);
var startContinuousLocation = /*#__PURE__*/getBridgeWithAPI4Async('startContinuousLocation', startContinuousLocation$1);
var stopContinuousLocation = /*#__PURE__*/getBridgeWithAPI4Async('stopContinuousLocation', stopContinuousLocation$1);
var chooseImage = /*#__PURE__*/getBridgeWithAPI4Async('chooseImage', chooseImage$1);
var previewImage = /*#__PURE__*/getBridgeWithAPI4Async('previewImage', previewImage$1);
var chooseVideo = /*#__PURE__*/getBridgeWithAPI4Async('chooseVideo', chooseVideo$1);
var saveImage = /*#__PURE__*/getBridgeWithAPI4Async('saveImage', saveImage$1);
var getImageInfo = /*#__PURE__*/getBridgeWithAPI4Async('getImageInfo', getImageInfo$1);
var compressImage = /*#__PURE__*/getBridgeWithAPI4Async('compressImage', compressImage$1);
var getAvailableAudioSources = /*#__PURE__*/getBridgeWithAPI4Async('getAvailableAudioSources', getAvailableAudioSources$1);
var saveVideoToPhotosAlbum = /*#__PURE__*/getBridgeWithAPI4Async('saveVideoToPhotosAlbum', saveVideoToPhotosAlbum$1);
var generateImageFromCode = /*#__PURE__*/getBridgeWithAPI4Async('generateImageFromCode', generateImageFromCode$1);
var saveImageToPhotosAlbum = /*#__PURE__*/getBridgeWithAPI4Async('saveImageToPhotosAlbum', saveImageToPhotosAlbum$1);
var textToSpeech = /*#__PURE__*/getBridgeWithAPI4Async('textToSpeech', textToSpeech$1);
var chooseFileFromDisk = /*#__PURE__*/getBridgeWithAPI4Async('chooseFileFromDisk', chooseFileFromDisk$1);
var showNavigationBarLoading = /*#__PURE__*/getBridgeWithAPI4Async('showNavigationBarLoading', showNavigationBarLoading$1);
var hideNavigationBarLoading = /*#__PURE__*/getBridgeWithAPI4Async('hideNavigationBarLoading', hideNavigationBarLoading$1);
var setNavigationBar = /*#__PURE__*/getBridgeWithAPI4Async('setNavigationBar', setNavigationBar$1);
var rpc = /*#__PURE__*/getBridgeWithAPI4Async('rpc', rpc$1);
var request = /*#__PURE__*/getBridgeWithAPI4Async('request', request$1);
var httpRequest = /*#__PURE__*/getBridgeWithAPI4Async('httpRequest', httpRequest$1);
var uploadFile = /*#__PURE__*/getBridgeWithAPI4Async('uploadFile', uploadFile$1);
var downloadFile = /*#__PURE__*/getBridgeWithAPI4Async('downloadFile', downloadFile$1);
var onNetworkStatusChange = /*#__PURE__*/getBridgeWithAPI4Async('onNetworkStatusChange', onNetworkStatusChange$1);
var offNetworkStatusChange = /*#__PURE__*/getBridgeWithAPI4Async('offNetworkStatusChange', offNetworkStatusChange$1);
var getTBSessionInfo = /*#__PURE__*/getBridgeWithAPI4Async('getTBSessionInfo', getTBSessionInfo$1);
var navigateToMiniProgram = /*#__PURE__*/getBridgeWithAPI4Async('navigateToMiniProgram', navigateToMiniProgram$1);
var hideAddToDesktopMenu = /*#__PURE__*/getBridgeWithAPI4Async('hideAddToDesktopMenu', hideAddToDesktopMenu$1);
var hideAllAddToDesktopMenu = /*#__PURE__*/getBridgeWithAPI4Async('hideAllAddToDesktopMenu', hideAllAddToDesktopMenu$1);
var hideFavoriteMenu = /*#__PURE__*/getBridgeWithAPI4Async('hideFavoriteMenu', hideFavoriteMenu$1);
var hideShareMenu = /*#__PURE__*/getBridgeWithAPI4Async('hideShareMenu', hideShareMenu$1);
var setStorage = /*#__PURE__*/getBridgeWithAPI4Async('setStorage', setStorage$1);
var getStorage = /*#__PURE__*/getBridgeWithAPI4Async('getStorage', getStorage$1);
var removeStorage = /*#__PURE__*/getBridgeWithAPI4Async('removeStorage', removeStorage$1);
var clearStorage = /*#__PURE__*/getBridgeWithAPI4Async('clearStorage', clearStorage$1);
var getStorageInfo = /*#__PURE__*/getBridgeWithAPI4Async('getStorageInfo', getStorageInfo$1);
var showToast = /*#__PURE__*/getBridgeWithAPI4Async('showToast', showToast$1);
var hideToast = /*#__PURE__*/getBridgeWithAPI4Async('hideToast', hideToast$1);
var connectSocket = /*#__PURE__*/getBridgeWithAPI4Async('connectSocket', connectSocket$1);
var sendSocketMessage = /*#__PURE__*/getBridgeWithAPI4Async('sendSocketMessage', sendSocketMessage$1);
var closeSocket = /*#__PURE__*/getBridgeWithAPI4Async('closeSocket', closeSocket$1);
var onSocketOpen = /*#__PURE__*/getBridgeWithAPI4Async('onSocketOpen', onSocketOpen$1);
var offSocketOpen = /*#__PURE__*/getBridgeWithAPI4Async('offSocketOpen', offSocketOpen$1);
var onSocketMessage = /*#__PURE__*/getBridgeWithAPI4Async('onSocketMessage', onSocketMessage$1);
var offSocketMessage = /*#__PURE__*/getBridgeWithAPI4Async('offSocketMessage', offSocketMessage$1);
var onSocketError = /*#__PURE__*/getBridgeWithAPI4Async('onSocketError', onSocketError$1);
var offSocketError = /*#__PURE__*/getBridgeWithAPI4Async('offSocketError', offSocketError$1);
var onSocketClose = /*#__PURE__*/getBridgeWithAPI4Async('onSocketClose', onSocketClose$1);
var offSocketClose = /*#__PURE__*/getBridgeWithAPI4Async('offSocketClose', offSocketClose$1);
var isSpeechRecognizeAvailable = /*#__PURE__*/getBridgeWithAPI4Async('isSpeechRecognizeAvailable', isSpeechRecognizeAvailable$1);
var startSpeechRecognize = /*#__PURE__*/getBridgeWithAPI4Async('startSpeechRecognize', startSpeechRecognize$1);
var stopSpeechRecognize = /*#__PURE__*/getBridgeWithAPI4Async('stopSpeechRecognize', stopSpeechRecognize$1);
var preloadCanvasImage = /*#__PURE__*/getBridgeWithAPI4Async('preloadCanvasImage', preloadCanvasImage$1);
var reportAnalytics = /*#__PURE__*/getBridgeWithAPI4Async('reportAnalytics', reportAnalytics$1);
var getSystemInfo = /*#__PURE__*/getBridgeWithAPI4Async('getSystemInfo', getSystemInfo$1);
var onUserCaptureScreen = /*#__PURE__*/getBridgeWithAPI4Async('onUserCaptureScreen', onUserCaptureScreen$1);
var offUserCaptureScreen = /*#__PURE__*/getBridgeWithAPI4Async('offUserCaptureScreen', offUserCaptureScreen$1);
var showAuthGuide = /*#__PURE__*/getBridgeWithAPI4Async('showAuthGuide', showAuthGuide$1);
var getAppAuthorizeSetting = /*#__PURE__*/getBridgeWithAPI4Async('getAppAuthorizeSetting', getAppAuthorizeSetting$1);
var getSystemSetting = /*#__PURE__*/getBridgeWithAPI4Async('getSystemSetting', getSystemSetting$1);
var tradePay = /*#__PURE__*/getBridgeWithAPI4Async('tradePay', tradePay$1);
var getUserInfo = /*#__PURE__*/getBridgeWithAPI4Async('getUserInfo', getUserInfo$1);
var getAuthCode = /*#__PURE__*/getBridgeWithAPI4Async('getAuthCode', getAuthCode$1);
var getAuthUserInfo = /*#__PURE__*/getBridgeWithAPI4Async('getAuthUserInfo', getAuthUserInfo$1);
var startZMVerify = /*#__PURE__*/getBridgeWithAPI4Async('startZMVerify', startZMVerify$1);
var openSetting = /*#__PURE__*/getBridgeWithAPI4Async('openSetting', openSetting$1);
var getSetting = /*#__PURE__*/getBridgeWithAPI4Async('getSetting', getSetting$1);
var chooseAddress = /*#__PURE__*/getBridgeWithAPI4Async('chooseAddress', chooseAddress$1);
var openCardList = /*#__PURE__*/getBridgeWithAPI4Async('openCardList', openCardList$1);
var openVoucherList = /*#__PURE__*/getBridgeWithAPI4Async('openVoucherList', openVoucherList$1);
var openTicketList = /*#__PURE__*/getBridgeWithAPI4Async('openTicketList', openTicketList$1);
var openCardDetail = /*#__PURE__*/getBridgeWithAPI4Async('openCardDetail', openCardDetail$1);
var openVoucherDetail = /*#__PURE__*/getBridgeWithAPI4Async('openVoucherDetail', openVoucherDetail$1);
var openTicketDetail = /*#__PURE__*/getBridgeWithAPI4Async('openTicketDetail', openTicketDetail$1);
var openMerchantCardList = /*#__PURE__*/getBridgeWithAPI4Async('openMerchantCardList', openMerchantCardList$1);
var openMerchantVoucherList = /*#__PURE__*/getBridgeWithAPI4Async('openMerchantVoucherList', openMerchantVoucherList$1);
var openMerchantTicketList = /*#__PURE__*/getBridgeWithAPI4Async('openMerchantTicketList', openMerchantTicketList$1);
var navigateToCouponDetail = /*#__PURE__*/getBridgeWithAPI4Async('navigateToCouponDetail', navigateToCouponDetail$1);
var paySignCenter = /*#__PURE__*/getBridgeWithAPI4Async('paySignCenter', paySignCenter$1);
var zmCreditBorrow = /*#__PURE__*/getBridgeWithAPI4Async('zmCreditBorrow', zmCreditBorrow$1);
var textRiskIdentification = /*#__PURE__*/getBridgeWithAPI4Async('textRiskIdentification', textRiskIdentification$1);
var openCarService = /*#__PURE__*/getBridgeWithAPI4Async('openCarService', openCarService$1);
var openChatWindow = /*#__PURE__*/getBridgeWithAPI4Async('openChatWindow', openChatWindow$1);
var startZMCreditRent = /*#__PURE__*/getBridgeWithAPI4Async('startZMCreditRent', startZMCreditRent$1);
var zmRentTransition = /*#__PURE__*/getBridgeWithAPI4Async('zmRentTransition', zmRentTransition$1);
var chooseInvoiceTitle = /*#__PURE__*/getBridgeWithAPI4Async('chooseInvoiceTitle', chooseInvoiceTitle$1);
var zmFreeDeposit = /*#__PURE__*/getBridgeWithAPI4Async('zmFreeDeposit', zmFreeDeposit$1);
var openTaobao = /*#__PURE__*/getBridgeWithAPI4Async('openTaobao', openTaobao$1);
var openOtherApplication = /*#__PURE__*/getBridgeWithAPI4Async('openOtherApplication', openOtherApplication$1);
var addEventCal = /*#__PURE__*/getBridgeWithAPI4Async('addEventCal', addEventCal$1);
var addEventCalendar = /*#__PURE__*/getBridgeWithAPI4Async('addEventCalendar', addEventCalendar$1);
var isLowPowerMode = /*#__PURE__*/getBridgeWithAPI4Async('isLowPowerMode', isLowPowerMode$1);
var getUpdateManager = /*#__PURE__*/getBridgeWithAPI4Async('getUpdateManager', getUpdateManager$1);
var getRecorderManager = /*#__PURE__*/getBridgeWithAPI4Async('getRecorderManager', getRecorderManager$1);
var getBackgroundAudioManager = /*#__PURE__*/getBridgeWithAPI4Async('getBackgroundAudioManager', getBackgroundAudioManager$1);
var createInnerAudioContext = /*#__PURE__*/getBridgeWithAPI4Async('createInnerAudioContext', createInnerAudioContext$1);
var setTabBarBadge = /*#__PURE__*/getBridgeWithAPI4Async('setTabBarBadge', setTabBarBadge$1);
var setTabBarItem = /*#__PURE__*/getBridgeWithAPI4Async('setTabBarItem', setTabBarItem$1);
var setTabBarStyle = /*#__PURE__*/getBridgeWithAPI4Async('setTabBarStyle', setTabBarStyle$1);
var hideTabBar = /*#__PURE__*/getBridgeWithAPI4Async('hideTabBar', hideTabBar$1);
var hideTabBarRedDot = /*#__PURE__*/getBridgeWithAPI4Async('hideTabBarRedDot', hideTabBarRedDot$1);
var showTabBar = /*#__PURE__*/getBridgeWithAPI4Async('showTabBar', showTabBar$1);
var showTabBarRedDot = /*#__PURE__*/getBridgeWithAPI4Async('showTabBarRedDot', showTabBarRedDot$1);
var removeTabBarBadge = /*#__PURE__*/getBridgeWithAPI4Async('removeTabBarBadge', removeTabBarBadge$1);
var openEmbeddedMiniProgram = /*#__PURE__*/getBridgeWithAPI4Async('openEmbeddedMiniProgram', openEmbeddedMiniProgram$1);
var isScreenReaderEnabled = /*#__PURE__*/getBridgeWithAPI4Async('isScreenReaderEnabled', isScreenReaderEnabled$1);
var chooseDistrict = /*#__PURE__*/getBridgeWithAPI4Async('chooseDistrict', chooseDistrict$1);
var createRewardedAd = /*#__PURE__*/getBridgeWithAPI4Async('createRewardedAd', createRewardedAd$1);

/* group: linked */
var getFileSystemManager = /*#__PURE__*/getBridgeWithAPI4Linked('getFileSystemManager', getFileSystemManager$1);

/* group: native */
/**
 * @deprecated addNotifyListener 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var addNotifyListener = /*#__PURE__*/getBridgeWithAPI4Native('addNotifyListener', addNotifyListener$1);

/**
 * @deprecated removeNotifyListener 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var removeNotifyListener = /*#__PURE__*/getBridgeWithAPI4Native('removeNotifyListener', removeNotifyListener$1);

/**
 * @deprecated postNotification 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var postNotification = /*#__PURE__*/getBridgeWithAPI4Native('postNotification', postNotification$1);

/**
 * @deprecated getTitleAndStatusbarHeight 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var getTitleAndStatusbarHeight = /*#__PURE__*/getBridgeWithAPI4Native('getTitleAndStatusbarHeight', getTitleAndStatusbarHeight$1);

/**
 * @deprecated easyShare 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var easyShare = /*#__PURE__*/getBridgeWithAPI4Native('easyShare', easyShare$1);

/**
 * @deprecated pushWindow 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var pushWindow = /*#__PURE__*/getBridgeWithAPI4Native('pushWindow', pushWindow$1);

/**
 * @deprecated popWindow 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var popWindow = /*#__PURE__*/getBridgeWithAPI4Native('popWindow', popWindow$1);

/**
 * @deprecated startApp 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var startApp = /*#__PURE__*/getBridgeWithAPI4Native('startApp', startApp$1);

/**
 * @deprecated exitApp 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var exitApp = /*#__PURE__*/getBridgeWithAPI4Native('exitApp', exitApp$1);

/**
 * @deprecated popTo 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var popTo = /*#__PURE__*/getBridgeWithAPI4Native('popTo', popTo$1);

/**
 * @deprecated snapshot 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var snapshot = /*#__PURE__*/getBridgeWithAPI4Native('snapshot', snapshot$1);

/**
 * @deprecated setOptionMenu 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var setOptionMenu = /*#__PURE__*/getBridgeWithAPI4Native('setOptionMenu', setOptionMenu$1);

/**
 * @deprecated showOptionMenu 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var showOptionMenu = /*#__PURE__*/getBridgeWithAPI4Native('showOptionMenu', showOptionMenu$1);

/**
 * @deprecated hideOptionMenu 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var hideOptionMenu = /*#__PURE__*/getBridgeWithAPI4Native('hideOptionMenu', hideOptionMenu$1);

/**
 * @deprecated showBackButton 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var showBackButton = /*#__PURE__*/getBridgeWithAPI4Native('showBackButton', showBackButton$1);

/**
 * @deprecated hideBackButton 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var hideBackButton = /*#__PURE__*/getBridgeWithAPI4Native('hideBackButton', hideBackButton$1);

/**
 * @deprecated getCurrentLocation 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var getCurrentLocation = /*#__PURE__*/getBridgeWithAPI4Native('getCurrentLocation', getCurrentLocation$1);

/**
 * @deprecated setGestureBack 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var setGestureBack = /*#__PURE__*/getBridgeWithAPI4Native('setGestureBack', setGestureBack$1);

/**
 * @deprecated uploadImage 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var uploadImage = /*#__PURE__*/getBridgeWithAPI4Native('uploadImage', uploadImage$1);

/**
 * @deprecated setTitle 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var setTitle = /*#__PURE__*/getBridgeWithAPI4Native('setTitle', setTitle$1);

/**
 * @deprecated getCdpSpaceInfo 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var getCdpSpaceInfo = /*#__PURE__*/getBridgeWithAPI4Native('getCdpSpaceInfo', getCdpSpaceInfo$1);

/**
 * @deprecated cdpFeedback 是客户端接口，已不推荐 my.* 使用。请使用其他产品化 JSAPI 或通过 internal-my 调用
 */
var cdpFeedback = /*#__PURE__*/getBridgeWithAPI4Native('cdpFeedback', cdpFeedback$1);

/* group: base */
var call = /*#__PURE__*/getBridgeWithAPI4Base('call');
var on = /*#__PURE__*/getBridgeWithAPI4Base('on');
var off = /*#__PURE__*/getBridgeWithAPI4Base('off');
var emit = /*#__PURE__*/getBridgeWithAPI4Base('emit');

export { addEventCal, addEventCalendar, addNotifyListener, addPeripheralService, addPhoneContact, alert, ap, call, cancelRecord, cdpFeedback, chooseAddress, chooseAlipayContact, chooseCity, chooseContact, chooseDistrict, chooseFileFromDisk, chooseImage, chooseInvoiceTitle, chooseLocation, choosePhoneContact, chooseVideo, clearStorage, closeBLEPeripheral, closeBluetoothAdapter, closeSocket, compressImage, confirm, connectBLEDevice, connectSocket, createInnerAudioContext, createRewardedAd, datePicker, disconnectBLEDevice, downloadFile, easyShare, emit, exitApp, generateImageFromCode, geoCode, getAppAuthorizeSetting, getAuthCode, getAuthStatus, getAuthUserInfo, getAvailableAudioSources, getBLEDeviceCharacteristics, getBLEDeviceServices, getBackgroundAudioManager, getBatteryInfo, getBeacons, getBluetoothAdapterState, getBluetoothDevices, getCarrierName, getCdpSpaceInfo, getClipboard, getConnectedBluetoothDevices, getConnectedWifi, getCurrentLocation, getDeviceID, getDeviceInfo, getFileInfo, getFileSystemManager, getHCEState, getImageInfo, getLocation, getNetworkType, getOpenUserData, getRecorderManager, getSavedFileInfo, getSavedFileList, getScreenBrightness, getScreenOrientation, getServerTime, getSetting, getStorage, getStorageInfo, getSystemInfo, getSystemSetting, getTBSessionInfo, getTitleAndStatusbarHeight, getTitleColor, getUpdateManager, getUserInfo, getWifiList, hideAddToDesktopMenu, hideAllAddToDesktopMenu, hideBackButton, hideFavoriteMenu, hideLoading, hideNavigationBarLoading, hideOptionMenu, hideShareMenu, hideTabBar, hideTabBarRedDot, hideToast, httpRequest, isCollected, isLowPowerMode, isScreenReaderEnabled, isSpeechRecognizeAvailable, isSystemRoot, multiLevelSelect, navigateToCouponDetail, navigateToMiniProgram, notifyBLECharacteristicValueChange, off, offAccelerometerChange, offBLECharacteristicValueChange, offBLEConnectionStateChanged, offBeaconServiceChange, offBeaconUpdate, offBluetoothAdapterStateChange, offBluetoothDeviceFound, offCharacteristicDidSubscribe, offCharacteristicDidUnsubscribe, offCharacteristicRead, offCharacteristicWrite, offCompassChange, offDeviceMotionChange, offGyroscopeChange, offNetworkStatusChange, offSocketClose, offSocketError, offSocketMessage, offSocketOpen, offUserCaptureScreen, on, onAccelerometerChange, onBLECharacteristicValueChange, onBLEConnectionStateChanged, onBeaconServiceChange, onBeaconUpdate, onBluetoothAdapterStateChange, onBluetoothDeviceFound, onCharacteristicDidSubscribe, onCharacteristicDidUnsubscribe, onCharacteristicRead, onCharacteristicWrite, onCompassChange, onDeviceMotionChange, onGyroscopeChange, onNetworkStatusChange, onSocketClose, onSocketError, onSocketMessage, onSocketOpen, onUserCaptureScreen, openBLEPeripheral, openBluetoothAdapter, openCarService, openCardDetail, openCardList, openChatWindow, openDocument, openEmbeddedMiniProgram, openLocation, openMerchantCardList, openMerchantTicketList, openMerchantVoucherList, openOtherApplication, openSetting, openTaobao, openTicketDetail, openTicketList, openVoucherDetail, openVoucherList, optionsSelect, pauseBackgroundAudio, pauseVoice, paySignCenter, playBackgroundAudio, playVoice, popTo, popWindow, postNotification, preloadCanvasImage, previewImage, prompt, pushWindow, reGeoCode, readBLECharacteristicValue, regionPicker, registerSSID, removeBackgroundImage, removeNotifyListener, removePeripheralService, removeSavedFile, removeStorage, removeTabBarBadge, reportAnalytics, request, resumeVoice, rpc, rsa, saveFile, saveImage, saveImageToPhotosAlbum, saveVideoToPhotosAlbum, scan, seNFCServiceIsv, seekBackgroundAudio, sendHCEMessage, sendSMS, sendSocketMessage, setBackButton, setBackgroundColor, setBackgroundTextStyle, setCanPullDown, setClipboard, setGestureBack, setKeepScreenOn, setNavigationBar, setOptionMenu, setScreenBrightness, setScreenOrientation, setStorage, setTabBarBadge, setTabBarItem, setTabBarStyle, setTitle, setTransparentTitle, setWifiList, showActionSheet, showAuthGuide, showBackButton, showLoading, showNavigationBarLoading, showOptionMenu, showTabBar, showTabBarRedDot, showToast, snapshot, startApp, startBLEAdvertising, startBeaconDiscovery, startBluetoothDevicesDiscovery, startContinuousLocation, startHCE, startPullDownRefresh, startRecord, startSpeechRecognize, startWifi, startZMCreditRent, startZMVerify, stopBLEAdvertising, stopBackgroundAudio, stopBeaconDiscovery, stopBluetoothDevicesDiscovery, stopContinuousLocation, stopPullDownRefresh, stopRecord, stopSpeechRecognize, stopVoice, stopWifi, textRiskIdentification, textToSpeech, tradePay, unregisterSSID, updateCharacteristic, uploadFile, uploadImage, vibrate, vibrateLong, vibrateShort, watchShake, writeBLECharacteristicValue, zmCreditBorrow, zmFreeDeposit, zmRentTransition };
